export const preCachedContest = [
    {
        "id": 1849,
        "name": "Educational Codeforces Round 152 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "BEFORE",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1690468500,
        "relativeTimeSeconds": -988732
    },
    {
        "id": 1848,
        "name": "Codeforces Round 885 (Div. 2)",
        "type": "CF",
        "phase": "BEFORE",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1689518100,
        "relativeTimeSeconds": -38332
    },
    {
        "id": 1844,
        "name": "Codeforces Round  884 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1689086100,
        "relativeTimeSeconds": 393669
    },
    {
        "id": 1846,
        "name": "Codeforces Round 883 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1688740500,
        "relativeTimeSeconds": 739269
    },
    {
        "id": 1847,
        "name": "Codeforces Round 882 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1688654100,
        "relativeTimeSeconds": 825669
    },
    {
        "id": 1845,
        "name": "Educational Codeforces Round 151 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1688049300,
        "relativeTimeSeconds": 1430469
    },
    {
        "id": 1842,
        "name": "CodeTON Round 5 (Div. 1 + Div. 2, Rated, Prizes!)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1687615500,
        "relativeTimeSeconds": 1864269
    },
    {
        "id": 1843,
        "name": "Codeforces Round 881 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1687271700,
        "relativeTimeSeconds": 2208069
    },
    {
        "id": 1835,
        "name": "Codeforces Round 880 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1687098900,
        "relativeTimeSeconds": 2380869
    },
    {
        "id": 1836,
        "name": "Codeforces Round 880 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1687098900,
        "relativeTimeSeconds": 2380869
    },
    {
        "id": 1834,
        "name": "Codeforces Round 879 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1687075500,
        "relativeTimeSeconds": 2404269
    },
    {
        "id": 1841,
        "name": "Educational Codeforces Round 150 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1686580500,
        "relativeTimeSeconds": 2899269
    },
    {
        "id": 1840,
        "name": "Codeforces Round 878 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1686062100,
        "relativeTimeSeconds": 3417669
    },
    {
        "id": 1838,
        "name": "Codeforces Round 877 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1685889900,
        "relativeTimeSeconds": 3589869
    },
    {
        "id": 1839,
        "name": "Codeforces Round 876 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1685802900,
        "relativeTimeSeconds": 3676869
    },
    {
        "id": 1830,
        "name": "Codeforces Round 875 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1685284500,
        "relativeTimeSeconds": 4195269
    },
    {
        "id": 1831,
        "name": "Codeforces Round 875 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1685284500,
        "relativeTimeSeconds": 4195269
    },
    {
        "id": 1837,
        "name": "Educational Codeforces Round 149 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1685025300,
        "relativeTimeSeconds": 4454469
    },
    {
        "id": 1833,
        "name": "Codeforces Round 874 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1684506900,
        "relativeTimeSeconds": 4972869
    },
    {
        "id": 1827,
        "name": "Codeforces Round 873 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1684074900,
        "relativeTimeSeconds": 5404869
    },
    {
        "id": 1828,
        "name": "Codeforces Round 873 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1684074900,
        "relativeTimeSeconds": 5404869
    },
    {
        "id": 1832,
        "name": "Educational Codeforces Round 148 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1683902100,
        "relativeTimeSeconds": 5577669
    },
    {
        "id": 1824,
        "name": "Codeforces Round 872 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1683547500,
        "relativeTimeSeconds": 5932269
    },
    {
        "id": 1825,
        "name": "Codeforces Round 872 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1683547500,
        "relativeTimeSeconds": 5932269
    },
    {
        "id": 1829,
        "name": "Codeforces Round 871 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1683383700,
        "relativeTimeSeconds": 6096069
    },
    {
        "id": 1826,
        "name": "Codeforces Round 870 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1683297300,
        "relativeTimeSeconds": 6182469
    },
    {
        "id": 1817,
        "name": "Codeforces Round 869 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1682778900,
        "relativeTimeSeconds": 6700869
    },
    {
        "id": 1818,
        "name": "Codeforces Round 869 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1682778900,
        "relativeTimeSeconds": 6700869
    },
    {
        "id": 1823,
        "name": "Codeforces Round 868 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1682606100,
        "relativeTimeSeconds": 6873669
    },
    {
        "id": 1822,
        "name": "Codeforces Round 867 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1682346900,
        "relativeTimeSeconds": 7132869
    },
    {
        "id": 1821,
        "name": "Educational Codeforces Round 147 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1682001300,
        "relativeTimeSeconds": 7478469
    },
    {
        "id": 1819,
        "name": "Codeforces Round 866 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1681549500,
        "relativeTimeSeconds": 7930269
    },
    {
        "id": 1820,
        "name": "Codeforces Round 866 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1681549500,
        "relativeTimeSeconds": 7930269
    },
    {
        "id": 1813,
        "name": "ICPC 2023 Online Spring Challenge powered by Huawei",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1209600,
        "startTimeSeconds": 1681383600,
        "relativeTimeSeconds": 8096169
    },
    {
        "id": 1815,
        "name": "Codeforces Round 865 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1681051500,
        "relativeTimeSeconds": 8428269
    },
    {
        "id": 1816,
        "name": "Codeforces Round 865 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1681051500,
        "relativeTimeSeconds": 8428269
    },
    {
        "id": 1797,
        "name": "Codeforces Round 864 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1680962700,
        "relativeTimeSeconds": 8517069
    },
    {
        "id": 1814,
        "name": "Educational Codeforces Round 146 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1680791700,
        "relativeTimeSeconds": 8688069
    },
    {
        "id": 1811,
        "name": "Codeforces Round 863 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1680618900,
        "relativeTimeSeconds": 8860869
    },
    {
        "id": 1805,
        "name": "Codeforces Round 862 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1680446100,
        "relativeTimeSeconds": 9033669
    },
    {
        "id": 1812,
        "name": "April Fools Day Contest 2023",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1680359700,
        "relativeTimeSeconds": 9120069
    },
    {
        "id": 1810,
        "name": "CodeTON Round 4 (Div. 1 + Div. 2, Rated, Prizes!)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1680273300,
        "relativeTimeSeconds": 9206469
    },
    {
        "id": 1808,
        "name": "Codeforces Round 861 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1680080700,
        "relativeTimeSeconds": 9399069
    },
    {
        "id": 1798,
        "name": "Codeforces Round 860 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1679841300,
        "relativeTimeSeconds": 9638469
    },
    {
        "id": 1809,
        "name": "Educational Codeforces Round 145 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1679582100,
        "relativeTimeSeconds": 9897669
    },
    {
        "id": 1807,
        "name": "Codeforces Round 859 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1679237700,
        "relativeTimeSeconds": 10242069
    },
    {
        "id": 1806,
        "name": "Codeforces Round 858 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1679141100,
        "relativeTimeSeconds": 10338669
    },
    {
        "id": 1804,
        "name": "Nebius Welcome Round (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1678631700,
        "relativeTimeSeconds": 10848069
    },
    {
        "id": 1801,
        "name": "Codeforces Round 857 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1678354500,
        "relativeTimeSeconds": 11125269
    },
    {
        "id": 1802,
        "name": "Codeforces Round 857 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1678354500,
        "relativeTimeSeconds": 11125269
    },
    {
        "id": 1794,
        "name": "Codeforces Round 856 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1677951300,
        "relativeTimeSeconds": 11528469
    },
    {
        "id": 1800,
        "name": "Codeforces Round 855 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1677767700,
        "relativeTimeSeconds": 11712069
    },
    {
        "id": 1796,
        "name": "Educational Codeforces Round 144 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1677594900,
        "relativeTimeSeconds": 11884869
    },
    {
        "id": 1799,
        "name": "Codeforces Round 854 by cybercats (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1677508500,
        "relativeTimeSeconds": 11971269
    },
    {
        "id": 1789,
        "name": "Codeforces Round 853 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1677334800,
        "relativeTimeSeconds": 12144969
    },
    {
        "id": 1776,
        "name": "SWERC 2022-2023 - Online Mirror (Unrated, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1676804700,
        "relativeTimeSeconds": 12675069
    },
    {
        "id": 1795,
        "name": "Educational Codeforces Round 143 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1676558100,
        "relativeTimeSeconds": 12921669
    },
    {
        "id": 1793,
        "name": "Codeforces Round 852 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1676190900,
        "relativeTimeSeconds": 13288869
    },
    {
        "id": 1788,
        "name": "Codeforces Round 851 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1675953300,
        "relativeTimeSeconds": 13526469
    },
    {
        "id": 1784,
        "name": "VK Cup 2022 - Финальный раунд (Engine)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1675598700,
        "relativeTimeSeconds": 13881070
    },
    {
        "id": 1785,
        "name": "Codeforces Round 850 (Div. 1, based on VK Cup 2022 - Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1675598700,
        "relativeTimeSeconds": 13881069
    },
    {
        "id": 1786,
        "name": "Codeforces Round 850 (Div. 2, based on VK Cup 2022 - Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1675598700,
        "relativeTimeSeconds": 13881069
    },
    {
        "id": 1791,
        "name": "Codeforces Round 849 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8700,
        "startTimeSeconds": 1675434900,
        "relativeTimeSeconds": 14044869
    },
    {
        "id": 1778,
        "name": "Codeforces Round 848 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1675262100,
        "relativeTimeSeconds": 14217669
    },
    {
        "id": 1787,
        "name": "TypeDB Forces 2023 (Div. 1 + Div. 2, Rated, Prizes!)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1675002900,
        "relativeTimeSeconds": 14476869
    },
    {
        "id": 1790,
        "name": "Codeforces Round 847 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1674830100,
        "relativeTimeSeconds": 14649669
    },
    {
        "id": 1780,
        "name": "Codeforces Round 846 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1674657300,
        "relativeTimeSeconds": 14822469
    },
    {
        "id": 1792,
        "name": "Educational Codeforces Round 142 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1674570900,
        "relativeTimeSeconds": 14908869
    },
    {
        "id": 1777,
        "name": "Codeforces Round 845 (Div. 2) and ByteRace 2023",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1674311700,
        "relativeTimeSeconds": 15168069
    },
    {
        "id": 1781,
        "name": "VK Cup 2022 - Отборочный раунд (Engine)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1673784300,
        "relativeTimeSeconds": 15695470
    },
    {
        "id": 1782,
        "name": "Codeforces Round 844 (Div. 1 + Div. 2, based on VK Cup 2022 - Elimination Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1673784300,
        "relativeTimeSeconds": 15695469
    },
    {
        "id": 1775,
        "name": "Codeforces Round 843 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1673349300,
        "relativeTimeSeconds": 16130469
    },
    {
        "id": 1783,
        "name": "Educational Codeforces Round 141 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1673188500,
        "relativeTimeSeconds": 16291269
    },
    {
        "id": 1768,
        "name": "Codeforces Round 842 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1672929300,
        "relativeTimeSeconds": 16550469
    },
    {
        "id": 1779,
        "name": "Hello 2023",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1672756500,
        "relativeTimeSeconds": 16723269
    },
    {
        "id": 1770,
        "name": "Good Bye 2022: 2023 is NEAR",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1672410900,
        "relativeTimeSeconds": 17068869
    },
    {
        "id": 1731,
        "name": "Codeforces Round 841 (Div. 2) and Divide by Zero 2022",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1672151700,
        "relativeTimeSeconds": 17328069
    },
    {
        "id": 1763,
        "name": "Codeforces Round 840 (Div. 2) and Enigma 2022 - Cybros LNMIIT",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1671460500,
        "relativeTimeSeconds": 18019269
    },
    {
        "id": 1772,
        "name": "Codeforces Round 839 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1671374100,
        "relativeTimeSeconds": 18105669
    },
    {
        "id": 1774,
        "name": "Polynomial Round 2022 (Div. 1 + Div. 2, Rated, Prizes!)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1671287700,
        "relativeTimeSeconds": 18192069
    },
    {
        "id": 1767,
        "name": "Educational Codeforces Round 140 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1671201300,
        "relativeTimeSeconds": 18278469
    },
    {
        "id": 1762,
        "name": "Codeforces Round 838 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1671114900,
        "relativeTimeSeconds": 18364869
    },
    {
        "id": 1766,
        "name": "Educational Codeforces Round 139 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1670855700,
        "relativeTimeSeconds": 18624069
    },
    {
        "id": 1771,
        "name": "Codeforces Round 837 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1670772900,
        "relativeTimeSeconds": 18706869
    },
    {
        "id": 1773,
        "name": "2022-2023 ICPC, NERC, Northern Eurasia Onsite (Unrated, Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1670400300,
        "relativeTimeSeconds": 19079469
    },
    {
        "id": 1769,
        "name": "VK Cup 2022 - Квалификация (Engine)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1339200,
        "startTimeSeconds": 1670058000,
        "relativeTimeSeconds": 19421770
    },
    {
        "id": 1765,
        "name": "2022-2023 ICPC, NERC, Southern and Volga Russian Regional Contest (Online Mirror, ICPC Rules, Preferably Teams)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1669545300,
        "relativeTimeSeconds": 19934469
    },
    {
        "id": 1764,
        "name": "Codeforces Global Round 24",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1669471500,
        "relativeTimeSeconds": 20008269
    },
    {
        "id": 1758,
        "name": "Codeforces Round 836 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1669390500,
        "relativeTimeSeconds": 20089269
    },
    {
        "id": 1760,
        "name": "Codeforces Round 835 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8700,
        "startTimeSeconds": 1669041300,
        "relativeTimeSeconds": 20438469
    },
    {
        "id": 1761,
        "name": "Pinely Round 1 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1668954900,
        "relativeTimeSeconds": 20524869
    },
    {
        "id": 1759,
        "name": "Codeforces Round  834 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1668782100,
        "relativeTimeSeconds": 20697669
    },
    {
        "id": 1751,
        "name": "45th ICPC World Finals Challenge powered by Huawei - Problem 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1209540,
        "startTimeSeconds": 1668643200,
        "relativeTimeSeconds": 20836569
    },
    {
        "id": 1752,
        "name": "45th ICPC World Finals Challenge powered by Huawei - Problem 1",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1209540,
        "startTimeSeconds": 1668643200,
        "relativeTimeSeconds": 20836569
    },
    {
        "id": 1748,
        "name": "Codeforces Round 833 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1668263700,
        "relativeTimeSeconds": 21216069
    },
    {
        "id": 1755,
        "name": "Ecnerwala vs Errichto Kotlin Match",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 2400,
        "startTimeSeconds": 1667794620,
        "relativeTimeSeconds": 21685149
    },
    {
        "id": 1750,
        "name": "CodeTON Round 3 (Div. 1 + Div. 2, Rated, Prizes!)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1667745300,
        "relativeTimeSeconds": 21734469
    },
    {
        "id": 1747,
        "name": "Codeforces Round 832 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1667572500,
        "relativeTimeSeconds": 21907269
    },
    {
        "id": 1740,
        "name": "Codeforces Round 831 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9900,
        "startTimeSeconds": 1667034600,
        "relativeTimeSeconds": 22445169
    },
    {
        "id": 1732,
        "name": "Codeforces Round 830 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1666519500,
        "relativeTimeSeconds": 22960269
    },
    {
        "id": 1753,
        "name": "Codeforces Round 829 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1666511400,
        "relativeTimeSeconds": 22968369
    },
    {
        "id": 1754,
        "name": "Codeforces Round 829 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1666511400,
        "relativeTimeSeconds": 22968369
    },
    {
        "id": 1749,
        "name": "Educational Codeforces Round 138 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1666276500,
        "relativeTimeSeconds": 23203269
    },
    {
        "id": 1743,
        "name": "Educational Codeforces Round 137 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1666017300,
        "relativeTimeSeconds": 23462469
    },
    {
        "id": 1744,
        "name": "Codeforces Round  828 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1665930900,
        "relativeTimeSeconds": 23548869
    },
    {
        "id": 1746,
        "name": "Codeforces Global Round 23",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1665844500,
        "relativeTimeSeconds": 23635269
    },
    {
        "id": 1742,
        "name": "Codeforces Round 827 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8700,
        "startTimeSeconds": 1665671700,
        "relativeTimeSeconds": 23808069
    },
    {
        "id": 1741,
        "name": "Codeforces Round 826 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1665498900,
        "relativeTimeSeconds": 23980869
    },
    {
        "id": 1736,
        "name": "Codeforces Round 825 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1665412500,
        "relativeTimeSeconds": 24067269
    },
    {
        "id": 1737,
        "name": "Dytechlab Cup 2022",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1665153300,
        "relativeTimeSeconds": 24326469
    },
    {
        "id": 1735,
        "name": "Codeforces Round 824 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1664721300,
        "relativeTimeSeconds": 24758469
    },
    {
        "id": 1738,
        "name": "Codeforces Global Round 22",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1664548500,
        "relativeTimeSeconds": 24931269
    },
    {
        "id": 1739,
        "name": "Educational Codeforces Round 136 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1664462100,
        "relativeTimeSeconds": 25017669
    },
    {
        "id": 1730,
        "name": "Codeforces Round 823 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1664116500,
        "relativeTimeSeconds": 25363269
    },
    {
        "id": 1734,
        "name": "Codeforces Round 822 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1663934700,
        "relativeTimeSeconds": 25545069
    },
    {
        "id": 1733,
        "name": "Codeforces Round 821 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1663598100,
        "relativeTimeSeconds": 25881669
    },
    {
        "id": 1723,
        "name": "ICPC 2022 Online Challenge powered by HUAWEI - Problem 1",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1296000,
        "startTimeSeconds": 1663200000,
        "relativeTimeSeconds": 26279769
    },
    {
        "id": 1724,
        "name": "ICPC 2022 Online Challenge powered by HUAWEI - Problem 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1296000,
        "startTimeSeconds": 1663200000,
        "relativeTimeSeconds": 26279769
    },
    {
        "id": 1729,
        "name": "Codeforces Round 820 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1662993300,
        "relativeTimeSeconds": 26486469
    },
    {
        "id": 1728,
        "name": "Educational Codeforces Round 135 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1662647700,
        "relativeTimeSeconds": 26832069
    },
    {
        "id": 1726,
        "name": "Codeforces Round 819 (Div. 1 + Div. 2) and Grimoire of Code Annual Contest 2022",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1662474900,
        "relativeTimeSeconds": 27004869
    },
    {
        "id": 1725,
        "name": "COMPFEST 14 - Preliminary Online Mirror (Unrated, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1662298500,
        "relativeTimeSeconds": 27181269
    },
    {
        "id": 1717,
        "name": "Codeforces Round 818 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1662129300,
        "relativeTimeSeconds": 27350469
    },
    {
        "id": 1722,
        "name": "Codeforces Round 817 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1661871000,
        "relativeTimeSeconds": 27608769
    },
    {
        "id": 1721,
        "name": "Educational Codeforces Round 134 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1661610900,
        "relativeTimeSeconds": 27868869
    },
    {
        "id": 1715,
        "name": "Codeforces Round 816 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1661006100,
        "relativeTimeSeconds": 28473669
    },
    {
        "id": 1720,
        "name": "Codeforces Round 815 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1660829700,
        "relativeTimeSeconds": 28650069
    },
    {
        "id": 1718,
        "name": "Codeforces Round 814 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1660660500,
        "relativeTimeSeconds": 28819269
    },
    {
        "id": 1719,
        "name": "Codeforces Round 814 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1660660500,
        "relativeTimeSeconds": 28819269
    },
    {
        "id": 1712,
        "name": "Codeforces Round 813 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1660401300,
        "relativeTimeSeconds": 29078469
    },
    {
        "id": 1713,
        "name": "Codeforces Round 812 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1659796500,
        "relativeTimeSeconds": 29683269
    },
    {
        "id": 1716,
        "name": "Educational Codeforces Round 133 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1659623700,
        "relativeTimeSeconds": 29856069
    },
    {
        "id": 1714,
        "name": "Codeforces Round 811 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1659364500,
        "relativeTimeSeconds": 30115269
    },
    {
        "id": 1704,
        "name": "CodeTON Round 2 (Div. 1 + Div. 2, Rated, Prizes!)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1659276300,
        "relativeTimeSeconds": 30203469
    },
    {
        "id": 1710,
        "name": "Codeforces Round 810 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1658673300,
        "relativeTimeSeconds": 30806469
    },
    {
        "id": 1711,
        "name": "Codeforces Round 810 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1658673300,
        "relativeTimeSeconds": 30806469
    },
    {
        "id": 1709,
        "name": "Educational Codeforces Round 132 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1658414100,
        "relativeTimeSeconds": 31065669
    },
    {
        "id": 1706,
        "name": "Codeforces Round 809 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1658154900,
        "relativeTimeSeconds": 31324869
    },
    {
        "id": 1707,
        "name": "Codeforces Round 808 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1657982100,
        "relativeTimeSeconds": 31497669
    },
    {
        "id": 1708,
        "name": "Codeforces Round 808 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1657982100,
        "relativeTimeSeconds": 31497669
    },
    {
        "id": 1705,
        "name": "Codeforces Round 807 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1657892100,
        "relativeTimeSeconds": 31587669
    },
    {
        "id": 1703,
        "name": "Codeforces Round 806 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1657636500,
        "relativeTimeSeconds": 31843269
    },
    {
        "id": 1702,
        "name": "Codeforces Round 805 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1657463700,
        "relativeTimeSeconds": 32016069
    },
    {
        "id": 1701,
        "name": "Educational Codeforces Round 131 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1657290900,
        "relativeTimeSeconds": 32188869
    },
    {
        "id": 1699,
        "name": "Codeforces Round 804 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1656945300,
        "relativeTimeSeconds": 32534469
    },
    {
        "id": 1698,
        "name": "Codeforces Round 803 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1656426900,
        "relativeTimeSeconds": 33052869
    },
    {
        "id": 1696,
        "name": "Codeforces Global Round 21",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1656167700,
        "relativeTimeSeconds": 33312069
    },
    {
        "id": 1700,
        "name": "Codeforces Round 802 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1655629500,
        "relativeTimeSeconds": 33850269
    },
    {
        "id": 1695,
        "name": "Codeforces Round 801 (Div. 2) and EPIC Institute of Technology Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1655562900,
        "relativeTimeSeconds": 33916869
    },
    {
        "id": 1693,
        "name": "Codeforces Round 800 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1655390100,
        "relativeTimeSeconds": 34089669
    },
    {
        "id": 1694,
        "name": "Codeforces Round 800 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1655390100,
        "relativeTimeSeconds": 34089669
    },
    {
        "id": 1692,
        "name": "Codeforces Round 799 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1655217300,
        "relativeTimeSeconds": 34262469
    },
    {
        "id": 1697,
        "name": "Educational Codeforces Round 130 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1655044500,
        "relativeTimeSeconds": 34435269
    },
    {
        "id": 1689,
        "name": "Codeforces Round 798 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1654878900,
        "relativeTimeSeconds": 34600869
    },
    {
        "id": 1690,
        "name": "Codeforces Round 797 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1654612500,
        "relativeTimeSeconds": 34867269
    },
    {
        "id": 1687,
        "name": "Codeforces Round 796 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1654266900,
        "relativeTimeSeconds": 35212869
    },
    {
        "id": 1688,
        "name": "Codeforces Round 796 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1654266900,
        "relativeTimeSeconds": 35212869
    },
    {
        "id": 1691,
        "name": "CodeCraft-22 and Codeforces Round 795 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1654007700,
        "relativeTimeSeconds": 35472069
    },
    {
        "id": 1685,
        "name": "Codeforces Round 794 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1653500100,
        "relativeTimeSeconds": 35979669
    },
    {
        "id": 1686,
        "name": "Codeforces Round 794 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1653500100,
        "relativeTimeSeconds": 35979669
    },
    {
        "id": 1681,
        "name": "Educational Codeforces Round 129 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1653316500,
        "relativeTimeSeconds": 36163269
    },
    {
        "id": 1682,
        "name": "Codeforces Round 793 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1653230100,
        "relativeTimeSeconds": 36249669
    },
    {
        "id": 1684,
        "name": "Codeforces Round 792 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1652970900,
        "relativeTimeSeconds": 36508869
    },
    {
        "id": 1679,
        "name": "Codeforces Round 791 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1652520900,
        "relativeTimeSeconds": 36958869
    },
    {
        "id": 1680,
        "name": "Educational Codeforces Round 128 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1652452500,
        "relativeTimeSeconds": 37027269
    },
    {
        "id": 1676,
        "name": "Codeforces Round 790 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1652193900,
        "relativeTimeSeconds": 37285869
    },
    {
        "id": 1677,
        "name": "Codeforces Round 789 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1652020500,
        "relativeTimeSeconds": 37459269
    },
    {
        "id": 1678,
        "name": "Codeforces Round 789 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1652020500,
        "relativeTimeSeconds": 37459269
    },
    {
        "id": 1670,
        "name": "Codeforces Round 788 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1651847700,
        "relativeTimeSeconds": 37632069
    },
    {
        "id": 1675,
        "name": "Codeforces Round 787 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1651761300,
        "relativeTimeSeconds": 37718469
    },
    {
        "id": 1674,
        "name": "Codeforces Round 786 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1651502100,
        "relativeTimeSeconds": 37977669
    },
    {
        "id": 1673,
        "name": "Codeforces Round 785 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1651329300,
        "relativeTimeSeconds": 38150469
    },
    {
        "id": 1662,
        "name": "SWERC 2021-2022 - Online Mirror (Unrated, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1650798300,
        "relativeTimeSeconds": 38681469
    },
    {
        "id": 1672,
        "name": "Codeforces Global Round 20",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1650722700,
        "relativeTimeSeconds": 38757069
    },
    {
        "id": 1671,
        "name": "Educational Codeforces Round 127 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1650638100,
        "relativeTimeSeconds": 38841669
    },
    {
        "id": 1669,
        "name": "Codeforces Round 784 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1650551700,
        "relativeTimeSeconds": 38928069
    },
    {
        "id": 1667,
        "name": "Codeforces Round 783 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1650378900,
        "relativeTimeSeconds": 39100869
    },
    {
        "id": 1668,
        "name": "Codeforces Round 783 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1650378900,
        "relativeTimeSeconds": 39100869
    },
    {
        "id": 1659,
        "name": "Codeforces Round 782 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1650206100,
        "relativeTimeSeconds": 39273669
    },
    {
        "id": 1666,
        "name": "2021-2022 ICPC, NERC, Northern Eurasia Onsite (Unrated, Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1649837100,
        "relativeTimeSeconds": 39642669
    },
    {
        "id": 1661,
        "name": "Educational Codeforces Round 126 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1649514900,
        "relativeTimeSeconds": 39964869
    },
    {
        "id": 1665,
        "name": "Codeforces Round 781 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1649428500,
        "relativeTimeSeconds": 40051269
    },
    {
        "id": 1663,
        "name": "April Fools Day Contest 2022",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1648823700,
        "relativeTimeSeconds": 40656069
    },
    {
        "id": 1660,
        "name": "Codeforces Round 780 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1648737300,
        "relativeTimeSeconds": 40742469
    },
    {
        "id": 1658,
        "name": "Codeforces Round 779 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1648391700,
        "relativeTimeSeconds": 41088069
    },
    {
        "id": 1656,
        "name": "CodeTON Round 1 (Div. 1 + Div. 2, Rated, Prizes!)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1648132500,
        "relativeTimeSeconds": 41347269
    },
    {
        "id": 1657,
        "name": "Educational Codeforces Round 125 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1647960300,
        "relativeTimeSeconds": 41519469
    },
    {
        "id": 1654,
        "name": "Codeforces Round 778 (Div. 1 + Div. 2, based on Technocup 2022 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1647776100,
        "relativeTimeSeconds": 41703669
    },
    {
        "id": 1652,
        "name": "Технокубок 2022 - Финал",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1647764100,
        "relativeTimeSeconds": 41715669
    },
    {
        "id": 1647,
        "name": "Codeforces Round 777 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1647009300,
        "relativeTimeSeconds": 42470469
    },
    {
        "id": 1651,
        "name": "Educational Codeforces Round 124 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1646922900,
        "relativeTimeSeconds": 42556869
    },
    {
        "id": 1650,
        "name": "Codeforces Round 776 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1646750100,
        "relativeTimeSeconds": 42729669
    },
    {
        "id": 1648,
        "name": "Codeforces Round 775 (Div. 1, based on Moscow Open Olympiad in Informatics)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1646560500,
        "relativeTimeSeconds": 42919269
    },
    {
        "id": 1649,
        "name": "Codeforces Round 775 (Div. 2, based on Moscow Open Olympiad in Informatics)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1646560500,
        "relativeTimeSeconds": 42919269
    },
    {
        "id": 1646,
        "name": "Codeforces Round 774 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1646408100,
        "relativeTimeSeconds": 43071669
    },
    {
        "id": 1641,
        "name": "Codeforces Round 773 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1645611000,
        "relativeTimeSeconds": 43868769
    },
    {
        "id": 1642,
        "name": "Codeforces Round 773 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1645611000,
        "relativeTimeSeconds": 43868769
    },
    {
        "id": 1644,
        "name": "Educational Codeforces Round 123 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1645540500,
        "relativeTimeSeconds": 43939269
    },
    {
        "id": 1645,
        "name": "Kotlin Heroes: Practice 9",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1645536900,
        "relativeTimeSeconds": 43942869
    },
    {
        "id": 1635,
        "name": "Codeforces Round 772 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1645367700,
        "relativeTimeSeconds": 44112069
    },
    {
        "id": 1638,
        "name": "Codeforces Round 771 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1644849300,
        "relativeTimeSeconds": 44630469
    },
    {
        "id": 1637,
        "name": "Codeforces Global Round 19",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1644676500,
        "relativeTimeSeconds": 44803269
    },
    {
        "id": 1634,
        "name": "Codeforces Round 770 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1644158100,
        "relativeTimeSeconds": 45321669
    },
    {
        "id": 1639,
        "name": "Pinely Treasure Hunt Contest",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 12600,
        "startTimeSeconds": 1644055200,
        "relativeTimeSeconds": 45424569
    },
    {
        "id": 1633,
        "name": "Educational Codeforces Round 122 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1643639700,
        "relativeTimeSeconds": 45840069
    },
    {
        "id": 1632,
        "name": "Codeforces Round 769 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1643553300,
        "relativeTimeSeconds": 45926469
    },
    {
        "id": 1630,
        "name": "Codeforces Round 768 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1643294100,
        "relativeTimeSeconds": 46185669
    },
    {
        "id": 1631,
        "name": "Codeforces Round 768 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1643294100,
        "relativeTimeSeconds": 46185669
    },
    {
        "id": 1628,
        "name": "Codeforces Round 767 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1642862100,
        "relativeTimeSeconds": 46617669
    },
    {
        "id": 1629,
        "name": "Codeforces Round 767 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1642862100,
        "relativeTimeSeconds": 46617669
    },
    {
        "id": 1626,
        "name": "Educational Codeforces Round 121 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1642343700,
        "relativeTimeSeconds": 47136069
    },
    {
        "id": 1627,
        "name": "Codeforces Round 766 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1642257300,
        "relativeTimeSeconds": 47222469
    },
    {
        "id": 1625,
        "name": "Codeforces Round 765 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1641989100,
        "relativeTimeSeconds": 47490669
    },
    {
        "id": 1624,
        "name": "Codeforces Round 764 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1641825300,
        "relativeTimeSeconds": 47654469
    },
    {
        "id": 1621,
        "name": "Hello 2022",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1641220500,
        "relativeTimeSeconds": 48259269
    },
    {
        "id": 1616,
        "name": "Good Bye 2021: 2022 is NEAR",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1640792100,
        "relativeTimeSeconds": 48687669
    },
    {
        "id": 1623,
        "name": "Codeforces Round 763 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1640698500,
        "relativeTimeSeconds": 48781269
    },
    {
        "id": 1622,
        "name": "Educational Codeforces Round 120 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1640615700,
        "relativeTimeSeconds": 48864069
    },
    {
        "id": 1615,
        "name": "Codeforces Global Round 18",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1640356500,
        "relativeTimeSeconds": 49123269
    },
    {
        "id": 1619,
        "name": "Codeforces Round 762 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1640010900,
        "relativeTimeSeconds": 49468869
    },
    {
        "id": 1620,
        "name": "Educational Codeforces Round 119 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1639841700,
        "relativeTimeSeconds": 49638069
    },
    {
        "id": 1617,
        "name": "Codeforces Round 761 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1639661700,
        "relativeTimeSeconds": 49818069
    },
    {
        "id": 1618,
        "name": "Codeforces Round 760 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1639492500,
        "relativeTimeSeconds": 49987269
    },
    {
        "id": 1585,
        "name": "Technocup 2022 - Elimination Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1639322100,
        "relativeTimeSeconds": 50157669
    },
    {
        "id": 1591,
        "name": "Codeforces Round 759 (Div. 2, based on Technocup 2022 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1639322100,
        "relativeTimeSeconds": 50157669
    },
    {
        "id": 1608,
        "name": "Codeforces Round 758 (Div.1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1639217100,
        "relativeTimeSeconds": 50262669
    },
    {
        "id": 1597,
        "name": "Технокубок 2022 - Ознакомительный Раунд 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1639145100,
        "relativeTimeSeconds": 50334670
    },
    {
        "id": 1613,
        "name": "Educational Codeforces Round 118 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1638369300,
        "relativeTimeSeconds": 51110469
    },
    {
        "id": 1609,
        "name": "Deltix Round, Autumn 2021 (open for everyone, rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1638110100,
        "relativeTimeSeconds": 51369669
    },
    {
        "id": 1614,
        "name": "Codeforces Round 757 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1637925300,
        "relativeTimeSeconds": 51554469
    },
    {
        "id": 1611,
        "name": "Codeforces Round 756 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1637850900,
        "relativeTimeSeconds": 51628869
    },
    {
        "id": 1610,
        "name": "Codeforces Global Round 17",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1637678100,
        "relativeTimeSeconds": 51801669
    },
    {
        "id": 1612,
        "name": "Educational Codeforces Round 117 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1637573700,
        "relativeTimeSeconds": 51906069
    },
    {
        "id": 1584,
        "name": "Technocup 2022 - Elimination Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1636869900,
        "relativeTimeSeconds": 52609869
    },
    {
        "id": 1588,
        "name": "Codeforces Round 755 (Div. 1, based on Technocup 2022 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1636869900,
        "relativeTimeSeconds": 52609869
    },
    {
        "id": 1589,
        "name": "Codeforces Round 755 (Div. 2, based on Technocup 2022 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1636869900,
        "relativeTimeSeconds": 52609869
    },
    {
        "id": 1605,
        "name": "Codeforces Round 754 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1636727700,
        "relativeTimeSeconds": 52752069
    },
    {
        "id": 1596,
        "name": "Технокубок 2022 - Ознакомительный Раунд 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1636693500,
        "relativeTimeSeconds": 52786270
    },
    {
        "id": 1607,
        "name": "Codeforces Round 753 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1635863700,
        "relativeTimeSeconds": 53616069
    },
    {
        "id": 1603,
        "name": "Codeforces Round 752 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1635604500,
        "relativeTimeSeconds": 53875269
    },
    {
        "id": 1604,
        "name": "Codeforces Round 752 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1635604500,
        "relativeTimeSeconds": 53875269
    },
    {
        "id": 1606,
        "name": "Educational Codeforces Round 116 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1635518100,
        "relativeTimeSeconds": 53961669
    },
    {
        "id": 1601,
        "name": "Codeforces Round 751 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1635143700,
        "relativeTimeSeconds": 54336069
    },
    {
        "id": 1602,
        "name": "Codeforces Round 751 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1635143700,
        "relativeTimeSeconds": 54336069
    },
    {
        "id": 1582,
        "name": "Codeforces Round 750 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1635069900,
        "relativeTimeSeconds": 54409869
    },
    {
        "id": 1583,
        "name": "Technocup 2022 - Elimination Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1634468700,
        "relativeTimeSeconds": 55011069
    },
    {
        "id": 1586,
        "name": "Codeforces Round 749 (Div. 1 + Div. 2, based on Technocup 2022 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1634468700,
        "relativeTimeSeconds": 55011069
    },
    {
        "id": 1595,
        "name": "Технокубок 2022 - Ознакомительный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1634292300,
        "relativeTimeSeconds": 55187470
    },
    {
        "id": 1593,
        "name": "Codeforces Round 748 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1634135700,
        "relativeTimeSeconds": 55344069
    },
    {
        "id": 1598,
        "name": "Educational Codeforces Round 115 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1633856700,
        "relativeTimeSeconds": 55623069
    },
    {
        "id": 1599,
        "name": "Bubble Cup 14 - Finals Online Mirror (Unrated, ICPC Rules, Teams Preferred, Div. 1)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 14400,
        "startTimeSeconds": 1633770300,
        "relativeTimeSeconds": 55709469
    },
    {
        "id": 1600,
        "name": "Bubble Cup 14 - Finals Online Mirror (Unrated, ICPC Rules, Teams Preferred, Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 14400,
        "startTimeSeconds": 1633770300,
        "relativeTimeSeconds": 55709469
    },
    {
        "id": 1576,
        "name": "2021 ICPC Communication Routing Challenge: Marathon",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 432000,
        "startTimeSeconds": 1633737600,
        "relativeTimeSeconds": 55742169
    },
    {
        "id": 1594,
        "name": "Codeforces Round 747 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1633705500,
        "relativeTimeSeconds": 55774269
    },
    {
        "id": 1571,
        "name": "Kotlin Heroes: Episode 8",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9900,
        "startTimeSeconds": 1633617300,
        "relativeTimeSeconds": 55862469
    },
    {
        "id": 1592,
        "name": "Codeforces Round 746 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1633271700,
        "relativeTimeSeconds": 56208069
    },
    {
        "id": 1575,
        "name": "COMPFEST 13 - Finals Online Mirror (Unrated, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1633181700,
        "relativeTimeSeconds": 56298069
    },
    {
        "id": 1570,
        "name": "Kotlin Heroes: Practice 8",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 518400,
        "startTimeSeconds": 1633095300,
        "relativeTimeSeconds": 56384469
    },
    {
        "id": 1578,
        "name": "ICPC WF Moscow Invitational Contest - Online Mirror (Unrated, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1633093500,
        "relativeTimeSeconds": 56386269
    },
    {
        "id": 1580,
        "name": "Codeforces Round 745 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1632996900,
        "relativeTimeSeconds": 56482869
    },
    {
        "id": 1581,
        "name": "Codeforces Round 745 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1632996900,
        "relativeTimeSeconds": 56482869
    },
    {
        "id": 1579,
        "name": "Codeforces Round 744 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1632839700,
        "relativeTimeSeconds": 56640069
    },
    {
        "id": 1574,
        "name": "Educational Codeforces Round 114 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1632148500,
        "relativeTimeSeconds": 57331269
    },
    {
        "id": 1572,
        "name": "Codeforces Round 743 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1631975700,
        "relativeTimeSeconds": 57504069
    },
    {
        "id": 1573,
        "name": "Codeforces Round 743 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1631975700,
        "relativeTimeSeconds": 57504069
    },
    {
        "id": 1566,
        "name": "Codeforces Global Round 16",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1631457300,
        "relativeTimeSeconds": 58022469
    },
    {
        "id": 1569,
        "name": "Educational Codeforces Round 113 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1631111700,
        "relativeTimeSeconds": 58368069
    },
    {
        "id": 1567,
        "name": "Codeforces Round 742 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1630852500,
        "relativeTimeSeconds": 58627269
    },
    {
        "id": 1556,
        "name": "Deltix Round, Summer 2021 (open for everyone, rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1630247700,
        "relativeTimeSeconds": 59232069
    },
    {
        "id": 1562,
        "name": "Codeforces Round 741 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1629988500,
        "relativeTimeSeconds": 59491269
    },
    {
        "id": 1558,
        "name": "Codeforces Round 740 (Div. 1, based on VK Cup 2021 - Final (Engine))",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1629815700,
        "relativeTimeSeconds": 59664069
    },
    {
        "id": 1561,
        "name": "Codeforces Round 740 (Div. 2, based on VK Cup 2021 - Final (Engine))",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1629815700,
        "relativeTimeSeconds": 59664069
    },
    {
        "id": 1563,
        "name": "VK Cup 2021 - Final (Engine)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1629633900,
        "relativeTimeSeconds": 59845869
    },
    {
        "id": 1560,
        "name": "Codeforces Round 739 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1629297300,
        "relativeTimeSeconds": 60182469
    },
    {
        "id": 1559,
        "name": "Codeforces Round 738 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1629038100,
        "relativeTimeSeconds": 60441669
    },
    {
        "id": 1557,
        "name": "Codeforces Round 737 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1628519700,
        "relativeTimeSeconds": 60960069
    },
    {
        "id": 1548,
        "name": "Codeforces Round 736 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8700,
        "startTimeSeconds": 1627828500,
        "relativeTimeSeconds": 61651269
    },
    {
        "id": 1549,
        "name": "Codeforces Round 736 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8700,
        "startTimeSeconds": 1627828500,
        "relativeTimeSeconds": 61651269
    },
    {
        "id": 1555,
        "name": "Educational Codeforces Round 112 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1627655700,
        "relativeTimeSeconds": 61824069
    },
    {
        "id": 1554,
        "name": "Codeforces Round 735 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1627569300,
        "relativeTimeSeconds": 61910469
    },
    {
        "id": 1552,
        "name": "Codeforces Global Round 15",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9900,
        "startTimeSeconds": 1627223700,
        "relativeTimeSeconds": 62256069
    },
    {
        "id": 1551,
        "name": "Codeforces Round 734 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1627050900,
        "relativeTimeSeconds": 62428869
    },
    {
        "id": 1553,
        "name": "Harbour.Space Scholarship Contest 2021-2022 (open for everyone, rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1626964500,
        "relativeTimeSeconds": 62515269
    },
    {
        "id": 1544,
        "name": "VK Cup 2021 - Elimination (Engine)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1626532500,
        "relativeTimeSeconds": 62947269
    },
    {
        "id": 1530,
        "name": "Codeforces Round 733 (Div. 1 + Div. 2, based on VK Cup 2021 - Elimination (Engine))",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1626532500,
        "relativeTimeSeconds": 62947269
    },
    {
        "id": 1550,
        "name": "Educational Codeforces Round 111 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1626273300,
        "relativeTimeSeconds": 63206469
    },
    {
        "id": 1545,
        "name": "Codeforces Round 732 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1626012300,
        "relativeTimeSeconds": 63467469
    },
    {
        "id": 1546,
        "name": "Codeforces Round 732 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1626012300,
        "relativeTimeSeconds": 63467469
    },
    {
        "id": 1547,
        "name": "Codeforces Round 731 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1625927700,
        "relativeTimeSeconds": 63552069
    },
    {
        "id": 1543,
        "name": "Codeforces Round 730 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1625668500,
        "relativeTimeSeconds": 63811269
    },
    {
        "id": 1542,
        "name": "Codeforces Round 729 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1625317500,
        "relativeTimeSeconds": 64162269
    },
    {
        "id": 1533,
        "name": "Kotlin Heroes: Episode 7",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1624977300,
        "relativeTimeSeconds": 64502469
    },
    {
        "id": 1540,
        "name": "Codeforces Round 728 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1624635300,
        "relativeTimeSeconds": 64844469
    },
    {
        "id": 1541,
        "name": "Codeforces Round 728 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1624635300,
        "relativeTimeSeconds": 64844469
    },
    {
        "id": 1532,
        "name": "Kotlin Heroes: Practice 7",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1624368900,
        "relativeTimeSeconds": 65110869
    },
    {
        "id": 1539,
        "name": "Codeforces Round 727 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1624183500,
        "relativeTimeSeconds": 65296269
    },
    {
        "id": 1537,
        "name": "Codeforces Round 726 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1624026900,
        "relativeTimeSeconds": 65452869
    },
    {
        "id": 1534,
        "name": "Codeforces LATOKEN Round 1 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1623598500,
        "relativeTimeSeconds": 65881269
    },
    {
        "id": 1538,
        "name": "Codeforces Round 725 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1623335700,
        "relativeTimeSeconds": 66144069
    },
    {
        "id": 1536,
        "name": "Codeforces Round 724 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1622990100,
        "relativeTimeSeconds": 66489669
    },
    {
        "id": 1535,
        "name": "Educational Codeforces Round 110 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1622817300,
        "relativeTimeSeconds": 66662469
    },
    {
        "id": 1523,
        "name": "Deltix Round, Spring 2021 (open for everyone, rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1622385300,
        "relativeTimeSeconds": 67094469
    },
    {
        "id": 1526,
        "name": "Codeforces Round 723 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1622210700,
        "relativeTimeSeconds": 67269069
    },
    {
        "id": 1524,
        "name": "ICPC Challenge 2021: Marathon (powered by Huawei)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 345600,
        "startTimeSeconds": 1622001600,
        "relativeTimeSeconds": 67478169
    },
    {
        "id": 1528,
        "name": "Codeforces Round 722 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1621866900,
        "relativeTimeSeconds": 67612869
    },
    {
        "id": 1529,
        "name": "Codeforces Round 722 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1621866900,
        "relativeTimeSeconds": 67612869
    },
    {
        "id": 1531,
        "name": "VK Cup 2021 - Квалификация (Engine)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 561600,
        "startTimeSeconds": 1621846800,
        "relativeTimeSeconds": 67632970
    },
    {
        "id": 1527,
        "name": "Codeforces Round 721 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1621521300,
        "relativeTimeSeconds": 67958469
    },
    {
        "id": 1522,
        "name": "Codeforces Raif ML Round 1",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1209600,
        "startTimeSeconds": 1621267200,
        "relativeTimeSeconds": 68212569
    },
    {
        "id": 1525,
        "name": "Educational Codeforces Round 109 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1621152000,
        "relativeTimeSeconds": 68327769
    },
    {
        "id": 1521,
        "name": "Codeforces Round 720 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1620398100,
        "relativeTimeSeconds": 69081669
    },
    {
        "id": 1520,
        "name": "Codeforces Round 719 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1620225300,
        "relativeTimeSeconds": 69254469
    },
    {
        "id": 1515,
        "name": "Codeforces Global Round 14",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1619966100,
        "relativeTimeSeconds": 69513669
    },
    {
        "id": 1519,
        "name": "Educational Codeforces Round 108 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1619706900,
        "relativeTimeSeconds": 69772869
    },
    {
        "id": 1517,
        "name": "Contest 2050 and Codeforces Round 718 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9900,
        "startTimeSeconds": 1619188500,
        "relativeTimeSeconds": 70291269
    },
    {
        "id": 1516,
        "name": "Codeforces Round 717 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1619012100,
        "relativeTimeSeconds": 70467669
    },
    {
        "id": 1514,
        "name": "Codeforces Round 716 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1618839300,
        "relativeTimeSeconds": 70640469
    },
    {
        "id": 1508,
        "name": "Codeforces Round 715 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1618583700,
        "relativeTimeSeconds": 70896069
    },
    {
        "id": 1509,
        "name": "Codeforces Round 715 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1618583700,
        "relativeTimeSeconds": 70896069
    },
    {
        "id": 1511,
        "name": "Educational Codeforces Round 107 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1618238100,
        "relativeTimeSeconds": 71241669
    },
    {
        "id": 1513,
        "name": "Divide by Zero 2021 and Codeforces Round 714 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1618151700,
        "relativeTimeSeconds": 71328069
    },
    {
        "id": 1512,
        "name": "Codeforces Round 713 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1618065300,
        "relativeTimeSeconds": 71414469
    },
    {
        "id": 1510,
        "name": "2020-2021 ICPC, NERC, Northern Eurasia Onsite (Unrated, Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1617523500,
        "relativeTimeSeconds": 71956269
    },
    {
        "id": 1503,
        "name": "Codeforces Round 712 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1617460500,
        "relativeTimeSeconds": 72019269
    },
    {
        "id": 1504,
        "name": "Codeforces Round 712 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1617460500,
        "relativeTimeSeconds": 72019269
    },
    {
        "id": 1505,
        "name": "April Fools Day Contest 2021",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1617287700,
        "relativeTimeSeconds": 72192069
    },
    {
        "id": 1498,
        "name": "CodeCraft-21 and Codeforces Round 711 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1617028500,
        "relativeTimeSeconds": 72451269
    },
    {
        "id": 1506,
        "name": "Codeforces Round 710 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1616682900,
        "relativeTimeSeconds": 72796869
    },
    {
        "id": 1483,
        "name": "Codeforces Round 709 (Div. 1, based on Technocup 2021 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1616332800,
        "relativeTimeSeconds": 73146969
    },
    {
        "id": 1484,
        "name": "Codeforces Round 709 (Div. 2, based on Technocup 2021 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1616332800,
        "relativeTimeSeconds": 73146969
    },
    {
        "id": 1482,
        "name": "Технокубок 2021 - Финал",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1616322000,
        "relativeTimeSeconds": 73157769
    },
    {
        "id": 1499,
        "name": "Educational Codeforces Round 106 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1616079000,
        "relativeTimeSeconds": 73400769
    },
    {
        "id": 1497,
        "name": "Codeforces Round 708 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1615991700,
        "relativeTimeSeconds": 73488069
    },
    {
        "id": 1500,
        "name": "Codeforces Round 707 (Div. 1, based on Moscow Open Olympiad in Informatics)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1615626300,
        "relativeTimeSeconds": 73853469
    },
    {
        "id": 1501,
        "name": "Codeforces Round 707 (Div. 2, based on Moscow Open Olympiad in Informatics)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1615626300,
        "relativeTimeSeconds": 73853469
    },
    {
        "id": 1495,
        "name": "Codeforces Round 706 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1615377900,
        "relativeTimeSeconds": 74101869
    },
    {
        "id": 1496,
        "name": "Codeforces Round 706 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1615377900,
        "relativeTimeSeconds": 74101869
    },
    {
        "id": 1488,
        "name": "Kotlin Heroes: Episode 6",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1615300500,
        "relativeTimeSeconds": 74179269
    },
    {
        "id": 1493,
        "name": "Codeforces Round 705 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1615039500,
        "relativeTimeSeconds": 74440269
    },
    {
        "id": 1494,
        "name": "Educational Codeforces Round 105 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1614696300,
        "relativeTimeSeconds": 74783469
    },
    {
        "id": 1489,
        "name": "Kotlin Heroes: Practice 6",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1614692100,
        "relativeTimeSeconds": 74787669
    },
    {
        "id": 1491,
        "name": "Codeforces Global Round 13",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1614519300,
        "relativeTimeSeconds": 74960469
    },
    {
        "id": 1492,
        "name": "Codeforces Round 704 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1614071100,
        "relativeTimeSeconds": 75408669
    },
    {
        "id": 1486,
        "name": "Codeforces Round 703 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1613658900,
        "relativeTimeSeconds": 75820869
    },
    {
        "id": 1490,
        "name": "Codeforces Round 702 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1613486100,
        "relativeTimeSeconds": 75993669
    },
    {
        "id": 1487,
        "name": "Educational Codeforces Round 104 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1613399700,
        "relativeTimeSeconds": 76080069
    },
    {
        "id": 1485,
        "name": "Codeforces Round 701 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1613141400,
        "relativeTimeSeconds": 76338369
    },
    {
        "id": 1479,
        "name": "Codeforces Round 700 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1612708500,
        "relativeTimeSeconds": 76771269
    },
    {
        "id": 1480,
        "name": "Codeforces Round 700 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1612708500,
        "relativeTimeSeconds": 76771269
    },
    {
        "id": 1481,
        "name": "Codeforces Round 699 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1612535700,
        "relativeTimeSeconds": 76944069
    },
    {
        "id": 1476,
        "name": "Educational Codeforces Round 103 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1611930900,
        "relativeTimeSeconds": 77548869
    },
    {
        "id": 1477,
        "name": "Codeforces Round 698 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1611844500,
        "relativeTimeSeconds": 77635269
    },
    {
        "id": 1478,
        "name": "Codeforces Round 698 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1611844500,
        "relativeTimeSeconds": 77635269
    },
    {
        "id": 1475,
        "name": "Codeforces Round 697 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1611586800,
        "relativeTimeSeconds": 77892969
    },
    {
        "id": 1474,
        "name": "Codeforces Round 696 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1611066900,
        "relativeTimeSeconds": 78412869
    },
    {
        "id": 1473,
        "name": "Educational Codeforces Round 102 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1610634900,
        "relativeTimeSeconds": 78844869
    },
    {
        "id": 1467,
        "name": "Codeforces Round 695 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1610116500,
        "relativeTimeSeconds": 79363269
    },
    {
        "id": 1470,
        "name": "Codeforces Round 694 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1609857300,
        "relativeTimeSeconds": 79622469
    },
    {
        "id": 1471,
        "name": "Codeforces Round 694 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1609857300,
        "relativeTimeSeconds": 79622469
    },
    {
        "id": 1472,
        "name": "Codeforces Round 693 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1609770900,
        "relativeTimeSeconds": 79708869
    },
    {
        "id": 1466,
        "name": "Good Bye 2020",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1609338900,
        "relativeTimeSeconds": 80140869
    },
    {
        "id": 1469,
        "name": "Educational Codeforces Round 101 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1609166100,
        "relativeTimeSeconds": 80313669
    },
    {
        "id": 1468,
        "name": "2020-2021 ICPC, NERC, Southern and Volga Russian Regional Contest (Online Mirror, ICPC Rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1608896100,
        "relativeTimeSeconds": 80583669
    },
    {
        "id": 1411,
        "name": "Technocup 2021 - Elimination Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1608476700,
        "relativeTimeSeconds": 81003069
    },
    {
        "id": 1464,
        "name": "Codeforces Round 692 (Div. 1, based on Technocup 2021 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1608476700,
        "relativeTimeSeconds": 81003069
    },
    {
        "id": 1465,
        "name": "Codeforces Round 692 (Div. 2, based on Technocup 2021 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1608476700,
        "relativeTimeSeconds": 81003069
    },
    {
        "id": 1458,
        "name": "Codeforces Round 691 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1608370500,
        "relativeTimeSeconds": 81109269
    },
    {
        "id": 1459,
        "name": "Codeforces Round 691 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1608370500,
        "relativeTimeSeconds": 81109269
    },
    {
        "id": 1410,
        "name": "Технокубок 2021 - Ознакомительный Раунд 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1608300300,
        "relativeTimeSeconds": 81179470
    },
    {
        "id": 1463,
        "name": "Educational Codeforces Round 100 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1608215700,
        "relativeTimeSeconds": 81264069
    },
    {
        "id": 1462,
        "name": "Codeforces Round 690 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1608042900,
        "relativeTimeSeconds": 81436869
    },
    {
        "id": 1460,
        "name": "NERC Challenge 2020: Marathon",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 691200,
        "startTimeSeconds": 1607763600,
        "relativeTimeSeconds": 81716169
    },
    {
        "id": 1461,
        "name": "Codeforces Round 689 (Div. 2, based on Zed Code Competition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1607697300,
        "relativeTimeSeconds": 81782469
    },
    {
        "id": 1450,
        "name": "Codeforces Global Round 12",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1607265300,
        "relativeTimeSeconds": 82214469
    },
    {
        "id": 1453,
        "name": "Codeforces Round 688 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1607087100,
        "relativeTimeSeconds": 82392669
    },
    {
        "id": 1455,
        "name": "Educational Codeforces Round 99 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1606746900,
        "relativeTimeSeconds": 82732869
    },
    {
        "id": 1415,
        "name": "Technocup 2021 - Elimination Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1606633500,
        "relativeTimeSeconds": 82846269
    },
    {
        "id": 1456,
        "name": "Codeforces Round 687 (Div. 1, based on Technocup 2021 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1606633500,
        "relativeTimeSeconds": 82846269
    },
    {
        "id": 1457,
        "name": "Codeforces Round 687 (Div. 2, based on Technocup 2021 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1606633500,
        "relativeTimeSeconds": 82846269
    },
    {
        "id": 1414,
        "name": "Технокубок 2021 - Ознакомительный Раунд 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1606457100,
        "relativeTimeSeconds": 83022670
    },
    {
        "id": 1454,
        "name": "Codeforces Round 686 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1606228500,
        "relativeTimeSeconds": 83251269
    },
    {
        "id": 1451,
        "name": "Codeforces Round 685 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1605969300,
        "relativeTimeSeconds": 83510469
    },
    {
        "id": 1452,
        "name": "Educational Codeforces Round 98 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1605796500,
        "relativeTimeSeconds": 83683269
    },
    {
        "id": 1439,
        "name": "Codeforces Round 684 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1605623700,
        "relativeTimeSeconds": 83856069
    },
    {
        "id": 1440,
        "name": "Codeforces Round 684 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1605623700,
        "relativeTimeSeconds": 83856069
    },
    {
        "id": 1446,
        "name": "Codeforces Round 683 (Div. 1, by Meet IT)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1605450900,
        "relativeTimeSeconds": 84028869
    },
    {
        "id": 1447,
        "name": "Codeforces Round 683 (Div. 2, by Meet IT)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1605450900,
        "relativeTimeSeconds": 84028869
    },
    {
        "id": 1438,
        "name": "Codeforces Round 682 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1605278100,
        "relativeTimeSeconds": 84201669
    },
    {
        "id": 1431,
        "name": "Kotlin Heroes 5: ICPC Round",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1605191700,
        "relativeTimeSeconds": 84288069
    },
    {
        "id": 1432,
        "name": "Kotlin Heroes 5: ICPC Round (Practice)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1604583300,
        "relativeTimeSeconds": 84896469
    },
    {
        "id": 1442,
        "name": "Codeforces Round 681 (Div. 1, based on VK Cup 2019-2020 - Final)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1604327700,
        "relativeTimeSeconds": 85152069
    },
    {
        "id": 1443,
        "name": "Codeforces Round 681 (Div. 2, based on VK Cup 2019-2020 - Final)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1604327700,
        "relativeTimeSeconds": 85152069
    },
    {
        "id": 1441,
        "name": "VK Cup 2019-2020 - Final Round (Engine)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1604239500,
        "relativeTimeSeconds": 85240269
    },
    {
        "id": 1444,
        "name": "Codeforces Round 680 (Div. 1, based on Moscow Team Olympiad)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1604228700,
        "relativeTimeSeconds": 85251069
    },
    {
        "id": 1445,
        "name": "Codeforces Round 680 (Div. 2, based on Moscow Team Olympiad)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1604228700,
        "relativeTimeSeconds": 85251069
    },
    {
        "id": 1437,
        "name": "Educational Codeforces Round 97 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1603809300,
        "relativeTimeSeconds": 85670469
    },
    {
        "id": 1413,
        "name": "Technocup 2021 - Elimination Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1603623900,
        "relativeTimeSeconds": 85855869
    },
    {
        "id": 1434,
        "name": "Codeforces Round 679 (Div. 1, based on Technocup 2021 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1603623900,
        "relativeTimeSeconds": 85855869
    },
    {
        "id": 1435,
        "name": "Codeforces Round 679 (Div. 2, based on Technocup 2021 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1603623900,
        "relativeTimeSeconds": 85855869
    },
    {
        "id": 1436,
        "name": "Codeforces Round 678 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1603548300,
        "relativeTimeSeconds": 85931469
    },
    {
        "id": 1412,
        "name": "Технокубок 2021 - Ознакомительный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1603447500,
        "relativeTimeSeconds": 86032270
    },
    {
        "id": 1433,
        "name": "Codeforces Round 677 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1603204500,
        "relativeTimeSeconds": 86275269
    },
    {
        "id": 1421,
        "name": "Codeforces Round 676 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1603011900,
        "relativeTimeSeconds": 86467869
    },
    {
        "id": 1428,
        "name": "Codeforces Raif Round 1 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1602939900,
        "relativeTimeSeconds": 86539869
    },
    {
        "id": 1430,
        "name": "Educational Codeforces Round 96 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1602407100,
        "relativeTimeSeconds": 87072669
    },
    {
        "id": 1427,
        "name": "Codeforces Global Round 11",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1602341400,
        "relativeTimeSeconds": 87138369
    },
    {
        "id": 1423,
        "name": "Bubble Cup 13 - Finals [Online Mirror, unrated, Div. 1]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1601903100,
        "relativeTimeSeconds": 87576669
    },
    {
        "id": 1424,
        "name": "Bubble Cup 13 - Finals [Online Mirror, unrated, Div. 2]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1601903100,
        "relativeTimeSeconds": 87576669
    },
    {
        "id": 1422,
        "name": "Codeforces Round 675 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1601827500,
        "relativeTimeSeconds": 87652269
    },
    {
        "id": 1408,
        "name": "Grakn Forces 2020",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9900,
        "startTimeSeconds": 1601476500,
        "relativeTimeSeconds": 88003269
    },
    {
        "id": 1426,
        "name": "Codeforces Round 674 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1601280300,
        "relativeTimeSeconds": 88199469
    },
    {
        "id": 1416,
        "name": "Codeforces Round 673 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1601219100,
        "relativeTimeSeconds": 88260669
    },
    {
        "id": 1417,
        "name": "Codeforces Round 673 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1601219100,
        "relativeTimeSeconds": 88260669
    },
    {
        "id": 1425,
        "name": "2020 ICPC, COMPFEST 12, Indonesia Multi-Provincial Contest (Unrated, Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1601182800,
        "relativeTimeSeconds": 88296969
    },
    {
        "id": 1420,
        "name": "Codeforces Round 672 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1600958100,
        "relativeTimeSeconds": 88521669
    },
    {
        "id": 1419,
        "name": "Codeforces Round 671 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1600526100,
        "relativeTimeSeconds": 88953669
    },
    {
        "id": 1418,
        "name": "Educational Codeforces Round 95 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1600094100,
        "relativeTimeSeconds": 89385669
    },
    {
        "id": 1406,
        "name": "Codeforces Round 670 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1599918300,
        "relativeTimeSeconds": 89561469
    },
    {
        "id": 1407,
        "name": "Codeforces Round 669 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1599575700,
        "relativeTimeSeconds": 89904069
    },
    {
        "id": 1404,
        "name": "Codeforces Round 668 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1599402900,
        "relativeTimeSeconds": 90076869
    },
    {
        "id": 1405,
        "name": "Codeforces Round 668 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1599402900,
        "relativeTimeSeconds": 90076869
    },
    {
        "id": 1409,
        "name": "Codeforces Round 667 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1599230100,
        "relativeTimeSeconds": 90249669
    },
    {
        "id": 1396,
        "name": "Codeforces Round 666 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1598798100,
        "relativeTimeSeconds": 90681669
    },
    {
        "id": 1397,
        "name": "Codeforces Round 666 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1598798100,
        "relativeTimeSeconds": 90681669
    },
    {
        "id": 1403,
        "name": "Central-European Olympiad in Informatics, CEOI 2020, Day 2 (IOI, Unofficial Mirror Contest, Unrated)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18600,
        "startTimeSeconds": 1598616300,
        "relativeTimeSeconds": 90863469
    },
    {
        "id": 1402,
        "name": "Central-European Olympiad in Informatics, CEOI 2020, Day 1 (IOI, Unofficial Mirror Contest, Unrated)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1598443500,
        "relativeTimeSeconds": 91036269
    },
    {
        "id": 1400,
        "name": "Educational Codeforces Round 94 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1598366100,
        "relativeTimeSeconds": 91113669
    },
    {
        "id": 1401,
        "name": "Codeforces Round 665 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1598020500,
        "relativeTimeSeconds": 91459269
    },
    {
        "id": 1392,
        "name": "Codeforces Global Round 10",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1597588500,
        "relativeTimeSeconds": 91891269
    },
    {
        "id": 1398,
        "name": "Educational Codeforces Round 93 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1597415700,
        "relativeTimeSeconds": 92064069
    },
    {
        "id": 1394,
        "name": "Codeforces Round 664 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1597242900,
        "relativeTimeSeconds": 92236869
    },
    {
        "id": 1395,
        "name": "Codeforces Round 664 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1597242900,
        "relativeTimeSeconds": 92236869
    },
    {
        "id": 1391,
        "name": "Codeforces Round 663 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1596983700,
        "relativeTimeSeconds": 92496069
    },
    {
        "id": 1393,
        "name": "Codeforces Round 662 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1596810900,
        "relativeTimeSeconds": 92668869
    },
    {
        "id": 1399,
        "name": "Codeforces Round 661 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1596638100,
        "relativeTimeSeconds": 92841669
    },
    {
        "id": 1388,
        "name": "Codeforces Round 660 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1596119700,
        "relativeTimeSeconds": 93360069
    },
    {
        "id": 1389,
        "name": "Educational Codeforces Round 92 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1596033300,
        "relativeTimeSeconds": 93446469
    },
    {
        "id": 1383,
        "name": "Codeforces Round 659 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1595601300,
        "relativeTimeSeconds": 93878469
    },
    {
        "id": 1384,
        "name": "Codeforces Round 659 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1595601300,
        "relativeTimeSeconds": 93878469
    },
    {
        "id": 1387,
        "name": "Baltic Olympiad in Informatics 2020, Day 2 (IOI, Unofficial Mirror Contest, Unrated)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 19800,
        "startTimeSeconds": 1595502300,
        "relativeTimeSeconds": 93977469
    },
    {
        "id": 1386,
        "name": "Baltic Olympiad in Informatics 2020, Day 1 (IOI, Unofficial Mirror Contest, Unrated)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1595415900,
        "relativeTimeSeconds": 94063869
    },
    {
        "id": 1381,
        "name": "Codeforces Round 658 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1595342100,
        "relativeTimeSeconds": 94137669
    },
    {
        "id": 1382,
        "name": "Codeforces Round 658 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1595342100,
        "relativeTimeSeconds": 94137669
    },
    {
        "id": 1379,
        "name": "Codeforces Round 657 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1595149200,
        "relativeTimeSeconds": 94330569
    },
    {
        "id": 1385,
        "name": "Codeforces Round 656 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1594996500,
        "relativeTimeSeconds": 94483269
    },
    {
        "id": 1380,
        "name": "Educational Codeforces Round 91 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1594565100,
        "relativeTimeSeconds": 94914669
    },
    {
        "id": 1372,
        "name": "Codeforces Round 655 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1594479900,
        "relativeTimeSeconds": 94999869
    },
    {
        "id": 1375,
        "name": "Codeforces Global Round 9",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1593873900,
        "relativeTimeSeconds": 95605869
    },
    {
        "id": 1371,
        "name": "Codeforces Round 654 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1593610500,
        "relativeTimeSeconds": 95869269
    },
    {
        "id": 1374,
        "name": "Codeforces Round 653 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1593354900,
        "relativeTimeSeconds": 96124869
    },
    {
        "id": 1378,
        "name": "ICPC Challenge 2020: Marathon",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1593271800,
        "relativeTimeSeconds": 96207969
    },
    {
        "id": 1377,
        "name": "ICPC Challenge 2020",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1593255600,
        "relativeTimeSeconds": 96224169
    },
    {
        "id": 1373,
        "name": "Educational Codeforces Round 90 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1593095700,
        "relativeTimeSeconds": 96384069
    },
    {
        "id": 1376,
        "name": "ICPC Challenge 2020: Practice",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 171000,
        "startTimeSeconds": 1593082800,
        "relativeTimeSeconds": 96396969
    },
    {
        "id": 1369,
        "name": "Codeforces Round 652 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1592921100,
        "relativeTimeSeconds": 96558669
    },
    {
        "id": 1370,
        "name": "Codeforces Round 651 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1592663700,
        "relativeTimeSeconds": 96816069
    },
    {
        "id": 1357,
        "name": "Microsoft Q# Coding Contest - Summer 2020",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1592582400,
        "relativeTimeSeconds": 96897369
    },
    {
        "id": 1368,
        "name": "Codeforces Global Round 8",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1592491500,
        "relativeTimeSeconds": 96988269
    },
    {
        "id": 1367,
        "name": "Codeforces Round 650 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1592318100,
        "relativeTimeSeconds": 97161669
    },
    {
        "id": 1364,
        "name": "Codeforces Round 649 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1592060700,
        "relativeTimeSeconds": 97419069
    },
    {
        "id": 1356,
        "name": "Microsoft Q# Coding Contest - Summer 2020 - Warmup",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1591977600,
        "relativeTimeSeconds": 97502169
    },
    {
        "id": 1366,
        "name": "Educational Codeforces Round 89 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1591886100,
        "relativeTimeSeconds": 97593669
    },
    {
        "id": 1365,
        "name": "Codeforces Round 648 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1591540500,
        "relativeTimeSeconds": 97939269
    },
    {
        "id": 1361,
        "name": "Codeforces Round 647 (Div. 1) - Thanks, Algo Muse!",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1591281300,
        "relativeTimeSeconds": 98198469
    },
    {
        "id": 1362,
        "name": "Codeforces Round 647 (Div. 2) - Thanks, Algo Muse!",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1591281300,
        "relativeTimeSeconds": 98198469
    },
    {
        "id": 1363,
        "name": "Codeforces Round 646 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1590935700,
        "relativeTimeSeconds": 98544069
    },
    {
        "id": 1346,
        "name": "Kotlin Heroes: Episode 4",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1590762900,
        "relativeTimeSeconds": 98716869
    },
    {
        "id": 1359,
        "name": "Educational Codeforces Round 88 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1590676500,
        "relativeTimeSeconds": 98803269
    },
    {
        "id": 1358,
        "name": "Codeforces Round 645 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1590503700,
        "relativeTimeSeconds": 98976069
    },
    {
        "id": 1360,
        "name": "Codeforces Round 644 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1590327300,
        "relativeTimeSeconds": 99152469
    },
    {
        "id": 1347,
        "name": "Kotlin Heroes: Practice 4",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1590154500,
        "relativeTimeSeconds": 99325269
    },
    {
        "id": 1354,
        "name": "Educational Codeforces Round 87 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1589707200,
        "relativeTimeSeconds": 99772569
    },
    {
        "id": 1355,
        "name": "Codeforces Round 643 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1589628900,
        "relativeTimeSeconds": 99850869
    },
    {
        "id": 1353,
        "name": "Codeforces Round 642 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1589466900,
        "relativeTimeSeconds": 100012869
    },
    {
        "id": 1349,
        "name": "Codeforces Round 641 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1589286900,
        "relativeTimeSeconds": 100192869
    },
    {
        "id": 1350,
        "name": "Codeforces Round 641 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1589286900,
        "relativeTimeSeconds": 100192869
    },
    {
        "id": 1352,
        "name": "Codeforces Round 640 (Div. 4)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1589034900,
        "relativeTimeSeconds": 100444869
    },
    {
        "id": 1351,
        "name": "Testing Round 16 (Unrated)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 3600,
        "startTimeSeconds": 1588860300,
        "relativeTimeSeconds": 100619469
    },
    {
        "id": 1344,
        "name": "Codeforces Round 639 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1588775700,
        "relativeTimeSeconds": 100704069
    },
    {
        "id": 1345,
        "name": "Codeforces Round 639 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1588775700,
        "relativeTimeSeconds": 100704069
    },
    {
        "id": 1348,
        "name": "Codeforces Round 638 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1588343700,
        "relativeTimeSeconds": 101136069
    },
    {
        "id": 1342,
        "name": "Educational Codeforces Round 86 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1587911700,
        "relativeTimeSeconds": 101568069
    },
    {
        "id": 1340,
        "name": "Codeforces Round 637 (Div. 1) - Thanks, Ivan Belonogov!",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1587653100,
        "relativeTimeSeconds": 101826669
    },
    {
        "id": 1341,
        "name": "Codeforces Round 637 (Div. 2) - Thanks, Ivan Belonogov!",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1587653100,
        "relativeTimeSeconds": 101826669
    },
    {
        "id": 1343,
        "name": "Codeforces Round 636 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1587479700,
        "relativeTimeSeconds": 102000069
    },
    {
        "id": 1336,
        "name": "Codeforces Round 635 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1586961300,
        "relativeTimeSeconds": 102518469
    },
    {
        "id": 1337,
        "name": "Codeforces Round 635 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1586961300,
        "relativeTimeSeconds": 102518469
    },
    {
        "id": 1335,
        "name": "Codeforces Round 634 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1586788500,
        "relativeTimeSeconds": 102691269
    },
    {
        "id": 1338,
        "name": "Codeforces Round 633 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1586700300,
        "relativeTimeSeconds": 102779469
    },
    {
        "id": 1339,
        "name": "Codeforces Round 633 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1586700300,
        "relativeTimeSeconds": 102779469
    },
    {
        "id": 1334,
        "name": "Educational Codeforces Round 85 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1586529300,
        "relativeTimeSeconds": 102950469
    },
    {
        "id": 1333,
        "name": "Codeforces Round 632 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1586356500,
        "relativeTimeSeconds": 103123269
    },
    {
        "id": 1329,
        "name": "Codeforces Round 631 (Div. 1) - Thanks, Denis aramis Shitov!",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1585924500,
        "relativeTimeSeconds": 103555269
    },
    {
        "id": 1330,
        "name": "Codeforces Round 631 (Div. 2) - Thanks, Denis aramis Shitov!",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1585924500,
        "relativeTimeSeconds": 103555269
    },
    {
        "id": 1331,
        "name": "April Fools Day Contest 2020",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1585751700,
        "relativeTimeSeconds": 103728069
    },
    {
        "id": 1332,
        "name": "Codeforces Round 630 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1585661700,
        "relativeTimeSeconds": 103818069
    },
    {
        "id": 1328,
        "name": "Codeforces Round 629 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1585233300,
        "relativeTimeSeconds": 104246469
    },
    {
        "id": 1327,
        "name": "Educational Codeforces Round 84 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1584974100,
        "relativeTimeSeconds": 104505669
    },
    {
        "id": 1326,
        "name": "Codeforces Global Round 7",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1584628500,
        "relativeTimeSeconds": 104851269
    },
    {
        "id": 1325,
        "name": "Codeforces Round 628 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1584196500,
        "relativeTimeSeconds": 105283269
    },
    {
        "id": 1324,
        "name": "Codeforces Round 627 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1584018300,
        "relativeTimeSeconds": 105461469
    },
    {
        "id": 1312,
        "name": "Educational Codeforces Round 83 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1583764500,
        "relativeTimeSeconds": 105715269
    },
    {
        "id": 1322,
        "name": "Codeforces Round 626 (Div. 1, based on Moscow Open Olympiad in Informatics)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1583573700,
        "relativeTimeSeconds": 105906069
    },
    {
        "id": 1323,
        "name": "Codeforces Round 626 (Div. 2, based on Moscow Open Olympiad in Informatics)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1583573700,
        "relativeTimeSeconds": 105906069
    },
    {
        "id": 1316,
        "name": "CodeCraft-20 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1583332500,
        "relativeTimeSeconds": 106147269
    },
    {
        "id": 1305,
        "name": "Ozon Tech Challenge 2020 (Div.1 + Div.2, Rated, T-shirts + prizes!)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1583246100,
        "relativeTimeSeconds": 106233669
    },
    {
        "id": 1320,
        "name": "Codeforces Round 625 (Div. 1, based on Technocup 2020 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1583068500,
        "relativeTimeSeconds": 106411269
    },
    {
        "id": 1321,
        "name": "Codeforces Round 625 (Div. 2, based on Technocup 2020 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1583068500,
        "relativeTimeSeconds": 106411269
    },
    {
        "id": 1319,
        "name": "Технокубок 2020 - Финал",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1583057400,
        "relativeTimeSeconds": 106422370
    },
    {
        "id": 1297,
        "name": "Kotlin Heroes: Episode 3",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1582810500,
        "relativeTimeSeconds": 106669269
    },
    {
        "id": 1311,
        "name": "Codeforces Round 624 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1582554900,
        "relativeTimeSeconds": 106924869
    },
    {
        "id": 1310,
        "name": "VK Cup 2019-2020 - Elimination Round (Engine)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1582473900,
        "relativeTimeSeconds": 107005869
    },
    {
        "id": 1314,
        "name": "Codeforces Round 623 (Div. 1, based on VK Cup 2019-2020 - Elimination Round, Engine)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1582473900,
        "relativeTimeSeconds": 107005869
    },
    {
        "id": 1315,
        "name": "Codeforces Round 623 (Div. 2, based on VK Cup 2019-2020 - Elimination Round, Engine)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1582473900,
        "relativeTimeSeconds": 107005869
    },
    {
        "id": 1313,
        "name": "Codeforces Round 622 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1582448700,
        "relativeTimeSeconds": 107031069
    },
    {
        "id": 1298,
        "name": "Kotlin Heroes: Practice 3",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 607500,
        "startTimeSeconds": 1582202100,
        "relativeTimeSeconds": 107277669
    },
    {
        "id": 1307,
        "name": "Codeforces Round 621 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1581953700,
        "relativeTimeSeconds": 107526069
    },
    {
        "id": 1304,
        "name": "Codeforces Round 620 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1581771900,
        "relativeTimeSeconds": 107707869
    },
    {
        "id": 1308,
        "name": "VK Cup 2019-2020 - Отборочный раунд (Design)",
        "type": "IOI",
        "phase": "PENDING_SYSTEM_TEST",
        "frozen": false,
        "durationSeconds": 799200,
        "startTimeSeconds": 1581692400,
        "relativeTimeSeconds": 107787370
    },
    {
        "id": 1309,
        "name": "VK Cup 2019-2020 - Отборочный раунд (Mobile)",
        "type": "IOI",
        "phase": "PENDING_SYSTEM_TEST",
        "frozen": false,
        "durationSeconds": 1404000,
        "startTimeSeconds": 1581692400,
        "relativeTimeSeconds": 107787370
    },
    {
        "id": 1301,
        "name": "Codeforces Round 619 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1581604500,
        "relativeTimeSeconds": 107875269
    },
    {
        "id": 1303,
        "name": "Educational Codeforces Round 82 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1581518100,
        "relativeTimeSeconds": 107961669
    },
    {
        "id": 1299,
        "name": "Codeforces Round 618 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1581257100,
        "relativeTimeSeconds": 108222669
    },
    {
        "id": 1300,
        "name": "Codeforces Round 618 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1581257100,
        "relativeTimeSeconds": 108222669
    },
    {
        "id": 1296,
        "name": "Codeforces Round 617 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1580826900,
        "relativeTimeSeconds": 108652869
    },
    {
        "id": 1302,
        "name": "AIM Tech Poorly Prepared Contest (unrated, funny, Div. 1 preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1580746500,
        "relativeTimeSeconds": 108733269
    },
    {
        "id": 1290,
        "name": "Codeforces Round 616 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1580652300,
        "relativeTimeSeconds": 108827469
    },
    {
        "id": 1291,
        "name": "Codeforces Round 616 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1580652300,
        "relativeTimeSeconds": 108827469
    },
    {
        "id": 1295,
        "name": "Educational Codeforces Round 81 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1580308500,
        "relativeTimeSeconds": 109171269
    },
    {
        "id": 1294,
        "name": "Codeforces Round 615 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1579703700,
        "relativeTimeSeconds": 109776069
    },
    {
        "id": 1292,
        "name": "Codeforces Round 614 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1579440900,
        "relativeTimeSeconds": 110038869
    },
    {
        "id": 1293,
        "name": "Codeforces Round 614 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1579440900,
        "relativeTimeSeconds": 110038869
    },
    {
        "id": 1288,
        "name": "Educational Codeforces Round 80 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1579012500,
        "relativeTimeSeconds": 110467269
    },
    {
        "id": 1285,
        "name": "Codeforces Round 613 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1578665100,
        "relativeTimeSeconds": 110814669
    },
    {
        "id": 1286,
        "name": "Codeforces Round 612 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1578233100,
        "relativeTimeSeconds": 111246669
    },
    {
        "id": 1287,
        "name": "Codeforces Round 612 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1578233100,
        "relativeTimeSeconds": 111246669
    },
    {
        "id": 1284,
        "name": "Hello 2020",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1578139500,
        "relativeTimeSeconds": 111340269
    },
    {
        "id": 1270,
        "name": "Good Bye 2019",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1577628300,
        "relativeTimeSeconds": 111851469
    },
    {
        "id": 1283,
        "name": "Codeforces Round 611 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1577552700,
        "relativeTimeSeconds": 111927069
    },
    {
        "id": 1279,
        "name": "Educational Codeforces Round 79 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1577457600,
        "relativeTimeSeconds": 112022169
    },
    {
        "id": 1282,
        "name": "Codeforces Round 610 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1577198100,
        "relativeTimeSeconds": 112281669
    },
    {
        "id": 1268,
        "name": "Codeforces Round 609 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576926300,
        "relativeTimeSeconds": 112553469
    },
    {
        "id": 1269,
        "name": "Codeforces Round 609 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576926300,
        "relativeTimeSeconds": 112553469
    },
    {
        "id": 1278,
        "name": "Educational Codeforces Round 78 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576766100,
        "relativeTimeSeconds": 112713669
    },
    {
        "id": 1266,
        "name": "Codeforces Global Round 6",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1576595100,
        "relativeTimeSeconds": 112884669
    },
    {
        "id": 1271,
        "name": "Codeforces Round 608 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576401300,
        "relativeTimeSeconds": 113078469
    },
    {
        "id": 1280,
        "name": "Codeforces Round 607 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576386300,
        "relativeTimeSeconds": 113093469
    },
    {
        "id": 1281,
        "name": "Codeforces Round 607 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576386300,
        "relativeTimeSeconds": 113093469
    },
    {
        "id": 1259,
        "name": "Technocup 2020 - Elimination Round 4",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576321500,
        "relativeTimeSeconds": 113158269
    },
    {
        "id": 1276,
        "name": "Codeforces Round 606 (Div. 1, based on Technocup 2020 Elimination Round 4)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576321500,
        "relativeTimeSeconds": 113158269
    },
    {
        "id": 1277,
        "name": "Codeforces Round 606 (Div. 2, based on Technocup 2020 Elimination Round 4)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576321500,
        "relativeTimeSeconds": 113158269
    },
    {
        "id": 1272,
        "name": "Codeforces Round 605 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1576157700,
        "relativeTimeSeconds": 113322069
    },
    {
        "id": 1258,
        "name": "Технокубок 2020 - Ознакомительный Раунд 4",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1576145100,
        "relativeTimeSeconds": 113334670
    },
    {
        "id": 1273,
        "name": "VK Cup 2019 - Квалификация (Design)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 950400,
        "startTimeSeconds": 1575580200,
        "relativeTimeSeconds": 113899570
    },
    {
        "id": 1274,
        "name": "VK Cup 2019 - Квалификация (Mobile)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 950400,
        "startTimeSeconds": 1575580200,
        "relativeTimeSeconds": 113899570
    },
    {
        "id": 1275,
        "name": "VK Cup 2019 - Квалификация (Engine)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 950400,
        "startTimeSeconds": 1575580200,
        "relativeTimeSeconds": 113899570
    },
    {
        "id": 1264,
        "name": "Codeforces Round 604 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1575556500,
        "relativeTimeSeconds": 113923269
    },
    {
        "id": 1265,
        "name": "Codeforces Round 604 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1575556500,
        "relativeTimeSeconds": 113923269
    },
    {
        "id": 1267,
        "name": "2019-2020 ICPC, NERC, Northern Eurasia Finals (Unrated, Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1575183600,
        "relativeTimeSeconds": 114296169
    },
    {
        "id": 1263,
        "name": "Codeforces Round 603 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1575038100,
        "relativeTimeSeconds": 114441669
    },
    {
        "id": 1260,
        "name": "Educational Codeforces Round 77 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1574862600,
        "relativeTimeSeconds": 114617169
    },
    {
        "id": 1227,
        "name": "Technocup 2020 - Elimination Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1574582700,
        "relativeTimeSeconds": 114897069
    },
    {
        "id": 1261,
        "name": "Codeforces Round 602 (Div. 1, based on Technocup 2020 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1574582700,
        "relativeTimeSeconds": 114897069
    },
    {
        "id": 1262,
        "name": "Codeforces Round 602 (Div. 2, based on Technocup 2020 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1574582700,
        "relativeTimeSeconds": 114897069
    },
    {
        "id": 1226,
        "name": "Технокубок 2020 - Ознакомительный Раунд 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1574406300,
        "relativeTimeSeconds": 115073470
    },
    {
        "id": 1254,
        "name": "Codeforces Round 601 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1574174100,
        "relativeTimeSeconds": 115305669
    },
    {
        "id": 1255,
        "name": "Codeforces Round 601 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1574174100,
        "relativeTimeSeconds": 115305669
    },
    {
        "id": 1253,
        "name": "Codeforces Round 600 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1573914900,
        "relativeTimeSeconds": 115564869
    },
    {
        "id": 1257,
        "name": "Educational Codeforces Round 76 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1573655700,
        "relativeTimeSeconds": 115824069
    },
    {
        "id": 1242,
        "name": "Codeforces Round 599 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1573052700,
        "relativeTimeSeconds": 116427069
    },
    {
        "id": 1243,
        "name": "Codeforces Round 599 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1573052700,
        "relativeTimeSeconds": 116427069
    },
    {
        "id": 1256,
        "name": "Codeforces Round 598 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1572873300,
        "relativeTimeSeconds": 116606469
    },
    {
        "id": 1245,
        "name": "Codeforces Round 597 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1572618900,
        "relativeTimeSeconds": 116860869
    },
    {
        "id": 1250,
        "name": "2019-2020 ICPC, NERC, Southern and Volga Russian Regional Contest (Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1572168900,
        "relativeTimeSeconds": 117310869
    },
    {
        "id": 1252,
        "name": "2019-2020 ICPC, Asia Jakarta Regional Contest (Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1572147000,
        "relativeTimeSeconds": 117332769
    },
    {
        "id": 1225,
        "name": "Technocup 2020 - Elimination Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1572087900,
        "relativeTimeSeconds": 117391869
    },
    {
        "id": 1246,
        "name": "Codeforces Round 596 (Div. 1, based on Technocup 2020 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1572087900,
        "relativeTimeSeconds": 117391869
    },
    {
        "id": 1247,
        "name": "Codeforces Round 596 (Div. 2, based on Technocup 2020 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1572087900,
        "relativeTimeSeconds": 117391869
    },
    {
        "id": 1251,
        "name": "Educational Codeforces Round 75 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1571929500,
        "relativeTimeSeconds": 117550269
    },
    {
        "id": 1224,
        "name": "Технокубок 2020 - Ознакомительный Раунд 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1571911500,
        "relativeTimeSeconds": 117568270
    },
    {
        "id": 1249,
        "name": "Codeforces Round 595 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1571754900,
        "relativeTimeSeconds": 117724869
    },
    {
        "id": 1239,
        "name": "Codeforces Round 594 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1571562300,
        "relativeTimeSeconds": 117917469
    },
    {
        "id": 1248,
        "name": "Codeforces Round 594 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1571562300,
        "relativeTimeSeconds": 117917469
    },
    {
        "id": 1236,
        "name": "Codeforces Round 593 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1571319300,
        "relativeTimeSeconds": 118160469
    },
    {
        "id": 1237,
        "name": "Codeforces Global Round 5",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1571236500,
        "relativeTimeSeconds": 118243269
    },
    {
        "id": 1244,
        "name": "Codeforces Round 592 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1570957500,
        "relativeTimeSeconds": 118522269
    },
    {
        "id": 1238,
        "name": "Educational Codeforces Round 74 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8400,
        "startTimeSeconds": 1570545300,
        "relativeTimeSeconds": 118934469
    },
    {
        "id": 1223,
        "name": "Technocup 2020 - Elimination Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1570374300,
        "relativeTimeSeconds": 119105469
    },
    {
        "id": 1240,
        "name": "Codeforces Round 591 (Div. 1, based on Technocup 2020 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1570374300,
        "relativeTimeSeconds": 119105469
    },
    {
        "id": 1241,
        "name": "Codeforces Round 591 (Div. 2, based on Technocup 2020 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1570374300,
        "relativeTimeSeconds": 119105469
    },
    {
        "id": 1222,
        "name": "Технокубок 2020 - Ознакомительный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1570197900,
        "relativeTimeSeconds": 119281870
    },
    {
        "id": 1234,
        "name": "Codeforces Round 590 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1569940500,
        "relativeTimeSeconds": 119539269
    },
    {
        "id": 1235,
        "name": "Huawei Honorcup Marathon 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1209600,
        "startTimeSeconds": 1569866400,
        "relativeTimeSeconds": 119613369
    },
    {
        "id": 1228,
        "name": "Codeforces Round 589 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1569762300,
        "relativeTimeSeconds": 119717469
    },
    {
        "id": 1229,
        "name": "Codeforces Round 588 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1569247500,
        "relativeTimeSeconds": 120232269
    },
    {
        "id": 1230,
        "name": "Codeforces Round 588 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1569247500,
        "relativeTimeSeconds": 120232269
    },
    {
        "id": 1210,
        "name": "Dasha Code Championship - SPb Finals Round (only for onsite-finalists)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1569143100,
        "relativeTimeSeconds": 120336669
    },
    {
        "id": 1231,
        "name": "Dasha Code Championship - Novosibirsk Finals Round (only for onsite-finalists)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1569143100,
        "relativeTimeSeconds": 120336669
    },
    {
        "id": 1216,
        "name": "Codeforces Round 587 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1569049500,
        "relativeTimeSeconds": 120430269
    },
    {
        "id": 1221,
        "name": "Educational Codeforces Round 73 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1568903700,
        "relativeTimeSeconds": 120576069
    },
    {
        "id": 1220,
        "name": "Codeforces Round 586 (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1568822700,
        "relativeTimeSeconds": 120657069
    },
    {
        "id": 1218,
        "name": "Bubble Cup 12 - Finals [Online Mirror, unrated, Div. 1]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1568554500,
        "relativeTimeSeconds": 120925269
    },
    {
        "id": 1219,
        "name": "Bubble Cup 12 - Finals [Online Mirror, unrated, Div. 2]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1568554500,
        "relativeTimeSeconds": 120925269
    },
    {
        "id": 1215,
        "name": "Codeforces Round 585 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1568543700,
        "relativeTimeSeconds": 120936069
    },
    {
        "id": 1209,
        "name": "Codeforces Round 584 - Dasha Code Championship - Elimination Round (rated, open for everyone, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1568466300,
        "relativeTimeSeconds": 121013469
    },
    {
        "id": 1211,
        "name": "Kotlin Heroes: Episode 2",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1567866900,
        "relativeTimeSeconds": 121612869
    },
    {
        "id": 1217,
        "name": "Educational Codeforces Round 72 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1567694100,
        "relativeTimeSeconds": 121785669
    },
    {
        "id": 1214,
        "name": "Codeforces Round 583 (Div. 1 + Div. 2, based on Olympiad of Metropolises)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1567587900,
        "relativeTimeSeconds": 121891869
    },
    {
        "id": 1212,
        "name": "Kotlin Heroes: Practice 2",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1567258500,
        "relativeTimeSeconds": 122221269
    },
    {
        "id": 1213,
        "name": "Codeforces Round 582 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1567175700,
        "relativeTimeSeconds": 122304069
    },
    {
        "id": 1208,
        "name": "Manthan, Codefest 19 (open for everyone, rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1566743700,
        "relativeTimeSeconds": 122736069
    },
    {
        "id": 1207,
        "name": "Educational Codeforces Round 71 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1566484500,
        "relativeTimeSeconds": 122995269
    },
    {
        "id": 1204,
        "name": "Codeforces Round 581 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1566311700,
        "relativeTimeSeconds": 123168069
    },
    {
        "id": 1205,
        "name": "Codeforces Round 580 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1566135900,
        "relativeTimeSeconds": 123343869
    },
    {
        "id": 1206,
        "name": "Codeforces Round 580 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1566135900,
        "relativeTimeSeconds": 123343869
    },
    {
        "id": 1203,
        "name": "Codeforces Round 579 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8400,
        "startTimeSeconds": 1565706900,
        "relativeTimeSeconds": 123772869
    },
    {
        "id": 1200,
        "name": "Codeforces Round 578 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1565526900,
        "relativeTimeSeconds": 123952869
    },
    {
        "id": 1202,
        "name": "Educational Codeforces Round 70 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1565188500,
        "relativeTimeSeconds": 124291269
    },
    {
        "id": 1201,
        "name": "Codeforces Round 577 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1564936500,
        "relativeTimeSeconds": 124543269
    },
    {
        "id": 1198,
        "name": "Codeforces Round 576 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1564497300,
        "relativeTimeSeconds": 124982469
    },
    {
        "id": 1199,
        "name": "Codeforces Round 576 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1564497300,
        "relativeTimeSeconds": 124982469
    },
    {
        "id": 1193,
        "name": "CEOI 2019 day 2 online mirror (unrated, IOI format)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1564301100,
        "relativeTimeSeconds": 125178669
    },
    {
        "id": 1192,
        "name": "CEOI 2019 day 1 online mirror (unrated, IOI format)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1564063500,
        "relativeTimeSeconds": 125416269
    },
    {
        "id": 1196,
        "name": "Codeforces Round 575 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1563978900,
        "relativeTimeSeconds": 125500869
    },
    {
        "id": 1197,
        "name": "Educational Codeforces Round 69 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1563806100,
        "relativeTimeSeconds": 125673669
    },
    {
        "id": 1178,
        "name": "Codeforces Global Round 4",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1563636900,
        "relativeTimeSeconds": 125842869
    },
    {
        "id": 1195,
        "name": "Codeforces Round 574 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1563374100,
        "relativeTimeSeconds": 126105669
    },
    {
        "id": 1194,
        "name": "Educational Codeforces Round 68 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1563115500,
        "relativeTimeSeconds": 126364269
    },
    {
        "id": 1190,
        "name": "Codeforces Round 573 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1562942100,
        "relativeTimeSeconds": 126537669
    },
    {
        "id": 1191,
        "name": "Codeforces Round 573 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1562942100,
        "relativeTimeSeconds": 126537669
    },
    {
        "id": 1184,
        "name": "Helvetic Coding Contest 2019 online mirror (teams allowed, unrated)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 16200,
        "startTimeSeconds": 1562483100,
        "relativeTimeSeconds": 126996669
    },
    {
        "id": 1188,
        "name": "Codeforces Round 572 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1562339100,
        "relativeTimeSeconds": 127140669
    },
    {
        "id": 1189,
        "name": "Codeforces Round 572 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1562339100,
        "relativeTimeSeconds": 127140669
    },
    {
        "id": 1187,
        "name": "Educational Codeforces Round 67 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1561905900,
        "relativeTimeSeconds": 127573869
    },
    {
        "id": 1186,
        "name": "Codeforces Round 571 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1561710000,
        "relativeTimeSeconds": 127769769
    },
    {
        "id": 1183,
        "name": "Codeforces Round 570 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1561559700,
        "relativeTimeSeconds": 127920069
    },
    {
        "id": 1179,
        "name": "Codeforces Round 569 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1561136700,
        "relativeTimeSeconds": 128343069
    },
    {
        "id": 1180,
        "name": "Codeforces Round 569 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1561136700,
        "relativeTimeSeconds": 128343069
    },
    {
        "id": 1185,
        "name": "Codeforces Round 568 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1560955500,
        "relativeTimeSeconds": 128524269
    },
    {
        "id": 1181,
        "name": "Codeforces Round 567 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1560677700,
        "relativeTimeSeconds": 128802069
    },
    {
        "id": 1182,
        "name": "Codeforces Round 566 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1560258300,
        "relativeTimeSeconds": 129221469
    },
    {
        "id": 1176,
        "name": "Codeforces Round 565 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1560090900,
        "relativeTimeSeconds": 129388869
    },
    {
        "id": 1172,
        "name": "Codeforces Round 564 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1559909100,
        "relativeTimeSeconds": 129570669
    },
    {
        "id": 1173,
        "name": "Codeforces Round 564 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1559909100,
        "relativeTimeSeconds": 129570669
    },
    {
        "id": 1175,
        "name": "Educational Codeforces Round 66 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1559745300,
        "relativeTimeSeconds": 129734469
    },
    {
        "id": 1174,
        "name": "Codeforces Round 563 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1559570700,
        "relativeTimeSeconds": 129909069
    },
    {
        "id": 1148,
        "name": "Codeforces Global Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1559399700,
        "relativeTimeSeconds": 130080069
    },
    {
        "id": 1177,
        "name": "Testing Round 15 (Unrated)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 2700,
        "startTimeSeconds": 1559375100,
        "relativeTimeSeconds": 130104669
    },
    {
        "id": 1170,
        "name": "Kotlin Heroes: Episode 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1559054100,
        "relativeTimeSeconds": 130425669
    },
    {
        "id": 1168,
        "name": "Codeforces Round 562 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1558884900,
        "relativeTimeSeconds": 130594869
    },
    {
        "id": 1169,
        "name": "Codeforces Round 562 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1558884900,
        "relativeTimeSeconds": 130594869
    },
    {
        "id": 1171,
        "name": "Kotlin Heroes: Practice 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 518400,
        "startTimeSeconds": 1558535700,
        "relativeTimeSeconds": 130944069
    },
    {
        "id": 1166,
        "name": "Codeforces Round 561 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1558105500,
        "relativeTimeSeconds": 131374269
    },
    {
        "id": 1167,
        "name": "Educational Codeforces Round 65 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1557930900,
        "relativeTimeSeconds": 131548869
    },
    {
        "id": 1165,
        "name": "Codeforces Round 560 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1557844500,
        "relativeTimeSeconds": 131635269
    },
    {
        "id": 1158,
        "name": "Codeforces Round 559 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1557671700,
        "relativeTimeSeconds": 131808069
    },
    {
        "id": 1159,
        "name": "Codeforces Round 559 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1557671700,
        "relativeTimeSeconds": 131808069
    },
    {
        "id": 1163,
        "name": "Codeforces Round 558 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1557414300,
        "relativeTimeSeconds": 132065469
    },
    {
        "id": 1164,
        "name": "Mathforces: Tech Scouts Online Test 2018 (just fun and practice, unofficial, unrated)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1557043500,
        "relativeTimeSeconds": 132436269
    },
    {
        "id": 1147,
        "name": "Forethought Future Cup - Final Round (Onsite Finalists Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1556989500,
        "relativeTimeSeconds": 132490269
    },
    {
        "id": 1161,
        "name": "Codeforces Round 557 (Div. 1) [based on Forethought Future Cup - Final Round]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1556989500,
        "relativeTimeSeconds": 132490269
    },
    {
        "id": 1162,
        "name": "Codeforces Round 557 (Div. 2) [based on Forethought Future Cup - Final Round]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1556989500,
        "relativeTimeSeconds": 132490269
    },
    {
        "id": 1156,
        "name": "Educational Codeforces Round 64 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1556721300,
        "relativeTimeSeconds": 132758469
    },
    {
        "id": 1160,
        "name": "VRt Contest 2019 (marathon)",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1209600,
        "startTimeSeconds": 1556614800,
        "relativeTimeSeconds": 132864969
    },
    {
        "id": 1149,
        "name": "Codeforces Round 556 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1556548500,
        "relativeTimeSeconds": 132931269
    },
    {
        "id": 1150,
        "name": "Codeforces Round 556 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1556548500,
        "relativeTimeSeconds": 132931269
    },
    {
        "id": 1157,
        "name": "Codeforces Round 555 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1556289300,
        "relativeTimeSeconds": 133190469
    },
    {
        "id": 1152,
        "name": "Codeforces Round 554 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1556116500,
        "relativeTimeSeconds": 133363269
    },
    {
        "id": 1155,
        "name": "Educational Codeforces Round 63 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1555943700,
        "relativeTimeSeconds": 133536069
    },
    {
        "id": 1146,
        "name": "Forethought Future Cup - Elimination Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1555783500,
        "relativeTimeSeconds": 133696269
    },
    {
        "id": 1151,
        "name": "Codeforces Round 553 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1555601700,
        "relativeTimeSeconds": 133878069
    },
    {
        "id": 1154,
        "name": "Codeforces Round 552 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1555425300,
        "relativeTimeSeconds": 134054469
    },
    {
        "id": 1153,
        "name": "Codeforces Round 551 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1555164300,
        "relativeTimeSeconds": 134315469
    },
    {
        "id": 1119,
        "name": "Codeforces Global Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1554550500,
        "relativeTimeSeconds": 134929269
    },
    {
        "id": 1145,
        "name": "April Fools Day Contest 2019",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1554131100,
        "relativeTimeSeconds": 135348669
    },
    {
        "id": 1144,
        "name": "Codeforces Round 550 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1554041100,
        "relativeTimeSeconds": 135438669
    },
    {
        "id": 1142,
        "name": "Codeforces Round 549 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1553965800,
        "relativeTimeSeconds": 135513969
    },
    {
        "id": 1143,
        "name": "Codeforces Round 549 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1553965800,
        "relativeTimeSeconds": 135513969
    },
    {
        "id": 1140,
        "name": "Educational Codeforces Round 62 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1553267100,
        "relativeTimeSeconds": 136212669
    },
    {
        "id": 1139,
        "name": "Codeforces Round 548 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1553182500,
        "relativeTimeSeconds": 136297269
    },
    {
        "id": 1141,
        "name": "Codeforces Round 547 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1553006100,
        "relativeTimeSeconds": 136473669
    },
    {
        "id": 1136,
        "name": "Codeforces Round 546 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1552322100,
        "relativeTimeSeconds": 137157669
    },
    {
        "id": 1137,
        "name": "Codeforces Round 545 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1552035900,
        "relativeTimeSeconds": 137443869
    },
    {
        "id": 1138,
        "name": "Codeforces Round 545 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1552035900,
        "relativeTimeSeconds": 137443869
    },
    {
        "id": 1133,
        "name": "Codeforces Round 544 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1551971100,
        "relativeTimeSeconds": 137508669
    },
    {
        "id": 1132,
        "name": "Educational Codeforces Round 61 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1551798300,
        "relativeTimeSeconds": 137681469
    },
    {
        "id": 1120,
        "name": "Codeforces Round 543 (Div. 1, based on Technocup 2019 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1551627300,
        "relativeTimeSeconds": 137852469
    },
    {
        "id": 1121,
        "name": "Codeforces Round 543 (Div. 2, based on Technocup 2019 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1551627300,
        "relativeTimeSeconds": 137852469
    },
    {
        "id": 1112,
        "name": "Technocup 2019 - Final",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1551601800,
        "relativeTimeSeconds": 137877969
    },
    {
        "id": 1116,
        "name": "Microsoft Q# Coding Contest - Winter 2019",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1551459600,
        "relativeTimeSeconds": 138020169
    },
    {
        "id": 1129,
        "name": "Codeforces Round 542 [Alex Lopashev Thanks-Round] (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1551022500,
        "relativeTimeSeconds": 138457269
    },
    {
        "id": 1130,
        "name": "Codeforces Round 542 [Alex Lopashev Thanks-Round] (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1551022500,
        "relativeTimeSeconds": 138457269
    },
    {
        "id": 1131,
        "name": "Codeforces Round 541 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1550917200,
        "relativeTimeSeconds": 138562569
    },
    {
        "id": 1115,
        "name": "Microsoft Q# Coding Contest - Winter 2019 - Warmup",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1550854800,
        "relativeTimeSeconds": 138624969
    },
    {
        "id": 1118,
        "name": "Codeforces Round 540 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1550586900,
        "relativeTimeSeconds": 138892869
    },
    {
        "id": 1117,
        "name": "Educational Codeforces Round 60 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1550504400,
        "relativeTimeSeconds": 138975369
    },
    {
        "id": 1109,
        "name": "Codeforces Round 539 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1550334900,
        "relativeTimeSeconds": 139144869
    },
    {
        "id": 1113,
        "name": "Codeforces Round 539 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1550334900,
        "relativeTimeSeconds": 139144869
    },
    {
        "id": 1114,
        "name": "Codeforces Round 538 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1549807500,
        "relativeTimeSeconds": 139672269
    },
    {
        "id": 1110,
        "name": "Codeforces Global Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1549546500,
        "relativeTimeSeconds": 139933269
    },
    {
        "id": 1111,
        "name": "CodeCraft-19 and Codeforces Round 537 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1549208100,
        "relativeTimeSeconds": 140271669
    },
    {
        "id": 1106,
        "name": "Codeforces Round 536 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9600,
        "startTimeSeconds": 1548938100,
        "relativeTimeSeconds": 140541669
    },
    {
        "id": 1107,
        "name": "Educational Codeforces Round 59 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1548516900,
        "relativeTimeSeconds": 140962869
    },
    {
        "id": 1108,
        "name": "Codeforces Round 535 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1548254100,
        "relativeTimeSeconds": 141225669
    },
    {
        "id": 1103,
        "name": "Codeforces Round 534 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1548167700,
        "relativeTimeSeconds": 141312069
    },
    {
        "id": 1104,
        "name": "Codeforces Round 534 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1548167700,
        "relativeTimeSeconds": 141312069
    },
    {
        "id": 1105,
        "name": "Codeforces Round 533 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1547985900,
        "relativeTimeSeconds": 141493869
    },
    {
        "id": 1100,
        "name": "Codeforces Round 532 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1547390100,
        "relativeTimeSeconds": 142089669
    },
    {
        "id": 1101,
        "name": "Educational Codeforces Round 58 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1547217300,
        "relativeTimeSeconds": 142262469
    },
    {
        "id": 1102,
        "name": "Codeforces Round 531 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1547044500,
        "relativeTimeSeconds": 142435269
    },
    {
        "id": 1098,
        "name": "Codeforces Round 530 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1546706100,
        "relativeTimeSeconds": 142773669
    },
    {
        "id": 1099,
        "name": "Codeforces Round 530 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1546706100,
        "relativeTimeSeconds": 142773669
    },
    {
        "id": 1097,
        "name": "Hello 2019",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1546613100,
        "relativeTimeSeconds": 142866669
    },
    {
        "id": 1091,
        "name": "Good Bye 2018",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9600,
        "startTimeSeconds": 1546180500,
        "relativeTimeSeconds": 143299269
    },
    {
        "id": 1096,
        "name": "Educational Codeforces Round 57 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1546007700,
        "relativeTimeSeconds": 143472069
    },
    {
        "id": 1095,
        "name": "Codeforces Round 529 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1545921300,
        "relativeTimeSeconds": 143558469
    },
    {
        "id": 1085,
        "name": "Technocup 2019 - Elimination Round 4",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1545572100,
        "relativeTimeSeconds": 143907669
    },
    {
        "id": 1086,
        "name": "Codeforces Round 528 (Div. 1, based on Technocup 2019 Elimination Round 4)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1545572100,
        "relativeTimeSeconds": 143907669
    },
    {
        "id": 1087,
        "name": "Codeforces Round 528 (Div. 2, based on Technocup 2019 Elimination Round 4)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1545572100,
        "relativeTimeSeconds": 143907669
    },
    {
        "id": 1094,
        "name": "Технокубок 2019 - Ознакомительный Раунд 4",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1545395700,
        "relativeTimeSeconds": 144084070
    },
    {
        "id": 1092,
        "name": "Codeforces Round 527 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1545143700,
        "relativeTimeSeconds": 144336069
    },
    {
        "id": 1081,
        "name": "Avito Cool Challenge 2018",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1544970900,
        "relativeTimeSeconds": 144508869
    },
    {
        "id": 1093,
        "name": "Educational Codeforces Round 56 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1544884500,
        "relativeTimeSeconds": 144595269
    },
    {
        "id": 1083,
        "name": "Codeforces Round 526 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1544459700,
        "relativeTimeSeconds": 145020069
    },
    {
        "id": 1084,
        "name": "Codeforces Round 526 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1544459700,
        "relativeTimeSeconds": 145020069
    },
    {
        "id": 1090,
        "name": "2018-2019 Russia Open High School Programming Contest (Unrated, Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1544342700,
        "relativeTimeSeconds": 145137069
    },
    {
        "id": 1088,
        "name": "Codeforces Round 525 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1543934100,
        "relativeTimeSeconds": 145545669
    },
    {
        "id": 1089,
        "name": "2018-2019 ICPC, NEERC, Northern Eurasia Finals (Unrated, Online Mirror, ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1543734300,
        "relativeTimeSeconds": 145745469
    },
    {
        "id": 1082,
        "name": "Educational Codeforces Round 55 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1543415700,
        "relativeTimeSeconds": 146064069
    },
    {
        "id": 1056,
        "name": "Mail.Ru Cup 2018 Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1543163700,
        "relativeTimeSeconds": 146316069
    },
    {
        "id": 1080,
        "name": "Codeforces Round 524 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1543044900,
        "relativeTimeSeconds": 146434869
    },
    {
        "id": 1061,
        "name": "Codeforces Round 523 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1542901500,
        "relativeTimeSeconds": 146578269
    },
    {
        "id": 1032,
        "name": "Technocup 2019 - Elimination Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8400,
        "startTimeSeconds": 1542557100,
        "relativeTimeSeconds": 146922669
    },
    {
        "id": 1078,
        "name": "Codeforces Round 522 (Div. 1, based on Technocup 2019 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8400,
        "startTimeSeconds": 1542557100,
        "relativeTimeSeconds": 146922669
    },
    {
        "id": 1079,
        "name": "Codeforces Round 522 (Div. 2, based on Technocup 2019 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8400,
        "startTimeSeconds": 1542557100,
        "relativeTimeSeconds": 146922669
    },
    {
        "id": 1050,
        "name": "Технокубок 2019 - Ознакомительный Раунд 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1542380700,
        "relativeTimeSeconds": 147099070
    },
    {
        "id": 1077,
        "name": "Codeforces Round 521 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1542378900,
        "relativeTimeSeconds": 147100869
    },
    {
        "id": 1062,
        "name": "Codeforces Round 520 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1542209700,
        "relativeTimeSeconds": 147270069
    },
    {
        "id": 1076,
        "name": "Educational Codeforces Round 54 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1542033300,
        "relativeTimeSeconds": 147446469
    },
    {
        "id": 1055,
        "name": "Mail.Ru Cup 2018 Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1541860500,
        "relativeTimeSeconds": 147619269
    },
    {
        "id": 1044,
        "name": "Lyft Level 5 Challenge 2018 - Final Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1541355000,
        "relativeTimeSeconds": 148124769
    },
    {
        "id": 1074,
        "name": "Lyft Level 5 Challenge 2018 - Final Round (Open Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1541355000,
        "relativeTimeSeconds": 148124769
    },
    {
        "id": 1075,
        "name": "Lyft Level 5 Challenge 2018 - Final Round (Open Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1541355000,
        "relativeTimeSeconds": 148124769
    },
    {
        "id": 1043,
        "name": "Codeforces Round 519 by Botan Investments",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1540740900,
        "relativeTimeSeconds": 148738869
    },
    {
        "id": 1073,
        "name": "Educational Codeforces Round 53 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1540478100,
        "relativeTimeSeconds": 149001669
    },
    {
        "id": 1067,
        "name": "Codeforces Round 518 (Div. 1) [Thanks, Mail.Ru!]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1540398900,
        "relativeTimeSeconds": 149080869
    },
    {
        "id": 1068,
        "name": "Codeforces Round 518 (Div. 2) [Thanks, Mail.Ru!]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1540398900,
        "relativeTimeSeconds": 149080869
    },
    {
        "id": 1031,
        "name": "Technocup 2019 - Elimination Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1540109400,
        "relativeTimeSeconds": 149370369
    },
    {
        "id": 1071,
        "name": "Codeforces Round 517 (Div. 1, based on Technocup 2019 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1540109400,
        "relativeTimeSeconds": 149370369
    },
    {
        "id": 1072,
        "name": "Codeforces Round 517 (Div. 2, based on Technocup 2019 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1540109400,
        "relativeTimeSeconds": 149370369
    },
    {
        "id": 1070,
        "name": "2018-2019 ICPC, NEERC, Southern Subregional Contest (Online Mirror, ACM-ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1540022700,
        "relativeTimeSeconds": 149457069
    },
    {
        "id": 1049,
        "name": "Технокубок 2019 - Ознакомительный Раунд 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1539932700,
        "relativeTimeSeconds": 149547070
    },
    {
        "id": 1054,
        "name": "Mail.Ru Cup 2018 Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1539880500,
        "relativeTimeSeconds": 149599269
    },
    {
        "id": 1063,
        "name": "Codeforces Round 516 (Div. 1, by Moscow Team Olympiad)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1539511500,
        "relativeTimeSeconds": 149968269
    },
    {
        "id": 1064,
        "name": "Codeforces Round 516 (Div. 2, by Moscow Team Olympiad)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1539511500,
        "relativeTimeSeconds": 149968269
    },
    {
        "id": 1066,
        "name": "Codeforces Round 515 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1539354900,
        "relativeTimeSeconds": 150124869
    },
    {
        "id": 1057,
        "name": "Mail.Ru Cup 2018 - Practice Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1539335100,
        "relativeTimeSeconds": 150144669
    },
    {
        "id": 1065,
        "name": "Educational Codeforces Round 52 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1539269400,
        "relativeTimeSeconds": 150210369
    },
    {
        "id": 1033,
        "name": "Lyft Level 5 Challenge 2018 - Elimination Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1538931900,
        "relativeTimeSeconds": 150547869
    },
    {
        "id": 1059,
        "name": "Codeforces Round 514 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1538750100,
        "relativeTimeSeconds": 150729669
    },
    {
        "id": 1060,
        "name": "Codeforces Round 513 by Barcelona Bootcamp (rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1538636700,
        "relativeTimeSeconds": 150843069
    },
    {
        "id": 1030,
        "name": "Technocup 2019 - Elimination Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1537707900,
        "relativeTimeSeconds": 151771869
    },
    {
        "id": 1053,
        "name": "Codeforces Round 512 (Div. 1, based on Technocup 2019 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1537707900,
        "relativeTimeSeconds": 151771869
    },
    {
        "id": 1058,
        "name": "Codeforces Round 512 (Div. 2, based on Technocup 2019 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1537707900,
        "relativeTimeSeconds": 151771869
    },
    {
        "id": 1045,
        "name": "Bubble Cup 11 - Finals [Online Mirror, Div. 1]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1537612500,
        "relativeTimeSeconds": 151867269
    },
    {
        "id": 1046,
        "name": "Bubble Cup 11 - Finals [Online Mirror, Div. 2]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1537612500,
        "relativeTimeSeconds": 151867269
    },
    {
        "id": 1034,
        "name": "Codeforces Round 511 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1537540500,
        "relativeTimeSeconds": 151939269
    },
    {
        "id": 1047,
        "name": "Codeforces Round 511 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1537540500,
        "relativeTimeSeconds": 151939269
    },
    {
        "id": 1048,
        "name": "Технокубок 2019 - Ознакомительный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1537531500,
        "relativeTimeSeconds": 151948270
    },
    {
        "id": 1052,
        "name": "Huawei Honorcup Marathon 1",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1209600,
        "startTimeSeconds": 1537462800,
        "relativeTimeSeconds": 152016969
    },
    {
        "id": 1051,
        "name": "Educational Codeforces Round 51 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1537454700,
        "relativeTimeSeconds": 152025069
    },
    {
        "id": 1042,
        "name": "Codeforces Round 510 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1537171500,
        "relativeTimeSeconds": 152308269
    },
    {
        "id": 1041,
        "name": "Codeforces Round 509 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1537094100,
        "relativeTimeSeconds": 152385669
    },
    {
        "id": 1036,
        "name": "Educational Codeforces Round 50 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1536330900,
        "relativeTimeSeconds": 153148869
    },
    {
        "id": 1038,
        "name": "Codeforces Round 508 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1536248100,
        "relativeTimeSeconds": 153231669
    },
    {
        "id": 1039,
        "name": "Codeforces Round 507 (Div. 1, based on Olympiad of Metropolises)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1536165300,
        "relativeTimeSeconds": 153314469
    },
    {
        "id": 1040,
        "name": "Codeforces Round 507 (Div. 2, based on Olympiad of Metropolises)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1536165300,
        "relativeTimeSeconds": 153314469
    },
    {
        "id": 1037,
        "name": "Manthan, Codefest 18 (rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1535898900,
        "relativeTimeSeconds": 153580869
    },
    {
        "id": 1028,
        "name": "AIM Tech Round 5 (rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1535387700,
        "relativeTimeSeconds": 154092069
    },
    {
        "id": 1029,
        "name": "Codeforces Round 506 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1535122200,
        "relativeTimeSeconds": 154357569
    },
    {
        "id": 1025,
        "name": "Codeforces Round 505 (rated, Div. 1 + Div. 2, based on VK Cup 2018 Final)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1534685700,
        "relativeTimeSeconds": 154794069
    },
    {
        "id": 1027,
        "name": "Educational Codeforces Round 49 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1534602900,
        "relativeTimeSeconds": 154876869
    },
    {
        "id": 1023,
        "name": "Codeforces Round 504 (rated, Div. 1 + Div. 2, based on VK Cup 2018 Final)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1534516500,
        "relativeTimeSeconds": 154963269
    },
    {
        "id": 951,
        "name": "VK Cup 2018 - Final",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1534059600,
        "relativeTimeSeconds": 155420169
    },
    {
        "id": 1019,
        "name": "Codeforces Round 503 (by SIS, Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1533994500,
        "relativeTimeSeconds": 155485269
    },
    {
        "id": 1020,
        "name": "Codeforces Round 503 (by SIS, Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1533994500,
        "relativeTimeSeconds": 155485269
    },
    {
        "id": 1017,
        "name": "Codeforces Round 502 (in memory of Leopoldo Taravilse, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9600,
        "startTimeSeconds": 1533737100,
        "relativeTimeSeconds": 155742669
    },
    {
        "id": 1016,
        "name": "Educational Codeforces Round 48 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1533307500,
        "relativeTimeSeconds": 156172269
    },
    {
        "id": 1015,
        "name": "Codeforces Round 501 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1533047700,
        "relativeTimeSeconds": 156432069
    },
    {
        "id": 1012,
        "name": "Codeforces Round 500 (Div. 1) [based on EJOI]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1532938500,
        "relativeTimeSeconds": 156541269
    },
    {
        "id": 1013,
        "name": "Codeforces Round 500 (Div. 2) [based on EJOI]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1532938500,
        "relativeTimeSeconds": 156541269
    },
    {
        "id": 1010,
        "name": "Codeforces Round 499 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1532617500,
        "relativeTimeSeconds": 156862269
    },
    {
        "id": 1011,
        "name": "Codeforces Round 499 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1532617500,
        "relativeTimeSeconds": 156862269
    },
    {
        "id": 1014,
        "name": "Codeforces Marathon Round 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1532434500,
        "relativeTimeSeconds": 157045269
    },
    {
        "id": 1006,
        "name": "Codeforces Round 498 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1531751700,
        "relativeTimeSeconds": 157728069
    },
    {
        "id": 1009,
        "name": "Educational Codeforces Round 47 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1531578900,
        "relativeTimeSeconds": 157900869
    },
    {
        "id": 1007,
        "name": "Codeforces Round 497 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1531492500,
        "relativeTimeSeconds": 157987269
    },
    {
        "id": 1008,
        "name": "Codeforces Round 497 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1531492500,
        "relativeTimeSeconds": 157987269
    },
    {
        "id": 1005,
        "name": "Codeforces Round 496 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1531150500,
        "relativeTimeSeconds": 158329269
    },
    {
        "id": 1002,
        "name": "Microsoft Q# Coding Contest - Summer 2018",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1530892800,
        "relativeTimeSeconds": 158586969
    },
    {
        "id": 1004,
        "name": "Codeforces Round 495 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1530808500,
        "relativeTimeSeconds": 158671269
    },
    {
        "id": 1003,
        "name": "Codeforces Round 494 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1530628500,
        "relativeTimeSeconds": 158851269
    },
    {
        "id": 997,
        "name": "Codeforces Round 493 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1530453900,
        "relativeTimeSeconds": 159025869
    },
    {
        "id": 998,
        "name": "Codeforces Round 493 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1530453900,
        "relativeTimeSeconds": 159025869
    },
    {
        "id": 1001,
        "name": "Microsoft Q# Coding Contest - Summer 2018 - Warmup",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1530288000,
        "relativeTimeSeconds": 159191769
    },
    {
        "id": 1000,
        "name": "Educational Codeforces Round 46 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1530110100,
        "relativeTimeSeconds": 159369669
    },
    {
        "id": 995,
        "name": "Codeforces Round 492 (Div. 1) [Thanks, uDebug!]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1529858100,
        "relativeTimeSeconds": 159621669
    },
    {
        "id": 996,
        "name": "Codeforces Round 492 (Div. 2) [Thanks, uDebug!]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1529858100,
        "relativeTimeSeconds": 159621669
    },
    {
        "id": 991,
        "name": "Codeforces Round 491 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1529768100,
        "relativeTimeSeconds": 159711669
    },
    {
        "id": 999,
        "name": "Codeforces Round 490 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1529591700,
        "relativeTimeSeconds": 159888069
    },
    {
        "id": 992,
        "name": "Codeforces Round 489 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1529339700,
        "relativeTimeSeconds": 160140069
    },
    {
        "id": 993,
        "name": "Codeforces Round 488 by NEAR (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1529166900,
        "relativeTimeSeconds": 160312869
    },
    {
        "id": 994,
        "name": "Codeforces Round 488 by NEAR (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1529166900,
        "relativeTimeSeconds": 160312869
    },
    {
        "id": 989,
        "name": "Codeforces Round 487 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1528724100,
        "relativeTimeSeconds": 160755669
    },
    {
        "id": 990,
        "name": "Educational Codeforces Round 45 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1528625100,
        "relativeTimeSeconds": 160854669
    },
    {
        "id": 988,
        "name": "Codeforces Round 486 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1527863700,
        "relativeTimeSeconds": 161616069
    },
    {
        "id": 986,
        "name": "Codeforces Round 485 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1527608100,
        "relativeTimeSeconds": 161871669
    },
    {
        "id": 987,
        "name": "Codeforces Round 485 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1527608100,
        "relativeTimeSeconds": 161871669
    },
    {
        "id": 981,
        "name": "Avito Code Challenge 2018",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1527432600,
        "relativeTimeSeconds": 162047169
    },
    {
        "id": 985,
        "name": "Educational Codeforces Round 44 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1526913900,
        "relativeTimeSeconds": 162565869
    },
    {
        "id": 982,
        "name": "Codeforces Round 484 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1526574900,
        "relativeTimeSeconds": 162904869
    },
    {
        "id": 983,
        "name": "Codeforces Round 483 (Div. 1) [Thanks, Botan Investments and Victor Shaburov!]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1526395500,
        "relativeTimeSeconds": 163084269
    },
    {
        "id": 984,
        "name": "Codeforces Round 483 (Div. 2) [Thanks, Botan Investments and Victor Shaburov!]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1526395500,
        "relativeTimeSeconds": 163084269
    },
    {
        "id": 979,
        "name": "Codeforces Round 482 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1526308500,
        "relativeTimeSeconds": 163171269
    },
    {
        "id": 978,
        "name": "Codeforces Round 481 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1526202300,
        "relativeTimeSeconds": 163277469
    },
    {
        "id": 980,
        "name": "Codeforces Round 480 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1525791900,
        "relativeTimeSeconds": 163687869
    },
    {
        "id": 977,
        "name": "Codeforces Round 479 (Div. 3)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1525615500,
        "relativeTimeSeconds": 163864269
    },
    {
        "id": 975,
        "name": "Codeforces Round 478 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1525183500,
        "relativeTimeSeconds": 164296269
    },
    {
        "id": 976,
        "name": "Educational Codeforces Round 43 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1525099200,
        "relativeTimeSeconds": 164380569
    },
    {
        "id": 925,
        "name": "VK Cup 2018 - Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1525007700,
        "relativeTimeSeconds": 164472069
    },
    {
        "id": 966,
        "name": "Codeforces Round 477 (rated, Div. 1, based on VK Cup 2018 Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1525007700,
        "relativeTimeSeconds": 164472069
    },
    {
        "id": 967,
        "name": "Codeforces Round 477 (rated, Div. 2, based on VK Cup 2018 Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1525007700,
        "relativeTimeSeconds": 164472069
    },
    {
        "id": 965,
        "name": "Codeforces Round 476 (Div. 2) [Thanks, Telegram!]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1524677700,
        "relativeTimeSeconds": 164802069
    },
    {
        "id": 927,
        "name": "VK Cup 2018 - Wild-card Round 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1524152100,
        "relativeTimeSeconds": 165327669
    },
    {
        "id": 963,
        "name": "Tinkoff Internship Warmup Round 2018 and Codeforces Round 475 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1523973900,
        "relativeTimeSeconds": 165505869
    },
    {
        "id": 964,
        "name": "Tinkoff Internship Warmup Round 2018 and Codeforces Round 475 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1523973900,
        "relativeTimeSeconds": 165505869
    },
    {
        "id": 958,
        "name": "Helvetic Coding Contest 2018 online mirror (teams allowed, unrated)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1523689500,
        "relativeTimeSeconds": 165790269
    },
    {
        "id": 962,
        "name": "Educational Codeforces Round 42 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1523370900,
        "relativeTimeSeconds": 166108869
    },
    {
        "id": 960,
        "name": "Divide by Zero 2018 and Codeforces Round 474 (Div. 1 + Div. 2, combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1523117100,
        "relativeTimeSeconds": 166362669
    },
    {
        "id": 961,
        "name": "Educational Codeforces Round 41 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1522850700,
        "relativeTimeSeconds": 166629069
    },
    {
        "id": 959,
        "name": "Codeforces Round 473 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1522771500,
        "relativeTimeSeconds": 166708269
    },
    {
        "id": 952,
        "name": "April Fools Contest 2018",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1522596900,
        "relativeTimeSeconds": 166882869
    },
    {
        "id": 924,
        "name": "VK Cup 2018 - Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1521905700,
        "relativeTimeSeconds": 167574069
    },
    {
        "id": 956,
        "name": "Codeforces Round 472 (rated, Div. 1, based on VK Cup 2018 Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1521905700,
        "relativeTimeSeconds": 167574069
    },
    {
        "id": 957,
        "name": "Codeforces Round 472 (rated, Div. 2, based on VK Cup 2018 Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1521905700,
        "relativeTimeSeconds": 167574069
    },
    {
        "id": 955,
        "name": "Codeforces Round 471 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1521822900,
        "relativeTimeSeconds": 167656869
    },
    {
        "id": 954,
        "name": "Educational Codeforces Round 40 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1521698700,
        "relativeTimeSeconds": 167781069
    },
    {
        "id": 926,
        "name": "VK Cup 2018 - Wild-card Round 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1521300900,
        "relativeTimeSeconds": 168178869
    },
    {
        "id": 953,
        "name": "VK Cup 2018 - Wild-card Round 1 (unofficial unrated mirror)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1521300900,
        "relativeTimeSeconds": 168178869
    },
    {
        "id": 923,
        "name": "VK Cup 2018 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1520696100,
        "relativeTimeSeconds": 168783669
    },
    {
        "id": 947,
        "name": "Codeforces Round 470 (rated, Div. 1, based on VK Cup 2018 Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1520696100,
        "relativeTimeSeconds": 168783669
    },
    {
        "id": 948,
        "name": "Codeforces Round 470 (rated, Div. 2, based on VK Cup 2018 Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1520696100,
        "relativeTimeSeconds": 168783669
    },
    {
        "id": 949,
        "name": "Codeforces Round 469 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1520583000,
        "relativeTimeSeconds": 168896769
    },
    {
        "id": 950,
        "name": "Codeforces Round 469 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1520583000,
        "relativeTimeSeconds": 168896769
    },
    {
        "id": 946,
        "name": "Educational Codeforces Round 39 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1520348700,
        "relativeTimeSeconds": 169131069
    },
    {
        "id": 930,
        "name": "Codeforces Round 468 (Div. 1, based on Technocup 2018 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1520177700,
        "relativeTimeSeconds": 169302069
    },
    {
        "id": 931,
        "name": "Codeforces Round 468 (Div. 2, based on Technocup 2018 Final Round)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1520177700,
        "relativeTimeSeconds": 169302069
    },
    {
        "id": 944,
        "name": "Технокубок 2018 - Финал (только для онсайт-финалистов)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1520152800,
        "relativeTimeSeconds": 169326969
    },
    {
        "id": 929,
        "name": "VK Cup 2018 - Квалификация 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1520004900,
        "relativeTimeSeconds": 169474870
    },
    {
        "id": 936,
        "name": "Codeforces Round 467 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1519574700,
        "relativeTimeSeconds": 169905069
    },
    {
        "id": 937,
        "name": "Codeforces Round 467 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1519574700,
        "relativeTimeSeconds": 169905069
    },
    {
        "id": 928,
        "name": "VK Cup 2018 - Квалификация 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1519486500,
        "relativeTimeSeconds": 169993270
    },
    {
        "id": 940,
        "name": "Codeforces Round 466 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1519464900,
        "relativeTimeSeconds": 170014869
    },
    {
        "id": 935,
        "name": "Codeforces Round 465 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1519058100,
        "relativeTimeSeconds": 170421669
    },
    {
        "id": 939,
        "name": "Codeforces Round 464 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1518861900,
        "relativeTimeSeconds": 170617869
    },
    {
        "id": 938,
        "name": "Educational Codeforces Round 38 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1518793500,
        "relativeTimeSeconds": 170686269
    },
    {
        "id": 932,
        "name": "ICM Technex 2018 and Codeforces Round 463 (Div. 1 + Div. 2, combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1518705300,
        "relativeTimeSeconds": 170774469
    },
    {
        "id": 933,
        "name": "Codeforces Round 462 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1518609900,
        "relativeTimeSeconds": 170869869
    },
    {
        "id": 934,
        "name": "Codeforces Round 462 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1518609900,
        "relativeTimeSeconds": 170869869
    },
    {
        "id": 922,
        "name": "Codeforces Round 461 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1518023700,
        "relativeTimeSeconds": 171456069
    },
    {
        "id": 920,
        "name": "Educational Codeforces Round 37 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1517582100,
        "relativeTimeSeconds": 171897669
    },
    {
        "id": 921,
        "name": "AIM Tech Mini Marathon 1",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1517500800,
        "relativeTimeSeconds": 171978969
    },
    {
        "id": 919,
        "name": "Codeforces Round 460 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1517403900,
        "relativeTimeSeconds": 172075869
    },
    {
        "id": 917,
        "name": "Codeforces Round 459 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1517236500,
        "relativeTimeSeconds": 172243269
    },
    {
        "id": 918,
        "name": "Codeforces Round 459 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1517236500,
        "relativeTimeSeconds": 172243269
    },
    {
        "id": 914,
        "name": "Codecraft-18 and Codeforces Round 458 (Div. 1 + Div. 2, combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1516462500,
        "relativeTimeSeconds": 173017269
    },
    {
        "id": 916,
        "name": "Codeforces Round 457 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1516372500,
        "relativeTimeSeconds": 173107269
    },
    {
        "id": 915,
        "name": "Educational Codeforces Round 36 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1515848700,
        "relativeTimeSeconds": 173631069
    },
    {
        "id": 913,
        "name": "Hello 2018",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1515422700,
        "relativeTimeSeconds": 174057069
    },
    {
        "id": 912,
        "name": "Codeforces Round 456 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1515162900,
        "relativeTimeSeconds": 174316869
    },
    {
        "id": 908,
        "name": "Good Bye 2017",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1514562000,
        "relativeTimeSeconds": 174917769
    },
    {
        "id": 911,
        "name": "Educational Codeforces Round 35 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1514469900,
        "relativeTimeSeconds": 175009869
    },
    {
        "id": 909,
        "name": "Codeforces Round 455 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1514392500,
        "relativeTimeSeconds": 175087269
    },
    {
        "id": 904,
        "name": "Технокубок 2018 - Отборочный Раунд 4",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1514037900,
        "relativeTimeSeconds": 175441870
    },
    {
        "id": 906,
        "name": "Codeforces Round 454 (Div. 1, based on Technocup 2018 Elimination Round 4)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1514037900,
        "relativeTimeSeconds": 175441869
    },
    {
        "id": 907,
        "name": "Codeforces Round 454 (Div. 2, based on Technocup 2018 Elimination Round 4)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1514037900,
        "relativeTimeSeconds": 175441869
    },
    {
        "id": 910,
        "name": "Testing Round 14 (Unrated)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 5400,
        "startTimeSeconds": 1513940700,
        "relativeTimeSeconds": 175539069
    },
    {
        "id": 905,
        "name": "Технокубок 2018 - Ознакомительный Раунд 4",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1513861200,
        "relativeTimeSeconds": 175618570
    },
    {
        "id": 901,
        "name": "Codeforces Round 453 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1513697700,
        "relativeTimeSeconds": 175782069
    },
    {
        "id": 902,
        "name": "Codeforces Round 453 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1513697700,
        "relativeTimeSeconds": 175782069
    },
    {
        "id": 899,
        "name": "Codeforces Round 452 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1513492500,
        "relativeTimeSeconds": 175987269
    },
    {
        "id": 898,
        "name": "Codeforces Round 451 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1513424100,
        "relativeTimeSeconds": 176055669
    },
    {
        "id": 903,
        "name": "Educational Codeforces Round 34 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1513091100,
        "relativeTimeSeconds": 176388669
    },
    {
        "id": 900,
        "name": "Codeforces Round 450 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1513008300,
        "relativeTimeSeconds": 176471469
    },
    {
        "id": 896,
        "name": "Codeforces Round 449 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1512223500,
        "relativeTimeSeconds": 177256269
    },
    {
        "id": 897,
        "name": "Codeforces Round 449 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1512223500,
        "relativeTimeSeconds": 177256269
    },
    {
        "id": 895,
        "name": "Codeforces Round 448 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1511712300,
        "relativeTimeSeconds": 177767469
    },
    {
        "id": 893,
        "name": "Educational Codeforces Round 33 (Rated for Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1511449500,
        "relativeTimeSeconds": 178030269
    },
    {
        "id": 894,
        "name": "Codeforces Round 447 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1511099700,
        "relativeTimeSeconds": 178380069
    },
    {
        "id": 891,
        "name": "Codeforces Round 446 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1510929300,
        "relativeTimeSeconds": 178550469
    },
    {
        "id": 892,
        "name": "Codeforces Round 446 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1510929300,
        "relativeTimeSeconds": 178550469
    },
    {
        "id": 886,
        "name": "Технокубок 2018 - Отборочный Раунд 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1510502700,
        "relativeTimeSeconds": 178977070
    },
    {
        "id": 889,
        "name": "Codeforces Round 445 (Div. 1, based on Technocup 2018 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1510502700,
        "relativeTimeSeconds": 178977069
    },
    {
        "id": 890,
        "name": "Codeforces Round 445 (Div. 2, based on Technocup 2018 Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1510502700,
        "relativeTimeSeconds": 178977069
    },
    {
        "id": 888,
        "name": "Educational Codeforces Round 32",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1510239900,
        "relativeTimeSeconds": 179239869
    },
    {
        "id": 885,
        "name": "Технокубок 2018 - Ознакомительный Раунд 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1510239600,
        "relativeTimeSeconds": 179240170
    },
    {
        "id": 887,
        "name": "Codeforces Round 444 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1509725100,
        "relativeTimeSeconds": 179754669
    },
    {
        "id": 884,
        "name": "Educational Codeforces Round 31",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1509113100,
        "relativeTimeSeconds": 180366669
    },
    {
        "id": 878,
        "name": "Codeforces Round 443 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1509029100,
        "relativeTimeSeconds": 180450669
    },
    {
        "id": 879,
        "name": "Codeforces Round 443 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1509029100,
        "relativeTimeSeconds": 180450669
    },
    {
        "id": 877,
        "name": "Codeforces Round 442 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1508773500,
        "relativeTimeSeconds": 180706269
    },
    {
        "id": 883,
        "name": "2017-2018 ACM-ICPC, NEERC, Southern Subregional Contest (Online Mirror, ACM-ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1508573100,
        "relativeTimeSeconds": 180906669
    },
    {
        "id": 875,
        "name": "Codeforces Round 441 (Div. 1, by Moscow Team Olympiad)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1508151900,
        "relativeTimeSeconds": 181327869
    },
    {
        "id": 876,
        "name": "Codeforces Round 441 (Div. 2, by Moscow Team Olympiad)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1508151900,
        "relativeTimeSeconds": 181327869
    },
    {
        "id": 870,
        "name": "Technocup 2018 - Elimination Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1508054700,
        "relativeTimeSeconds": 181425069
    },
    {
        "id": 871,
        "name": "Codeforces Round 440 (Div. 1, based on Technocup 2018 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1508054700,
        "relativeTimeSeconds": 181425069
    },
    {
        "id": 872,
        "name": "Codeforces Round 440 (Div. 2, based on Technocup 2018 Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1508054700,
        "relativeTimeSeconds": 181425069
    },
    {
        "id": 873,
        "name": "Educational Codeforces Round 30",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1507817100,
        "relativeTimeSeconds": 181662669
    },
    {
        "id": 874,
        "name": "Technocup 2018 - Practice Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1507791600,
        "relativeTimeSeconds": 181688169
    },
    {
        "id": 869,
        "name": "Codeforces Round 439 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1507296900,
        "relativeTimeSeconds": 182182869
    },
    {
        "id": 868,
        "name": "Codeforces Round 438 by Sberbank and Barcelona Bootcamp (Div. 1 + Div. 2 combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1507187100,
        "relativeTimeSeconds": 182292669
    },
    {
        "id": 865,
        "name": "MemSQL Start[c]UP 3.0 - Round 2 (onsite finalists)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1506791100,
        "relativeTimeSeconds": 182688669
    },
    {
        "id": 866,
        "name": "MemSQL Start[c]UP 3.0 - Round 2 and Codeforces Round 437 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1506791100,
        "relativeTimeSeconds": 182688669
    },
    {
        "id": 867,
        "name": "Codeforces Round 437 (Div. 2, based on MemSQL Start[c]UP 3.0 - Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1506791100,
        "relativeTimeSeconds": 182688669
    },
    {
        "id": 864,
        "name": "Codeforces Round 436 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1506335700,
        "relativeTimeSeconds": 183144069
    },
    {
        "id": 855,
        "name": "Manthan, Codefest 17",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1506263700,
        "relativeTimeSeconds": 183216069
    },
    {
        "id": 863,
        "name": "Educational Codeforces Round 29",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1506006300,
        "relativeTimeSeconds": 183473469
    },
    {
        "id": 862,
        "name": "Codeforces Round 435 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1505833500,
        "relativeTimeSeconds": 183646269
    },
    {
        "id": 847,
        "name": "2017-2018 ACM-ICPC, NEERC, Southern Subregional Contest, qualification stage (Online Mirror, ACM-ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 14400,
        "startTimeSeconds": 1505739900,
        "relativeTimeSeconds": 183739869
    },
    {
        "id": 858,
        "name": "Технокубок 2018 - Отборочный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8400,
        "startTimeSeconds": 1505653500,
        "relativeTimeSeconds": 183826270
    },
    {
        "id": 860,
        "name": "Codeforces Round 434 (Div. 1, based on Technocup 2018 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8400,
        "startTimeSeconds": 1505653500,
        "relativeTimeSeconds": 183826269
    },
    {
        "id": 861,
        "name": "Codeforces Round 434 (Div. 2, based on Technocup 2018 Elimination Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8400,
        "startTimeSeconds": 1505653500,
        "relativeTimeSeconds": 183826269
    },
    {
        "id": 859,
        "name": "MemSQL Start[c]UP 3.0 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1505583300,
        "relativeTimeSeconds": 183896469
    },
    {
        "id": 857,
        "name": "Технокубок 2018 - Ознакомительный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1505390400,
        "relativeTimeSeconds": 184089370
    },
    {
        "id": 856,
        "name": "Russian Code Cup 2017 - Finals [Unofficial Mirror, Div. 1 Only Recommended, Teams Allowed]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1505050500,
        "relativeTimeSeconds": 184429269
    },
    {
        "id": 853,
        "name": "Codeforces Round 433 (Div. 1, based on Olympiad of Metropolises)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1504702500,
        "relativeTimeSeconds": 184777269
    },
    {
        "id": 854,
        "name": "Codeforces Round 433 (Div. 2, based on Olympiad of Metropolises)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1504702500,
        "relativeTimeSeconds": 184777269
    },
    {
        "id": 846,
        "name": "Educational Codeforces Round 28",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1504623900,
        "relativeTimeSeconds": 184855869
    },
    {
        "id": 850,
        "name": "Codeforces Round 432 (Div. 1, based on IndiaHacks Final Round 2017)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1504535700,
        "relativeTimeSeconds": 184944069
    },
    {
        "id": 851,
        "name": "Codeforces Round 432 (Div. 2, based on IndiaHacks Final Round 2017)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1504535700,
        "relativeTimeSeconds": 184944069
    },
    {
        "id": 852,
        "name": "Bubble Cup X - Finals [Online Mirror]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1504432800,
        "relativeTimeSeconds": 185046969
    },
    {
        "id": 848,
        "name": "Codeforces Round 431 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1504272900,
        "relativeTimeSeconds": 185206869
    },
    {
        "id": 849,
        "name": "Codeforces Round 431 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1504272900,
        "relativeTimeSeconds": 185206869
    },
    {
        "id": 842,
        "name": "Codeforces Round 430 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1504019100,
        "relativeTimeSeconds": 185460669
    },
    {
        "id": 843,
        "name": "AIM Tech Round 4 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1503592500,
        "relativeTimeSeconds": 185887269
    },
    {
        "id": 844,
        "name": "AIM Tech Round 4 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1503592500,
        "relativeTimeSeconds": 185887269
    },
    {
        "id": 845,
        "name": "Educational Codeforces Round 27",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1503327900,
        "relativeTimeSeconds": 186151869
    },
    {
        "id": 840,
        "name": "Codeforces Round 429 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1503068700,
        "relativeTimeSeconds": 186411069
    },
    {
        "id": 841,
        "name": "Codeforces Round 429 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1503068700,
        "relativeTimeSeconds": 186411069
    },
    {
        "id": 839,
        "name": "Codeforces Round 428 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1502548500,
        "relativeTimeSeconds": 186931269
    },
    {
        "id": 838,
        "name": "IndiaHacks 2nd Elimination 2017 (unofficial, unrated mirror, ICPC rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1502085900,
        "relativeTimeSeconds": 187393869
    },
    {
        "id": 837,
        "name": "Educational Codeforces Round 26",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1501773300,
        "relativeTimeSeconds": 187706469
    },
    {
        "id": 835,
        "name": "Codeforces Round 427 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1501511700,
        "relativeTimeSeconds": 187968069
    },
    {
        "id": 833,
        "name": "Codeforces Round 426 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1501425300,
        "relativeTimeSeconds": 188054469
    },
    {
        "id": 834,
        "name": "Codeforces Round 426 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1501425300,
        "relativeTimeSeconds": 188054469
    },
    {
        "id": 832,
        "name": "Codeforces Round 425 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1500906900,
        "relativeTimeSeconds": 188572869
    },
    {
        "id": 825,
        "name": "Educational Codeforces Round 25",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1500217500,
        "relativeTimeSeconds": 189262269
    },
    {
        "id": 830,
        "name": "Codeforces Round 424 (Div. 1, rated, based on VK Cup Finals)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1499958300,
        "relativeTimeSeconds": 189521469
    },
    {
        "id": 831,
        "name": "Codeforces Round 424 (Div. 2, rated, based on VK Cup Finals)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1499958300,
        "relativeTimeSeconds": 189521469
    },
    {
        "id": 827,
        "name": "Codeforces Round 423 (Div. 1, rated, based on VK Cup Finals)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1499791500,
        "relativeTimeSeconds": 189688269
    },
    {
        "id": 828,
        "name": "Codeforces Round 423 (Div. 2, rated, based on VK Cup Finals)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1499791500,
        "relativeTimeSeconds": 189688269
    },
    {
        "id": 823,
        "name": "VK Cup 2017 - Finals",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1499587500,
        "relativeTimeSeconds": 189892269
    },
    {
        "id": 826,
        "name": "VK Cup 2017 - Finals (practice session)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 4800,
        "startTimeSeconds": 1499502000,
        "relativeTimeSeconds": 189977769
    },
    {
        "id": 822,
        "name": "Codeforces Round 422 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1499011500,
        "relativeTimeSeconds": 190468269
    },
    {
        "id": 818,
        "name": "Educational Codeforces Round 24",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1498748700,
        "relativeTimeSeconds": 190731069
    },
    {
        "id": 819,
        "name": "Codeforces Round 421 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1498574100,
        "relativeTimeSeconds": 190905669
    },
    {
        "id": 820,
        "name": "Codeforces Round 421 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1498574100,
        "relativeTimeSeconds": 190905669
    },
    {
        "id": 821,
        "name": "Codeforces Round 420 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1498401300,
        "relativeTimeSeconds": 191078469
    },
    {
        "id": 815,
        "name": "Codeforces Round 419 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1497710100,
        "relativeTimeSeconds": 191769669
    },
    {
        "id": 816,
        "name": "Codeforces Round 419 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1497710100,
        "relativeTimeSeconds": 191769669
    },
    {
        "id": 817,
        "name": "Educational Codeforces Round 23",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1497539100,
        "relativeTimeSeconds": 191940669
    },
    {
        "id": 814,
        "name": "Codeforces Round 418 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1496837700,
        "relativeTimeSeconds": 192642069
    },
    {
        "id": 813,
        "name": "Educational Codeforces Round 22",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1496675100,
        "relativeTimeSeconds": 192804669
    },
    {
        "id": 812,
        "name": "Codeforces Round 417 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1496326500,
        "relativeTimeSeconds": 193153269
    },
    {
        "id": 802,
        "name": "Helvetic Coding Contest 2017 online mirror (teams allowed, unrated)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 16200,
        "startTimeSeconds": 1495958700,
        "relativeTimeSeconds": 193521069
    },
    {
        "id": 811,
        "name": "Codeforces Round 416 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1495877700,
        "relativeTimeSeconds": 193602069
    },
    {
        "id": 809,
        "name": "Codeforces Round 415 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1495303500,
        "relativeTimeSeconds": 194176269
    },
    {
        "id": 810,
        "name": "Codeforces Round 415 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1495303500,
        "relativeTimeSeconds": 194176269
    },
    {
        "id": 808,
        "name": "Educational Codeforces Round 21",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1494860700,
        "relativeTimeSeconds": 194619069
    },
    {
        "id": 794,
        "name": "Tinkoff Challenge - Final Round (Codeforces Round 414, rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1494668100,
        "relativeTimeSeconds": 194811669
    },
    {
        "id": 799,
        "name": "Playrix Codescapes Cup (Codeforces Round 413, rated, Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1494516900,
        "relativeTimeSeconds": 194962869
    },
    {
        "id": 773,
        "name": "VK Cup 2017 - Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1494171900,
        "relativeTimeSeconds": 195307869
    },
    {
        "id": 806,
        "name": "Codeforces Round 412 (rated, Div. 1, based on VK Cup 2017 Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1494171900,
        "relativeTimeSeconds": 195307869
    },
    {
        "id": 807,
        "name": "Codeforces Round 412 (rated, Div. 2, base on VK Cup 2017 Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1494171900,
        "relativeTimeSeconds": 195307869
    },
    {
        "id": 804,
        "name": "Codeforces Round 411 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1493909400,
        "relativeTimeSeconds": 195570369
    },
    {
        "id": 805,
        "name": "Codeforces Round 411 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1493909400,
        "relativeTimeSeconds": 195570369
    },
    {
        "id": 803,
        "name": "Educational Codeforces Round 20",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1493391900,
        "relativeTimeSeconds": 196087869
    },
    {
        "id": 775,
        "name": "VK Cup 2017 - Wild Card Round 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1493220900,
        "relativeTimeSeconds": 196258869
    },
    {
        "id": 793,
        "name": "Tinkoff Challenge - Elimination Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1492965900,
        "relativeTimeSeconds": 196513869
    },
    {
        "id": 798,
        "name": "Codeforces Round 410 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1492785300,
        "relativeTimeSeconds": 196694469
    },
    {
        "id": 772,
        "name": "VK Cup 2017 - Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1492356900,
        "relativeTimeSeconds": 197122869
    },
    {
        "id": 800,
        "name": "Codeforces Round 409 (rated, Div. 1, based on VK Cup 2017 Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1492356900,
        "relativeTimeSeconds": 197122869
    },
    {
        "id": 801,
        "name": "Codeforces Round 409 (rated, Div. 2, based on VK Cup 2017 Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1492356900,
        "relativeTimeSeconds": 197122869
    },
    {
        "id": 797,
        "name": "Educational Codeforces Round 19",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1492266900,
        "relativeTimeSeconds": 197212869
    },
    {
        "id": 796,
        "name": "Codeforces Round 408 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1491842100,
        "relativeTimeSeconds": 197637669
    },
    {
        "id": 774,
        "name": "VK Cup 2017 - Wild Card Round 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1491406500,
        "relativeTimeSeconds": 198073269
    },
    {
        "id": 795,
        "name": "VK Cup 2017 - Wild Card Round 1 (Unofficial Public Mirror)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1491406500,
        "relativeTimeSeconds": 198073269
    },
    {
        "id": 784,
        "name": "April Fools Contest 2017",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1490972400,
        "relativeTimeSeconds": 198507369
    },
    {
        "id": 788,
        "name": "Codeforces Round 407 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1490803500,
        "relativeTimeSeconds": 198676269
    },
    {
        "id": 789,
        "name": "Codeforces Round 407 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1490803500,
        "relativeTimeSeconds": 198676269
    },
    {
        "id": 792,
        "name": "Educational Codeforces Round 18",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1490625300,
        "relativeTimeSeconds": 198854469
    },
    {
        "id": 786,
        "name": "Codeforces Round 406 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1490281500,
        "relativeTimeSeconds": 199198269
    },
    {
        "id": 787,
        "name": "Codeforces Round 406 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1490281500,
        "relativeTimeSeconds": 199198269
    },
    {
        "id": 771,
        "name": "VK Cup 2017 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1489851300,
        "relativeTimeSeconds": 199628469
    },
    {
        "id": 790,
        "name": "Codeforces Round 405 (rated, Div. 1, based on VK Cup 2017 Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1489851300,
        "relativeTimeSeconds": 199628469
    },
    {
        "id": 791,
        "name": "Codeforces Round 405 (rated, Div. 2, based on VK Cup 2017 Round 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1489851300,
        "relativeTimeSeconds": 199628469
    },
    {
        "id": 785,
        "name": "Codeforces Round 404 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1489590300,
        "relativeTimeSeconds": 199889469
    },
    {
        "id": 770,
        "name": "VK Cup 2017 - Qualification 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1489233600,
        "relativeTimeSeconds": 200246169
    },
    {
        "id": 781,
        "name": "Codeforces Round 403 (Div. 1, based on Technocup 2017 Finals)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1488719100,
        "relativeTimeSeconds": 200760669
    },
    {
        "id": 782,
        "name": "Codeforces Round 403 (Div. 2, based on Technocup 2017 Finals)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1488719100,
        "relativeTimeSeconds": 200760669
    },
    {
        "id": 780,
        "name": "Технокубок 2017 - Финал (только для онсайт-финалистов)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1488705300,
        "relativeTimeSeconds": 200774470
    },
    {
        "id": 769,
        "name": "VK Cup 2017 - Qualification 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1488628800,
        "relativeTimeSeconds": 200850969
    },
    {
        "id": 778,
        "name": "Codeforces Round 402 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1488096300,
        "relativeTimeSeconds": 201383469
    },
    {
        "id": 779,
        "name": "Codeforces Round 402 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1488096300,
        "relativeTimeSeconds": 201383469
    },
    {
        "id": 777,
        "name": "Codeforces Round 401 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1487930700,
        "relativeTimeSeconds": 201549069
    },
    {
        "id": 776,
        "name": "ICM Technex 2017 and Codeforces Round 400 (Div. 1 + Div. 2, combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1487861100,
        "relativeTimeSeconds": 201618669
    },
    {
        "id": 768,
        "name": "Divide by Zero 2017 and Codeforces Round 399 (Div. 1 + Div. 2, combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9600,
        "startTimeSeconds": 1487606700,
        "relativeTimeSeconds": 201873069
    },
    {
        "id": 767,
        "name": "Codeforces Round 398 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1487408700,
        "relativeTimeSeconds": 202071069
    },
    {
        "id": 765,
        "name": "Codeforces Round 397 by Kaspersky Lab and Barcelona Bootcamp (Div. 1 + Div. 2 combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1487059500,
        "relativeTimeSeconds": 202420269
    },
    {
        "id": 766,
        "name": "Codeforces Round 396 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1486487100,
        "relativeTimeSeconds": 202992669
    },
    {
        "id": 763,
        "name": "Codeforces Round 395 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1486042500,
        "relativeTimeSeconds": 203437269
    },
    {
        "id": 764,
        "name": "Codeforces Round 395 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1486042500,
        "relativeTimeSeconds": 203437269
    },
    {
        "id": 761,
        "name": "Codeforces Round 394 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1485873300,
        "relativeTimeSeconds": 203606469
    },
    {
        "id": 762,
        "name": "Educational Codeforces Round 17",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1485354900,
        "relativeTimeSeconds": 204124869
    },
    {
        "id": 756,
        "name": "8VC Venture Cup 2017 - Final Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1485108900,
        "relativeTimeSeconds": 204370869
    },
    {
        "id": 759,
        "name": "Codeforces Round 393 (Div. 1) (8VC Venture Cup 2017 - Final Round Div. 1 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1485108900,
        "relativeTimeSeconds": 204370869
    },
    {
        "id": 760,
        "name": "Codeforces Round 393 (Div. 2) (8VC Venture Cup 2017 - Final Round Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1485108900,
        "relativeTimeSeconds": 204370869
    },
    {
        "id": 758,
        "name": "Codeforces Round 392 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1484838300,
        "relativeTimeSeconds": 204641469
    },
    {
        "id": 755,
        "name": "8VC Venture Cup 2017 - Elimination Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1484499900,
        "relativeTimeSeconds": 204979869
    },
    {
        "id": 757,
        "name": "Codecraft-17 and Codeforces Round 391 (Div. 1 + Div. 2, combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1484235300,
        "relativeTimeSeconds": 205244469
    },
    {
        "id": 754,
        "name": "Codeforces Round 390 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1483713300,
        "relativeTimeSeconds": 205766469
    },
    {
        "id": 750,
        "name": "Good Bye 2016",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1483107300,
        "relativeTimeSeconds": 206372469
    },
    {
        "id": 753,
        "name": "Testing Round 13",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 4500,
        "startTimeSeconds": 1483002300,
        "relativeTimeSeconds": 206477469
    },
    {
        "id": 748,
        "name": "Technocup 2017 - Elimination Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1482656700,
        "relativeTimeSeconds": 206823069
    },
    {
        "id": 752,
        "name": "Codeforces Round 389 (Div. 2, Rated, Based on Technocup 2017 - Elimination Round 3)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1482656700,
        "relativeTimeSeconds": 206823069
    },
    {
        "id": 751,
        "name": "Технокубок 2017 - Ознакомительный Раунд 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 257400,
        "startTimeSeconds": 1482395400,
        "relativeTimeSeconds": 207084370
    },
    {
        "id": 749,
        "name": "Codeforces Round 388 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1482165300,
        "relativeTimeSeconds": 207314469
    },
    {
        "id": 747,
        "name": "Codeforces Round 387 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1482113100,
        "relativeTimeSeconds": 207366669
    },
    {
        "id": 746,
        "name": "Codeforces Round 386 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1482057300,
        "relativeTimeSeconds": 207422469
    },
    {
        "id": 744,
        "name": "Codeforces Round 385 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1481992500,
        "relativeTimeSeconds": 207487269
    },
    {
        "id": 745,
        "name": "Codeforces Round 385 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1481992500,
        "relativeTimeSeconds": 207487269
    },
    {
        "id": 743,
        "name": "Codeforces Round 384 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1481726100,
        "relativeTimeSeconds": 207753669
    },
    {
        "id": 741,
        "name": "Codeforces Round 383 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1481034900,
        "relativeTimeSeconds": 208444869
    },
    {
        "id": 742,
        "name": "Codeforces Round 383 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1481034900,
        "relativeTimeSeconds": 208444869
    },
    {
        "id": 735,
        "name": "Codeforces Round 382 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1480264500,
        "relativeTimeSeconds": 209215269
    },
    {
        "id": 736,
        "name": "Codeforces Round 382 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1480264500,
        "relativeTimeSeconds": 209215269
    },
    {
        "id": 739,
        "name": "Codeforces Round 381 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1479918900,
        "relativeTimeSeconds": 209560869
    },
    {
        "id": 740,
        "name": "Codeforces Round 381 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1479918900,
        "relativeTimeSeconds": 209560869
    },
    {
        "id": 729,
        "name": "Technocup 2017 - Elimination Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1479632700,
        "relativeTimeSeconds": 209847069
    },
    {
        "id": 737,
        "name": "Codeforces Round 380 (Div. 1, Rated, Based on Technocup 2017 - Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1479632700,
        "relativeTimeSeconds": 209847069
    },
    {
        "id": 738,
        "name": "Codeforces Round 380 (Div. 2, Rated, Based on Technocup 2017 - Elimination Round 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1479632700,
        "relativeTimeSeconds": 209847069
    },
    {
        "id": 728,
        "name": "Технокубок 2017 - Ознакомительный Раунд 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 259200,
        "startTimeSeconds": 1479369600,
        "relativeTimeSeconds": 210110170
    },
    {
        "id": 734,
        "name": "Codeforces Round 379 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1479227700,
        "relativeTimeSeconds": 210252069
    },
    {
        "id": 733,
        "name": "Codeforces Round 378 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1477922700,
        "relativeTimeSeconds": 211557069
    },
    {
        "id": 730,
        "name": "2016-2017 ACM-ICPC, NEERC, Southern Subregional Contest (Online Mirror, ACM-ICPC Rules, Teams Preferred)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1477209600,
        "relativeTimeSeconds": 212270169
    },
    {
        "id": 725,
        "name": "Canada Cup 2016",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1477148700,
        "relativeTimeSeconds": 212331069
    },
    {
        "id": 732,
        "name": "Codeforces Round 377 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1476714900,
        "relativeTimeSeconds": 212764869
    },
    {
        "id": 731,
        "name": "Codeforces Round 376 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1476611100,
        "relativeTimeSeconds": 212868669
    },
    {
        "id": 727,
        "name": "Technocup 2017 - Elimination Round 1 (Unofficially Open for Everyone, Rated for Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1476522300,
        "relativeTimeSeconds": 212957469
    },
    {
        "id": 726,
        "name": "Технокубок 2017 - Ознакомительный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 255600,
        "startTimeSeconds": 1476262800,
        "relativeTimeSeconds": 213216970
    },
    {
        "id": 724,
        "name": "Intel Code Challenge Final Round (Div. 1 + Div. 2, Combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1475928900,
        "relativeTimeSeconds": 213550869
    },
    {
        "id": 723,
        "name": "Codeforces Round 375 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1475494500,
        "relativeTimeSeconds": 213985269
    },
    {
        "id": 722,
        "name": "Intel Code Challenge Elimination Round (Div. 1 + Div. 2, combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1475330700,
        "relativeTimeSeconds": 214149069
    },
    {
        "id": 721,
        "name": "Codeforces Round 374 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1475244300,
        "relativeTimeSeconds": 214235469
    },
    {
        "id": 718,
        "name": "Codeforces Round 373 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1474635900,
        "relativeTimeSeconds": 214843869
    },
    {
        "id": 719,
        "name": "Codeforces Round 373 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1474635900,
        "relativeTimeSeconds": 214843869
    },
    {
        "id": 720,
        "name": "Russian Code Cup 2016 - Finals [Unofficial Mirror, Div. 1 Only Recommended]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1474196700,
        "relativeTimeSeconds": 215283069
    },
    {
        "id": 715,
        "name": "Codeforces Round 372 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1474119900,
        "relativeTimeSeconds": 215359869
    },
    {
        "id": 716,
        "name": "Codeforces Round 372 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1474119900,
        "relativeTimeSeconds": 215359870
    },
    {
        "id": 713,
        "name": "Codeforces Round 371 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1473784500,
        "relativeTimeSeconds": 215695269
    },
    {
        "id": 714,
        "name": "Codeforces Round 371 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1473784500,
        "relativeTimeSeconds": 215695269
    },
    {
        "id": 717,
        "name": "Bubble Cup 9 - Finals [Online Mirror]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1473584400,
        "relativeTimeSeconds": 215895369
    },
    {
        "id": 712,
        "name": "Codeforces Round 370 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1473525900,
        "relativeTimeSeconds": 215953869
    },
    {
        "id": 711,
        "name": "Codeforces Round 369 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1472472300,
        "relativeTimeSeconds": 217007469
    },
    {
        "id": 708,
        "name": "AIM Tech Round 3 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1472056500,
        "relativeTimeSeconds": 217423269
    },
    {
        "id": 709,
        "name": "AIM Tech Round 3 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1472056500,
        "relativeTimeSeconds": 217423269
    },
    {
        "id": 710,
        "name": "Educational Codeforces Round 16",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1471875000,
        "relativeTimeSeconds": 217604769
    },
    {
        "id": 707,
        "name": "Codeforces Round 368 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1471698300,
        "relativeTimeSeconds": 217781469
    },
    {
        "id": 706,
        "name": "Codeforces Round 367 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1470933300,
        "relativeTimeSeconds": 218546469
    },
    {
        "id": 704,
        "name": "Codeforces Round 366 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1470578700,
        "relativeTimeSeconds": 218901069
    },
    {
        "id": 705,
        "name": "Codeforces Round 366 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1470578700,
        "relativeTimeSeconds": 218901069
    },
    {
        "id": 703,
        "name": "Codeforces Round 365 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1470323700,
        "relativeTimeSeconds": 219156069
    },
    {
        "id": 702,
        "name": "Educational Codeforces Round 15",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1469804400,
        "relativeTimeSeconds": 219675369
    },
    {
        "id": 700,
        "name": "Codeforces Round 364 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1469205300,
        "relativeTimeSeconds": 220274469
    },
    {
        "id": 701,
        "name": "Codeforces Round 364 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1469205300,
        "relativeTimeSeconds": 220274469
    },
    {
        "id": 698,
        "name": "Codeforces Round 363 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1468933500,
        "relativeTimeSeconds": 220546269
    },
    {
        "id": 699,
        "name": "Codeforces Round 363 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1468933500,
        "relativeTimeSeconds": 220546269
    },
    {
        "id": 696,
        "name": "Codeforces Round 362 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1468514100,
        "relativeTimeSeconds": 220965669
    },
    {
        "id": 697,
        "name": "Codeforces Round 362 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1468514100,
        "relativeTimeSeconds": 220965669
    },
    {
        "id": 691,
        "name": "Educational Codeforces Round 14",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1468425600,
        "relativeTimeSeconds": 221054169
    },
    {
        "id": 690,
        "name": "Helvetic Coding Contest 2016 online mirror (teams, unrated)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 16200,
        "startTimeSeconds": 1468137600,
        "relativeTimeSeconds": 221342169
    },
    {
        "id": 689,
        "name": "Codeforces Round 361 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1467822900,
        "relativeTimeSeconds": 221656869
    },
    {
        "id": 695,
        "name": "VK Cup 2016 - Finals",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 12600,
        "startTimeSeconds": 1467534000,
        "relativeTimeSeconds": 221945769
    },
    {
        "id": 693,
        "name": "VK Cup 2016 - Finals (trial contest)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 3600,
        "startTimeSeconds": 1467447900,
        "relativeTimeSeconds": 222031869
    },
    {
        "id": 687,
        "name": "Codeforces Round 360 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1467219900,
        "relativeTimeSeconds": 222259869
    },
    {
        "id": 688,
        "name": "Codeforces Round 360 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1467219900,
        "relativeTimeSeconds": 222259869
    },
    {
        "id": 685,
        "name": "Codeforces Round 359 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1466699700,
        "relativeTimeSeconds": 222780069
    },
    {
        "id": 686,
        "name": "Codeforces Round 359 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1466699700,
        "relativeTimeSeconds": 222780069
    },
    {
        "id": 682,
        "name": "Codeforces Round 358 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1466181300,
        "relativeTimeSeconds": 223298469
    },
    {
        "id": 683,
        "name": "Surprise Language Round 8",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1466092800,
        "relativeTimeSeconds": 223386969
    },
    {
        "id": 681,
        "name": "Codeforces Round 357 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1465922100,
        "relativeTimeSeconds": 223557669
    },
    {
        "id": 678,
        "name": "Educational Codeforces Round 13",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1465834200,
        "relativeTimeSeconds": 223645569
    },
    {
        "id": 684,
        "name": "Codeforces Marathon Round 1",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 864000,
        "startTimeSeconds": 1465722000,
        "relativeTimeSeconds": 223757769
    },
    {
        "id": 679,
        "name": "Codeforces Round 356 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1465403700,
        "relativeTimeSeconds": 224076069
    },
    {
        "id": 680,
        "name": "Codeforces Round 356 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1465403700,
        "relativeTimeSeconds": 224076069
    },
    {
        "id": 677,
        "name": "Codeforces Round 355 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1464798900,
        "relativeTimeSeconds": 224680869
    },
    {
        "id": 676,
        "name": "Codeforces Round 354 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1464188700,
        "relativeTimeSeconds": 225291069
    },
    {
        "id": 675,
        "name": "Codeforces Round 353 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1463416500,
        "relativeTimeSeconds": 226063269
    },
    {
        "id": 671,
        "name": "Codeforces Round 352 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1462984500,
        "relativeTimeSeconds": 226495269
    },
    {
        "id": 672,
        "name": "Codeforces Round 352 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1462984500,
        "relativeTimeSeconds": 226495269
    },
    {
        "id": 643,
        "name": "VK Cup 2016 - Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1462633500,
        "relativeTimeSeconds": 226846269
    },
    {
        "id": 673,
        "name": "Codeforces Round 351 (VK Cup 2016 Round 3, Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1462633500,
        "relativeTimeSeconds": 226846269
    },
    {
        "id": 674,
        "name": "Codeforces Round 351 (VK Cup 2016 Round 3, Div. 1 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1462633500,
        "relativeTimeSeconds": 226846269
    },
    {
        "id": 670,
        "name": "Codeforces Round 350 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1462464300,
        "relativeTimeSeconds": 227015469
    },
    {
        "id": 666,
        "name": "Codeforces Round 349 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1461947700,
        "relativeTimeSeconds": 227532069
    },
    {
        "id": 667,
        "name": "Codeforces Round 349 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1461947700,
        "relativeTimeSeconds": 227532069
    },
    {
        "id": 642,
        "name": "VK Cup 2016 - Wild Card Round 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1461596400,
        "relativeTimeSeconds": 227883369
    },
    {
        "id": 641,
        "name": "VK Cup 2016 - Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1461515700,
        "relativeTimeSeconds": 227964069
    },
    {
        "id": 668,
        "name": "Codeforces Round 348 (VK Cup 2016 Round 2, Div. 1 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1461515700,
        "relativeTimeSeconds": 227964069
    },
    {
        "id": 669,
        "name": "Codeforces Round 348 (VK Cup 2016 Round 2, Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1461515700,
        "relativeTimeSeconds": 227964069
    },
    {
        "id": 665,
        "name": "Educational Codeforces Round 12",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1461164400,
        "relativeTimeSeconds": 228315369
    },
    {
        "id": 663,
        "name": "Codeforces Round 347 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1460824500,
        "relativeTimeSeconds": 228655269
    },
    {
        "id": 664,
        "name": "Codeforces Round 347 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1460824500,
        "relativeTimeSeconds": 228655269
    },
    {
        "id": 662,
        "name": "CROC 2016 - Final Round [Private, For Onsite Finalists Only]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1460729700,
        "relativeTimeSeconds": 228750069
    },
    {
        "id": 640,
        "name": "VK Cup 2016 - Wild Card Round 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1460306100,
        "relativeTimeSeconds": 229173669
    },
    {
        "id": 661,
        "name": "VK Cup 2016 - Wild Card Round 1 (Unofficial Open Online Mirror)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1460306100,
        "relativeTimeSeconds": 229173669
    },
    {
        "id": 660,
        "name": "Educational Codeforces Round 11",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1460127600,
        "relativeTimeSeconds": 229352169
    },
    {
        "id": 656,
        "name": "April Fools Day Contest 2016",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1459526400,
        "relativeTimeSeconds": 229953369
    },
    {
        "id": 659,
        "name": "Codeforces Round 346 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1459353900,
        "relativeTimeSeconds": 230125869
    },
    {
        "id": 639,
        "name": "VK Cup 2016 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1459182900,
        "relativeTimeSeconds": 230296869
    },
    {
        "id": 657,
        "name": "VK Cup 2016 - Round 1 (Div.1 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1459182900,
        "relativeTimeSeconds": 230296869
    },
    {
        "id": 658,
        "name": "VK Cup 2016 - Round 1 (Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1459182900,
        "relativeTimeSeconds": 230296869
    },
    {
        "id": 649,
        "name": "Технокубок 2016 - Отборочный Раунд 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1458975600,
        "relativeTimeSeconds": 230504170
    },
    {
        "id": 652,
        "name": "Educational Codeforces Round 10",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1458910800,
        "relativeTimeSeconds": 230568969
    },
    {
        "id": 647,
        "name": "Технокубок 2016 - Ознакомительный Раунд 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1458799200,
        "relativeTimeSeconds": 230680570
    },
    {
        "id": 648,
        "name": "Технокубок 2016 - Отборочный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1458745200,
        "relativeTimeSeconds": 230734570
    },
    {
        "id": 646,
        "name": "Технокубок 2016 - Ознакомительный Раунд 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1458568800,
        "relativeTimeSeconds": 230910970
    },
    {
        "id": 638,
        "name": "VK Cup 2016 - Qualification Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1458475200,
        "relativeTimeSeconds": 231004569
    },
    {
        "id": 653,
        "name": "IndiaHacks 2016 - Online Edition (Div. 1 + Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1458376500,
        "relativeTimeSeconds": 231103269
    },
    {
        "id": 645,
        "name": "CROC 2016 - Elimination Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1458318900,
        "relativeTimeSeconds": 231160869
    },
    {
        "id": 655,
        "name": "CROC 2016 - Elimination Round  (Rated Unofficial Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1458318900,
        "relativeTimeSeconds": 231160869
    },
    {
        "id": 644,
        "name": "CROC 2016 - Qualification",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1458118800,
        "relativeTimeSeconds": 231360969
    },
    {
        "id": 637,
        "name": "VK Cup 2016 - Qualification Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1457870400,
        "relativeTimeSeconds": 231609369
    },
    {
        "id": 650,
        "name": "Codeforces Round 345 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1457342700,
        "relativeTimeSeconds": 232137069
    },
    {
        "id": 651,
        "name": "Codeforces Round 345 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1457342700,
        "relativeTimeSeconds": 232137069
    },
    {
        "id": 631,
        "name": "Codeforces Round 344 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1457022900,
        "relativeTimeSeconds": 232456869
    },
    {
        "id": 632,
        "name": "Educational Codeforces Round 9",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1456844400,
        "relativeTimeSeconds": 232635369
    },
    {
        "id": 636,
        "name": "VeeRoute Marathon",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 1209600,
        "startTimeSeconds": 1456765200,
        "relativeTimeSeconds": 232714569
    },
    {
        "id": 627,
        "name": "8VC Venture Cup 2016 - Final Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1456683000,
        "relativeTimeSeconds": 232796769
    },
    {
        "id": 634,
        "name": "8VC Venture Cup 2016 - Final Round (Div. 1 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1456683000,
        "relativeTimeSeconds": 232796769
    },
    {
        "id": 635,
        "name": "8VC Venture Cup 2016 - Final Round (Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1456683000,
        "relativeTimeSeconds": 232796769
    },
    {
        "id": 633,
        "name": "Manthan, Codefest 16",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1456506900,
        "relativeTimeSeconds": 232972869
    },
    {
        "id": 629,
        "name": "Codeforces Round 343 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1455986100,
        "relativeTimeSeconds": 233493669
    },
    {
        "id": 628,
        "name": "Educational Codeforces Round 8",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1455894000,
        "relativeTimeSeconds": 233585769
    },
    {
        "id": 630,
        "name": "Experimental Educational Round: VolBIT Formulas Blitz",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1455807600,
        "relativeTimeSeconds": 233672169
    },
    {
        "id": 626,
        "name": "8VC Venture Cup 2016 - Elimination Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1455384900,
        "relativeTimeSeconds": 234094869
    },
    {
        "id": 622,
        "name": "Educational Codeforces Round 7",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1455116400,
        "relativeTimeSeconds": 234363369
    },
    {
        "id": 625,
        "name": "Codeforces Round 342 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1454835900,
        "relativeTimeSeconds": 234643869
    },
    {
        "id": 623,
        "name": "AIM Tech Round (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1454605500,
        "relativeTimeSeconds": 234874269
    },
    {
        "id": 624,
        "name": "AIM Tech Round (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1454605500,
        "relativeTimeSeconds": 234874269
    },
    {
        "id": 621,
        "name": "Codeforces Round 341 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1454249100,
        "relativeTimeSeconds": 235230669
    },
    {
        "id": 618,
        "name": "Wunder Fund Round 2016 (Div. 1 + Div. 2 combined)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1454087400,
        "relativeTimeSeconds": 235392369
    },
    {
        "id": 617,
        "name": "Codeforces Round 340 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1453563300,
        "relativeTimeSeconds": 235916469
    },
    {
        "id": 620,
        "name": "Educational Codeforces Round 6",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1453388400,
        "relativeTimeSeconds": 236091369
    },
    {
        "id": 613,
        "name": "Codeforces Round 339 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1452789300,
        "relativeTimeSeconds": 236690469
    },
    {
        "id": 614,
        "name": "Codeforces Round 339 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1452789300,
        "relativeTimeSeconds": 236690469
    },
    {
        "id": 616,
        "name": "Educational Codeforces Round 5",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1452524400,
        "relativeTimeSeconds": 236955369
    },
    {
        "id": 615,
        "name": "Codeforces Round 338 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1452261900,
        "relativeTimeSeconds": 237217869
    },
    {
        "id": 611,
        "name": "Good Bye 2015",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1451487900,
        "relativeTimeSeconds": 237991869
    },
    {
        "id": 610,
        "name": "Codeforces Round 337 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1451215200,
        "relativeTimeSeconds": 238264569
    },
    {
        "id": 612,
        "name": "Educational Codeforces Round 4",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1451055600,
        "relativeTimeSeconds": 238424169
    },
    {
        "id": 607,
        "name": "Codeforces Round 336 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1450888500,
        "relativeTimeSeconds": 238591269
    },
    {
        "id": 608,
        "name": "Codeforces Round 336 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1450888500,
        "relativeTimeSeconds": 238591269
    },
    {
        "id": 609,
        "name": "Educational Codeforces Round 3",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1450537200,
        "relativeTimeSeconds": 238942569
    },
    {
        "id": 605,
        "name": "Codeforces Round 335 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1449677100,
        "relativeTimeSeconds": 239802669
    },
    {
        "id": 606,
        "name": "Codeforces Round 335 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1449677100,
        "relativeTimeSeconds": 239802669
    },
    {
        "id": 603,
        "name": "Codeforces Round 334 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1448984100,
        "relativeTimeSeconds": 240495669
    },
    {
        "id": 604,
        "name": "Codeforces Round 334 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1448984100,
        "relativeTimeSeconds": 240495669
    },
    {
        "id": 600,
        "name": "Educational Codeforces Round 2",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1448636400,
        "relativeTimeSeconds": 240843369
    },
    {
        "id": 601,
        "name": "Codeforces Round 333 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1448382900,
        "relativeTimeSeconds": 241096869
    },
    {
        "id": 602,
        "name": "Codeforces Round 333 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1448382900,
        "relativeTimeSeconds": 241096869
    },
    {
        "id": 599,
        "name": "Codeforces Round 332 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1448037300,
        "relativeTimeSeconds": 241442469
    },
    {
        "id": 596,
        "name": "Codeforces Round 331 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1447605300,
        "relativeTimeSeconds": 241874469
    },
    {
        "id": 598,
        "name": "Educational Codeforces Round 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1447426800,
        "relativeTimeSeconds": 242052969
    },
    {
        "id": 597,
        "name": "Testing Round 12",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 5400,
        "startTimeSeconds": 1447264800,
        "relativeTimeSeconds": 242214969
    },
    {
        "id": 594,
        "name": "Codeforces Round 330 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1447000200,
        "relativeTimeSeconds": 242479569
    },
    {
        "id": 595,
        "name": "Codeforces Round 330 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1447000200,
        "relativeTimeSeconds": 242479569
    },
    {
        "id": 593,
        "name": "Codeforces Round 329 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1446655500,
        "relativeTimeSeconds": 242824269
    },
    {
        "id": 592,
        "name": "Codeforces Round 328 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1446309000,
        "relativeTimeSeconds": 243170769
    },
    {
        "id": 590,
        "name": "Codeforces Round 327 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1445763600,
        "relativeTimeSeconds": 243716169
    },
    {
        "id": 591,
        "name": "Codeforces Round 327 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1445763600,
        "relativeTimeSeconds": 243716169
    },
    {
        "id": 587,
        "name": "Codeforces Round 326 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1444926600,
        "relativeTimeSeconds": 244553169
    },
    {
        "id": 588,
        "name": "Codeforces Round 326 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1444926600,
        "relativeTimeSeconds": 244553169
    },
    {
        "id": 585,
        "name": "Codeforces Round 325 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1444641000,
        "relativeTimeSeconds": 244838769
    },
    {
        "id": 586,
        "name": "Codeforces Round 325 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1444641000,
        "relativeTimeSeconds": 244838769
    },
    {
        "id": 584,
        "name": "Codeforces Round 324 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1444149000,
        "relativeTimeSeconds": 245330769
    },
    {
        "id": 582,
        "name": "Codeforces Round 323 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1443890700,
        "relativeTimeSeconds": 245589069
    },
    {
        "id": 583,
        "name": "Codeforces Round 323 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1443890700,
        "relativeTimeSeconds": 245589069
    },
    {
        "id": 581,
        "name": "Codeforces Round 322 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1443430800,
        "relativeTimeSeconds": 246048969
    },
    {
        "id": 580,
        "name": "Codeforces Round 321 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1442939400,
        "relativeTimeSeconds": 246540369
    },
    {
        "id": 578,
        "name": "Codeforces Round 320 (Div. 1) [Bayan Thanks-Round]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1442416500,
        "relativeTimeSeconds": 247063269
    },
    {
        "id": 579,
        "name": "Codeforces Round 320 (Div. 2) [Bayan Thanks-Round]",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1442416500,
        "relativeTimeSeconds": 247063269
    },
    {
        "id": 576,
        "name": "Codeforces Round 319 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1441902600,
        "relativeTimeSeconds": 247577169
    },
    {
        "id": 577,
        "name": "Codeforces Round 319 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1441902600,
        "relativeTimeSeconds": 247577169
    },
    {
        "id": 575,
        "name": "Bubble Cup 8 - Finals [Online Mirror]",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1441526400,
        "relativeTimeSeconds": 247953369
    },
    {
        "id": 573,
        "name": "Codeforces Round 318 [RussianCodeCup Thanks-Round] (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1440865800,
        "relativeTimeSeconds": 248613969
    },
    {
        "id": 574,
        "name": "Codeforces Round 318 [RussianCodeCup Thanks-Round] (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1440865800,
        "relativeTimeSeconds": 248613970
    },
    {
        "id": 571,
        "name": "Codeforces Round 317 [AimFund Thanks-Round] (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1440261000,
        "relativeTimeSeconds": 249218769
    },
    {
        "id": 572,
        "name": "Codeforces Round 317 [AimFund Thanks-Round] (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1440261000,
        "relativeTimeSeconds": 249218769
    },
    {
        "id": 570,
        "name": "Codeforces Round 316 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1439483400,
        "relativeTimeSeconds": 249996369
    },
    {
        "id": 568,
        "name": "Codeforces Round 315 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1439224200,
        "relativeTimeSeconds": 250255569
    },
    {
        "id": 569,
        "name": "Codeforces Round 315 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1439224200,
        "relativeTimeSeconds": 250255569
    },
    {
        "id": 567,
        "name": "Codeforces Round #Pi (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1438790400,
        "relativeTimeSeconds": 250689369
    },
    {
        "id": 566,
        "name": "VK Cup 2015 - Finals, online mirror",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1438273200,
        "relativeTimeSeconds": 251206569
    },
    {
        "id": 562,
        "name": "VK Cup 2015 - Finals",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1437898500,
        "relativeTimeSeconds": 251581269
    },
    {
        "id": 559,
        "name": "Codeforces Round 313 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1437573600,
        "relativeTimeSeconds": 251906169
    },
    {
        "id": 560,
        "name": "Codeforces Round 313 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1437573600,
        "relativeTimeSeconds": 251906169
    },
    {
        "id": 558,
        "name": "Codeforces Round 312 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1436886600,
        "relativeTimeSeconds": 252593169
    },
    {
        "id": 557,
        "name": "Codeforces Round 311 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1435676400,
        "relativeTimeSeconds": 253803369
    },
    {
        "id": 555,
        "name": "Codeforces Round 310 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1435414200,
        "relativeTimeSeconds": 254065569
    },
    {
        "id": 556,
        "name": "Codeforces Round 310 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1435414200,
        "relativeTimeSeconds": 254065569
    },
    {
        "id": 553,
        "name": "Codeforces Round 309 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1435163400,
        "relativeTimeSeconds": 254316369
    },
    {
        "id": 554,
        "name": "Codeforces Round 309 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1435163400,
        "relativeTimeSeconds": 254316369
    },
    {
        "id": 552,
        "name": "Codeforces Round 308 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1434645000,
        "relativeTimeSeconds": 254834769
    },
    {
        "id": 551,
        "name": "Codeforces Round 307 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1434127500,
        "relativeTimeSeconds": 255352269
    },
    {
        "id": 549,
        "name": "Looksery Cup 2015",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1433595600,
        "relativeTimeSeconds": 255884169
    },
    {
        "id": 550,
        "name": "Codeforces Round 306 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1433435400,
        "relativeTimeSeconds": 256044369
    },
    {
        "id": 547,
        "name": "Codeforces Round 305 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1432658100,
        "relativeTimeSeconds": 256821669
    },
    {
        "id": 548,
        "name": "Codeforces Round 305 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1432658100,
        "relativeTimeSeconds": 256821669
    },
    {
        "id": 546,
        "name": "Codeforces Round 304 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1432312200,
        "relativeTimeSeconds": 257167569
    },
    {
        "id": 545,
        "name": "Codeforces Round 303 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1432053000,
        "relativeTimeSeconds": 257426769
    },
    {
        "id": 543,
        "name": "Codeforces Round 302 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1431016200,
        "relativeTimeSeconds": 258463569
    },
    {
        "id": 544,
        "name": "Codeforces Round 302 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1431016200,
        "relativeTimeSeconds": 258463569
    },
    {
        "id": 541,
        "name": "VK Cup 2015 - Раунд 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1430668800,
        "relativeTimeSeconds": 258810970
    },
    {
        "id": 542,
        "name": "VK Cup 2015 - Round 3 (unofficial online mirror, Div. 1 only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1430668800,
        "relativeTimeSeconds": 258810969
    },
    {
        "id": 540,
        "name": "Codeforces Round 301 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1430411400,
        "relativeTimeSeconds": 259068369
    },
    {
        "id": 538,
        "name": "Codeforces Round 300",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1430064000,
        "relativeTimeSeconds": 259415769
    },
    {
        "id": 537,
        "name": "VK Cup 2015 - Wild Card Round 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1429381800,
        "relativeTimeSeconds": 260097969
    },
    {
        "id": 532,
        "name": "VK Cup 2015 - Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1429286400,
        "relativeTimeSeconds": 260193369
    },
    {
        "id": 533,
        "name": "VK Cup 2015 - Round 2 (unofficial online mirror, Div. 1 only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1429286400,
        "relativeTimeSeconds": 260193369
    },
    {
        "id": 535,
        "name": "Codeforces Round 299 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1429029300,
        "relativeTimeSeconds": 260450469
    },
    {
        "id": 536,
        "name": "Codeforces Round 299 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1429029300,
        "relativeTimeSeconds": 260450469
    },
    {
        "id": 534,
        "name": "Codeforces Round 298 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1428854400,
        "relativeTimeSeconds": 260625369
    },
    {
        "id": 526,
        "name": "ZeptoLab Code Rush 2015",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1428165300,
        "relativeTimeSeconds": 261314469
    },
    {
        "id": 530,
        "name": "VK Cup 2015 - Wild Card Round 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1427562000,
        "relativeTimeSeconds": 261917769
    },
    {
        "id": 531,
        "name": "VK Cup 2015 - Wild Card Round 1 (Online Mirror)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1427562000,
        "relativeTimeSeconds": 261917769
    },
    {
        "id": 525,
        "name": "Codeforces Round 297 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1427387400,
        "relativeTimeSeconds": 262092369
    },
    {
        "id": 529,
        "name": "VK Cup 2015 - Round 1 (unofficial online mirror, Div. 1 only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1426956300,
        "relativeTimeSeconds": 262523469
    },
    {
        "id": 524,
        "name": "VK Cup 2015 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1426946400,
        "relativeTimeSeconds": 262533369
    },
    {
        "id": 527,
        "name": "Codeforces Round 296 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1426610700,
        "relativeTimeSeconds": 262869069
    },
    {
        "id": 528,
        "name": "Codeforces Round 296 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1426610700,
        "relativeTimeSeconds": 262869069
    },
    {
        "id": 523,
        "name": "VK Cup 2015 - Qualification Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1426345200,
        "relativeTimeSeconds": 263134569
    },
    {
        "id": 522,
        "name": "VK Cup 2015 - Qualification Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1425740400,
        "relativeTimeSeconds": 263739369
    },
    {
        "id": 520,
        "name": "Codeforces Round 295 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1425279600,
        "relativeTimeSeconds": 264200169
    },
    {
        "id": 521,
        "name": "Codeforces Round 295 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1425279600,
        "relativeTimeSeconds": 264200169
    },
    {
        "id": 519,
        "name": "Codeforces Round 294 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1425128400,
        "relativeTimeSeconds": 264351369
    },
    {
        "id": 518,
        "name": "Codeforces Round 293 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1424795400,
        "relativeTimeSeconds": 264684369
    },
    {
        "id": 515,
        "name": "Codeforces Round 292 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1424190900,
        "relativeTimeSeconds": 265288869
    },
    {
        "id": 516,
        "name": "Codeforces Round 292 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1424190900,
        "relativeTimeSeconds": 265288869
    },
    {
        "id": 514,
        "name": "Codeforces Round 291 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1423931400,
        "relativeTimeSeconds": 265548369
    },
    {
        "id": 513,
        "name": "Rockethon 2015",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 11700,
        "startTimeSeconds": 1423328400,
        "relativeTimeSeconds": 266151369
    },
    {
        "id": 512,
        "name": "Codeforces Round 290 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1422894600,
        "relativeTimeSeconds": 266585169
    },
    {
        "id": 510,
        "name": "Codeforces Round 290 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1422894600,
        "relativeTimeSeconds": 266585169
    },
    {
        "id": 509,
        "name": "Codeforces Round 289 (Div. 2, ACM ICPC Rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1422705600,
        "relativeTimeSeconds": 266774169
    },
    {
        "id": 508,
        "name": "Codeforces Round 288 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1422376200,
        "relativeTimeSeconds": 267103569
    },
    {
        "id": 507,
        "name": "Codeforces Round 287 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1422028800,
        "relativeTimeSeconds": 267450969
    },
    {
        "id": 505,
        "name": "Codeforces Round 286 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1421586000,
        "relativeTimeSeconds": 267893769
    },
    {
        "id": 506,
        "name": "Codeforces Round 286 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1421586000,
        "relativeTimeSeconds": 267893769
    },
    {
        "id": 501,
        "name": "Codeforces Round 285 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1421053200,
        "relativeTimeSeconds": 268426569
    },
    {
        "id": 504,
        "name": "Codeforces Round 285 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1421053200,
        "relativeTimeSeconds": 268426569
    },
    {
        "id": 500,
        "name": "Good Bye 2014",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1419951600,
        "relativeTimeSeconds": 269528169
    },
    {
        "id": 498,
        "name": "Codeforces Round 284 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1419438600,
        "relativeTimeSeconds": 270041169
    },
    {
        "id": 499,
        "name": "Codeforces Round 284 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1419438600,
        "relativeTimeSeconds": 270041169
    },
    {
        "id": 496,
        "name": "Codeforces Round 283 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1418833800,
        "relativeTimeSeconds": 270645969
    },
    {
        "id": 497,
        "name": "Codeforces Round 283 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1418833800,
        "relativeTimeSeconds": 270645969
    },
    {
        "id": 494,
        "name": "Codeforces Round 282 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1418488200,
        "relativeTimeSeconds": 270991569
    },
    {
        "id": 495,
        "name": "Codeforces Round 282 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1418488200,
        "relativeTimeSeconds": 270991569
    },
    {
        "id": 493,
        "name": "Codeforces Round 281 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1417618800,
        "relativeTimeSeconds": 271860969
    },
    {
        "id": 492,
        "name": "Codeforces Round 280 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1417451400,
        "relativeTimeSeconds": 272028369
    },
    {
        "id": 490,
        "name": "Codeforces Round 279 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1416733800,
        "relativeTimeSeconds": 272745969
    },
    {
        "id": 487,
        "name": "Codeforces Round 278 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1416590400,
        "relativeTimeSeconds": 272889369
    },
    {
        "id": 488,
        "name": "Codeforces Round 278 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1416590400,
        "relativeTimeSeconds": 272889369
    },
    {
        "id": 491,
        "name": "Testing Round 11",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 5400,
        "startTimeSeconds": 1416519000,
        "relativeTimeSeconds": 272960769
    },
    {
        "id": 489,
        "name": "Codeforces Round 277.5 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1416238500,
        "relativeTimeSeconds": 273241269
    },
    {
        "id": 486,
        "name": "Codeforces Round 277 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1415718000,
        "relativeTimeSeconds": 273761769
    },
    {
        "id": 484,
        "name": "Codeforces Round 276 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1415205000,
        "relativeTimeSeconds": 274274769
    },
    {
        "id": 485,
        "name": "Codeforces Round 276 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1415205000,
        "relativeTimeSeconds": 274274769
    },
    {
        "id": 482,
        "name": "Codeforces Round 275 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1414170000,
        "relativeTimeSeconds": 275309769
    },
    {
        "id": 483,
        "name": "Codeforces Round 275 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1414170000,
        "relativeTimeSeconds": 275309769
    },
    {
        "id": 479,
        "name": "Codeforces Round 274 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1413709200,
        "relativeTimeSeconds": 275770569
    },
    {
        "id": 480,
        "name": "Codeforces Round 274 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1413709200,
        "relativeTimeSeconds": 275770569
    },
    {
        "id": 478,
        "name": "Codeforces Round 273 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1413474000,
        "relativeTimeSeconds": 276005769
    },
    {
        "id": 476,
        "name": "Codeforces Round 272 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1413122400,
        "relativeTimeSeconds": 276357369
    },
    {
        "id": 477,
        "name": "Codeforces Round 272 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1413122400,
        "relativeTimeSeconds": 276357369
    },
    {
        "id": 474,
        "name": "Codeforces Round 271 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1412609400,
        "relativeTimeSeconds": 276870369
    },
    {
        "id": 475,
        "name": "Bayan 2015 Contest Warm Up",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1412514000,
        "relativeTimeSeconds": 276965769
    },
    {
        "id": 472,
        "name": "Codeforces Round 270",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1411918500,
        "relativeTimeSeconds": 277561269
    },
    {
        "id": 471,
        "name": "Codeforces Round 269 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1411745400,
        "relativeTimeSeconds": 277734369
    },
    {
        "id": 468,
        "name": "Codeforces Round 268 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1411218000,
        "relativeTimeSeconds": 278261769
    },
    {
        "id": 469,
        "name": "Codeforces Round 268 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1411218000,
        "relativeTimeSeconds": 278261769
    },
    {
        "id": 467,
        "name": "Codeforces Round 267 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1411054200,
        "relativeTimeSeconds": 278425569
    },
    {
        "id": 470,
        "name": "Surprise Language Round 7",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1410622200,
        "relativeTimeSeconds": 278857569
    },
    {
        "id": 466,
        "name": "Codeforces Round 266 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1410535800,
        "relativeTimeSeconds": 278943969
    },
    {
        "id": 464,
        "name": "Codeforces Round 265 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1410103800,
        "relativeTimeSeconds": 279375969
    },
    {
        "id": 465,
        "name": "Codeforces Round 265 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1410103800,
        "relativeTimeSeconds": 279375969
    },
    {
        "id": 463,
        "name": "Codeforces Round 264 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1409383800,
        "relativeTimeSeconds": 280095969
    },
    {
        "id": 461,
        "name": "Codeforces Round 263 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1409061600,
        "relativeTimeSeconds": 280418169
    },
    {
        "id": 462,
        "name": "Codeforces Round 263 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1409061600,
        "relativeTimeSeconds": 280418169
    },
    {
        "id": 460,
        "name": "Codeforces Round 262 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1408548600,
        "relativeTimeSeconds": 280931169
    },
    {
        "id": 459,
        "name": "Codeforces Round 261 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1408116600,
        "relativeTimeSeconds": 281363169
    },
    {
        "id": 457,
        "name": "MemSQL Start[c]UP 2.0 - Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1407690000,
        "relativeTimeSeconds": 281789769
    },
    {
        "id": 458,
        "name": "MemSQL Start[c]UP 2.0 - Round 2 - Online Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1407690000,
        "relativeTimeSeconds": 281789769
    },
    {
        "id": 455,
        "name": "Codeforces Round 260 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1407511800,
        "relativeTimeSeconds": 281967969
    },
    {
        "id": 456,
        "name": "Codeforces Round 260 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1407511800,
        "relativeTimeSeconds": 281967969
    },
    {
        "id": 453,
        "name": "Codeforces Round 259 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1406907000,
        "relativeTimeSeconds": 282572769
    },
    {
        "id": 454,
        "name": "Codeforces Round 259 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1406907000,
        "relativeTimeSeconds": 282572769
    },
    {
        "id": 452,
        "name": "MemSQL Start[c]UP 2.0 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1406480400,
        "relativeTimeSeconds": 282999369
    },
    {
        "id": 451,
        "name": "Codeforces Round 258 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1406215800,
        "relativeTimeSeconds": 283263969
    },
    {
        "id": 449,
        "name": "Codeforces Round 257 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1405774800,
        "relativeTimeSeconds": 283704969
    },
    {
        "id": 450,
        "name": "Codeforces Round 257 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1405774800,
        "relativeTimeSeconds": 283704969
    },
    {
        "id": 448,
        "name": "Codeforces Round 256 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1405605600,
        "relativeTimeSeconds": 283874169
    },
    {
        "id": 446,
        "name": "Codeforces Round #FF (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1405256400,
        "relativeTimeSeconds": 284223369
    },
    {
        "id": 447,
        "name": "Codeforces Round #FF (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1405256400,
        "relativeTimeSeconds": 284223369
    },
    {
        "id": 444,
        "name": "Codeforces Round 254 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1404651900,
        "relativeTimeSeconds": 284827869
    },
    {
        "id": 445,
        "name": "Codeforces Round 254 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1404651900,
        "relativeTimeSeconds": 284827869
    },
    {
        "id": 442,
        "name": "Codeforces Round 253 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1403191800,
        "relativeTimeSeconds": 286287969
    },
    {
        "id": 443,
        "name": "Codeforces Round 253 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1403191800,
        "relativeTimeSeconds": 286287969
    },
    {
        "id": 436,
        "name": "Zepto Code Rush 2014",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1402673400,
        "relativeTimeSeconds": 286806369
    },
    {
        "id": 441,
        "name": "Codeforces Round 252 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1402241400,
        "relativeTimeSeconds": 287238369
    },
    {
        "id": 439,
        "name": "Codeforces Round 251 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1401895800,
        "relativeTimeSeconds": 287583969
    },
    {
        "id": 440,
        "name": "Testing Round 10",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 5400,
        "startTimeSeconds": 1401809400,
        "relativeTimeSeconds": 287670369
    },
    {
        "id": 437,
        "name": "Codeforces Round 250 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1401627600,
        "relativeTimeSeconds": 287852169
    },
    {
        "id": 438,
        "name": "Codeforces Round 250 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1401627600,
        "relativeTimeSeconds": 287852169
    },
    {
        "id": 435,
        "name": "Codeforces Round 249 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1401463800,
        "relativeTimeSeconds": 288015969
    },
    {
        "id": 433,
        "name": "Codeforces Round 248 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1400914800,
        "relativeTimeSeconds": 288564969
    },
    {
        "id": 434,
        "name": "Codeforces Round 248 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1400914800,
        "relativeTimeSeconds": 288564969
    },
    {
        "id": 431,
        "name": "Codeforces Round 247 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1400686200,
        "relativeTimeSeconds": 288793569
    },
    {
        "id": 432,
        "name": "Codeforces Round 246 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1400167800,
        "relativeTimeSeconds": 289311969
    },
    {
        "id": 429,
        "name": "Codeforces Round 245 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1399822800,
        "relativeTimeSeconds": 289656969
    },
    {
        "id": 430,
        "name": "Codeforces Round 245 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1399822800,
        "relativeTimeSeconds": 289656969
    },
    {
        "id": 427,
        "name": "Codeforces Round 244 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1399044600,
        "relativeTimeSeconds": 290435169
    },
    {
        "id": 425,
        "name": "Codeforces Round 243 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1398612600,
        "relativeTimeSeconds": 290867169
    },
    {
        "id": 426,
        "name": "Codeforces Round 243 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1398612600,
        "relativeTimeSeconds": 290867169
    },
    {
        "id": 424,
        "name": "Codeforces Round 242 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1398409200,
        "relativeTimeSeconds": 291070569
    },
    {
        "id": 419,
        "name": "Coder-Strike 2014 - Finals",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1398169200,
        "relativeTimeSeconds": 291310569
    },
    {
        "id": 420,
        "name": "Coder-Strike 2014 - Finals (online edition, Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1398169140,
        "relativeTimeSeconds": 291310629
    },
    {
        "id": 421,
        "name": "Coder-Strike 2014 - Finals (online edition, Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1398168900,
        "relativeTimeSeconds": 291310869
    },
    {
        "id": 413,
        "name": "Coder-Strike 2014 - Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1397977200,
        "relativeTimeSeconds": 291502569
    },
    {
        "id": 412,
        "name": "Coder-Strike 2014 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1397837400,
        "relativeTimeSeconds": 291642369
    },
    {
        "id": 417,
        "name": "RCC 2014 Warmup (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1397749200,
        "relativeTimeSeconds": 291730569
    },
    {
        "id": 418,
        "name": "RCC 2014 Warmup (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1397749200,
        "relativeTimeSeconds": 291730569
    },
    {
        "id": 411,
        "name": "Coder-Strike 2014 - Qualification Round",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1397505600,
        "relativeTimeSeconds": 291974169
    },
    {
        "id": 416,
        "name": "Codeforces Round 241 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1397376000,
        "relativeTimeSeconds": 292103769
    },
    {
        "id": 414,
        "name": "Codeforces Round 240 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1396798800,
        "relativeTimeSeconds": 292680969
    },
    {
        "id": 415,
        "name": "Codeforces Round 240 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1396798800,
        "relativeTimeSeconds": 292680969
    },
    {
        "id": 409,
        "name": "April Fools Day Contest 2014",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1396366200,
        "relativeTimeSeconds": 293113569
    },
    {
        "id": 407,
        "name": "Codeforces Round 239 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1396162800,
        "relativeTimeSeconds": 293316969
    },
    {
        "id": 408,
        "name": "Codeforces Round 239 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1396162800,
        "relativeTimeSeconds": 293316969
    },
    {
        "id": 405,
        "name": "Codeforces Round 238 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1395502200,
        "relativeTimeSeconds": 293977569
    },
    {
        "id": 406,
        "name": "Codeforces Round 238 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1395502200,
        "relativeTimeSeconds": 293977569
    },
    {
        "id": 404,
        "name": "Codeforces Round 237 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1395243000,
        "relativeTimeSeconds": 294236769
    },
    {
        "id": 402,
        "name": "Codeforces Round 236 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1394983800,
        "relativeTimeSeconds": 294495969
    },
    {
        "id": 403,
        "name": "Codeforces Round 236 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1394983800,
        "relativeTimeSeconds": 294495969
    },
    {
        "id": 401,
        "name": "Codeforces Round 235 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1394465400,
        "relativeTimeSeconds": 295014369
    },
    {
        "id": 400,
        "name": "Codeforces Round 234 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1394033400,
        "relativeTimeSeconds": 295446369
    },
    {
        "id": 398,
        "name": "Codeforces Round 233 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1393687800,
        "relativeTimeSeconds": 295791969
    },
    {
        "id": 399,
        "name": "Codeforces Round 233 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1393687800,
        "relativeTimeSeconds": 295791969
    },
    {
        "id": 396,
        "name": "Codeforces Round 232 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1393428600,
        "relativeTimeSeconds": 296051169
    },
    {
        "id": 397,
        "name": "Codeforces Round 232 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1393428600,
        "relativeTimeSeconds": 296051169
    },
    {
        "id": 394,
        "name": "Codeforces Round 231 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1392910200,
        "relativeTimeSeconds": 296569569
    },
    {
        "id": 392,
        "name": "Codeforces Round 230 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1392728400,
        "relativeTimeSeconds": 296751369
    },
    {
        "id": 393,
        "name": "Codeforces Round 230 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1392728400,
        "relativeTimeSeconds": 296751369
    },
    {
        "id": 391,
        "name": "Rockethon 2014",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1392573600,
        "relativeTimeSeconds": 296906169
    },
    {
        "id": 390,
        "name": "Codeforces Round 229 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1392132600,
        "relativeTimeSeconds": 297347169
    },
    {
        "id": 388,
        "name": "Codeforces Round 228 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1391442000,
        "relativeTimeSeconds": 298037769
    },
    {
        "id": 389,
        "name": "Codeforces Round 228 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1391442000,
        "relativeTimeSeconds": 298037769
    },
    {
        "id": 387,
        "name": "Codeforces Round 227 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1391095800,
        "relativeTimeSeconds": 298383969
    },
    {
        "id": 385,
        "name": "Codeforces Round 226 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1390577700,
        "relativeTimeSeconds": 298902069
    },
    {
        "id": 383,
        "name": "Codeforces Round 225 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1390231800,
        "relativeTimeSeconds": 299247969
    },
    {
        "id": 384,
        "name": "Codeforces Round 225 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1390231800,
        "relativeTimeSeconds": 299247969
    },
    {
        "id": 382,
        "name": "Codeforces Round 224 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1389972600,
        "relativeTimeSeconds": 299507169
    },
    {
        "id": 386,
        "name": "Testing Round 9",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 5400,
        "startTimeSeconds": 1389906900,
        "relativeTimeSeconds": 299572869
    },
    {
        "id": 380,
        "name": "Codeforces Round 223 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1389540600,
        "relativeTimeSeconds": 299939169
    },
    {
        "id": 381,
        "name": "Codeforces Round 223 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1389540600,
        "relativeTimeSeconds": 299939169
    },
    {
        "id": 379,
        "name": "Good Bye 2013",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1388417400,
        "relativeTimeSeconds": 301062369
    },
    {
        "id": 377,
        "name": "Codeforces Round 222 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1388331000,
        "relativeTimeSeconds": 301148769
    },
    {
        "id": 378,
        "name": "Codeforces Round 222 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1388331000,
        "relativeTimeSeconds": 301148769
    },
    {
        "id": 375,
        "name": "Codeforces Round 221 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1387893600,
        "relativeTimeSeconds": 301586169
    },
    {
        "id": 376,
        "name": "Codeforces Round 221 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1387893600,
        "relativeTimeSeconds": 301586169
    },
    {
        "id": 374,
        "name": "Codeforces Round 220 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1387380600,
        "relativeTimeSeconds": 302099169
    },
    {
        "id": 372,
        "name": "Codeforces Round 219 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1386943200,
        "relativeTimeSeconds": 302536569
    },
    {
        "id": 373,
        "name": "Codeforces Round 219 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1386943200,
        "relativeTimeSeconds": 302536569
    },
    {
        "id": 371,
        "name": "Codeforces Round 218 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1386493200,
        "relativeTimeSeconds": 302986569
    },
    {
        "id": 370,
        "name": "Codeforces Round 217 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1386399600,
        "relativeTimeSeconds": 303080169
    },
    {
        "id": 369,
        "name": "Codeforces Round 216 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1385739000,
        "relativeTimeSeconds": 303740769
    },
    {
        "id": 367,
        "name": "Codeforces Round 215 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1385479800,
        "relativeTimeSeconds": 303999969
    },
    {
        "id": 368,
        "name": "Codeforces Round 215 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1385479800,
        "relativeTimeSeconds": 303999969
    },
    {
        "id": 366,
        "name": "Codeforces Round 214 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1385307000,
        "relativeTimeSeconds": 304172769
    },
    {
        "id": 364,
        "name": "Codeforces Round 213 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1384875000,
        "relativeTimeSeconds": 304604769
    },
    {
        "id": 365,
        "name": "Codeforces Round 213 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1384875000,
        "relativeTimeSeconds": 304604769
    },
    {
        "id": 362,
        "name": "Codeforces Round 212 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1384443000,
        "relativeTimeSeconds": 305036769
    },
    {
        "id": 363,
        "name": "Codeforces Round 211 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1384156800,
        "relativeTimeSeconds": 305322969
    },
    {
        "id": 360,
        "name": "Codeforces Round 210 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1384102800,
        "relativeTimeSeconds": 305376969
    },
    {
        "id": 361,
        "name": "Codeforces Round 210 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1384102800,
        "relativeTimeSeconds": 305376969
    },
    {
        "id": 359,
        "name": "Codeforces Round 209 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1383379200,
        "relativeTimeSeconds": 306100569
    },
    {
        "id": 358,
        "name": "Codeforces Round 208 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1382715000,
        "relativeTimeSeconds": 306764769
    },
    {
        "id": 356,
        "name": "Codeforces Round 207 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1381838400,
        "relativeTimeSeconds": 307641369
    },
    {
        "id": 357,
        "name": "Codeforces Round 207 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1381838400,
        "relativeTimeSeconds": 307641369
    },
    {
        "id": 354,
        "name": "Codeforces Round 206 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1381678200,
        "relativeTimeSeconds": 307801569
    },
    {
        "id": 355,
        "name": "Codeforces Round 206 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1381678200,
        "relativeTimeSeconds": 307801569
    },
    {
        "id": 353,
        "name": "Codeforces Round 205 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1381419000,
        "relativeTimeSeconds": 308060769
    },
    {
        "id": 351,
        "name": "Codeforces Round 204 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1380900600,
        "relativeTimeSeconds": 308579169
    },
    {
        "id": 352,
        "name": "Codeforces Round 204 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1380900600,
        "relativeTimeSeconds": 308579169
    },
    {
        "id": 350,
        "name": "Codeforces Round 203 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1380641400,
        "relativeTimeSeconds": 308838369
    },
    {
        "id": 348,
        "name": "Codeforces Round 202 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1380295800,
        "relativeTimeSeconds": 309183969
    },
    {
        "id": 349,
        "name": "Codeforces Round 202 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1380295800,
        "relativeTimeSeconds": 309183969
    },
    {
        "id": 346,
        "name": "Codeforces Round 201 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1379691000,
        "relativeTimeSeconds": 309788769
    },
    {
        "id": 347,
        "name": "Codeforces Round 201 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1379691000,
        "relativeTimeSeconds": 309788769
    },
    {
        "id": 343,
        "name": "Codeforces Round 200 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1379172600,
        "relativeTimeSeconds": 310307169
    },
    {
        "id": 344,
        "name": "Codeforces Round 200 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1379172600,
        "relativeTimeSeconds": 310307169
    },
    {
        "id": 345,
        "name": "Friday the 13th, Programmers Day",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1379086800,
        "relativeTimeSeconds": 310392969
    },
    {
        "id": 342,
        "name": "Codeforces Round 199 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1378540800,
        "relativeTimeSeconds": 310938969
    },
    {
        "id": 340,
        "name": "Codeforces Round 198 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1377876600,
        "relativeTimeSeconds": 311603169
    },
    {
        "id": 341,
        "name": "Codeforces Round 198 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1377876600,
        "relativeTimeSeconds": 311603169
    },
    {
        "id": 339,
        "name": "Codeforces Round 197 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1377531000,
        "relativeTimeSeconds": 311948769
    },
    {
        "id": 337,
        "name": "Codeforces Round 196 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1376668800,
        "relativeTimeSeconds": 312810969
    },
    {
        "id": 338,
        "name": "Codeforces Round 196 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1376668800,
        "relativeTimeSeconds": 312810969
    },
    {
        "id": 336,
        "name": "Codeforces Round 195 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1376062200,
        "relativeTimeSeconds": 313417569
    },
    {
        "id": 326,
        "name": "MemSQL start[c]up Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1375549200,
        "relativeTimeSeconds": 313930569
    },
    {
        "id": 335,
        "name": "MemSQL start[c]up Round 2 - online version",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1375549200,
        "relativeTimeSeconds": 313930569
    },
    {
        "id": 333,
        "name": "Codeforces Round 194 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1374913800,
        "relativeTimeSeconds": 314565969
    },
    {
        "id": 334,
        "name": "Codeforces Round 194 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1374913800,
        "relativeTimeSeconds": 314565969
    },
    {
        "id": 332,
        "name": "Codeforces Round 193 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1374679800,
        "relativeTimeSeconds": 314799969
    },
    {
        "id": 329,
        "name": "Codeforces Round 192 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1374327000,
        "relativeTimeSeconds": 315152769
    },
    {
        "id": 330,
        "name": "Codeforces Round 192 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1374327000,
        "relativeTimeSeconds": 315152769
    },
    {
        "id": 331,
        "name": "ABBYY Cup 3.0 - Finals (online version)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1374075000,
        "relativeTimeSeconds": 315404769
    },
    {
        "id": 324,
        "name": "ABBYY Cup 3.0 - Finals",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1374043200,
        "relativeTimeSeconds": 315436569
    },
    {
        "id": 325,
        "name": "MemSQL start[c]up Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1373734800,
        "relativeTimeSeconds": 315744969
    },
    {
        "id": 328,
        "name": "Testing Round 8",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 3600,
        "startTimeSeconds": 1373662800,
        "relativeTimeSeconds": 315816969
    },
    {
        "id": 327,
        "name": "Codeforces Round 191 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1372941000,
        "relativeTimeSeconds": 316538769
    },
    {
        "id": 321,
        "name": "Codeforces Round 190 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1372433400,
        "relativeTimeSeconds": 317046369
    },
    {
        "id": 322,
        "name": "Codeforces Round 190 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1372433400,
        "relativeTimeSeconds": 317046369
    },
    {
        "id": 323,
        "name": "Testing Round 7",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 3600,
        "startTimeSeconds": 1372363200,
        "relativeTimeSeconds": 317116569
    },
    {
        "id": 319,
        "name": "Codeforces Round 189 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1371992400,
        "relativeTimeSeconds": 317487369
    },
    {
        "id": 320,
        "name": "Codeforces Round 189 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1371992400,
        "relativeTimeSeconds": 317487369
    },
    {
        "id": 317,
        "name": "Codeforces Round 188 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1371223800,
        "relativeTimeSeconds": 318255969
    },
    {
        "id": 318,
        "name": "Codeforces Round 188 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1371223800,
        "relativeTimeSeconds": 318255969
    },
    {
        "id": 316,
        "name": "ABBYY Cup 3.0",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 14400,
        "startTimeSeconds": 1371042000,
        "relativeTimeSeconds": 318437769
    },
    {
        "id": 314,
        "name": "Codeforces Round 187 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1370619000,
        "relativeTimeSeconds": 318860769
    },
    {
        "id": 315,
        "name": "Codeforces Round 187 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1370619000,
        "relativeTimeSeconds": 318860769
    },
    {
        "id": 313,
        "name": "Codeforces Round 186 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1369927800,
        "relativeTimeSeconds": 319551969
    },
    {
        "id": 311,
        "name": "Codeforces Round 185 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1369582200,
        "relativeTimeSeconds": 319897569
    },
    {
        "id": 312,
        "name": "Codeforces Round 185 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1369582200,
        "relativeTimeSeconds": 319897569
    },
    {
        "id": 305,
        "name": "Codeforces Round 184 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1368968400,
        "relativeTimeSeconds": 320511369
    },
    {
        "id": 309,
        "name": "Croc Champ 2013 - Finals (online version, Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1368803400,
        "relativeTimeSeconds": 320676369
    },
    {
        "id": 308,
        "name": "Croc Champ 2013 - Finals",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1368784800,
        "relativeTimeSeconds": 320694969
    },
    {
        "id": 303,
        "name": "Codeforces Round 183 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1368363600,
        "relativeTimeSeconds": 321116169
    },
    {
        "id": 304,
        "name": "Codeforces Round 183 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1368363600,
        "relativeTimeSeconds": 321116169
    },
    {
        "id": 306,
        "name": "Testing Round 6",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 6000,
        "startTimeSeconds": 1368302400,
        "relativeTimeSeconds": 321177369
    },
    {
        "id": 301,
        "name": "Codeforces Round 182 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1367769900,
        "relativeTimeSeconds": 321709869
    },
    {
        "id": 302,
        "name": "Codeforces Round 182 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1367769900,
        "relativeTimeSeconds": 321709869
    },
    {
        "id": 300,
        "name": "Codeforces Round 181 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1366903800,
        "relativeTimeSeconds": 322575969
    },
    {
        "id": 293,
        "name": "Croc Champ 2013 - Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1366644900,
        "relativeTimeSeconds": 322834869
    },
    {
        "id": 299,
        "name": "Croc Champ 2013 - Round 2 (Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1366644600,
        "relativeTimeSeconds": 322835169
    },
    {
        "id": 297,
        "name": "Codeforces Round 180 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1366385400,
        "relativeTimeSeconds": 323094369
    },
    {
        "id": 298,
        "name": "Codeforces Round 180 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1366385400,
        "relativeTimeSeconds": 323094369
    },
    {
        "id": 292,
        "name": "Croc Champ 2013 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1366040100,
        "relativeTimeSeconds": 323439669
    },
    {
        "id": 291,
        "name": "Croc Champ 2013 - Qualification Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 172800,
        "startTimeSeconds": 1365796800,
        "relativeTimeSeconds": 323682969
    },
    {
        "id": 295,
        "name": "Codeforces Round 179 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1365694200,
        "relativeTimeSeconds": 323785569
    },
    {
        "id": 296,
        "name": "Codeforces Round 179 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1365694200,
        "relativeTimeSeconds": 323785569
    },
    {
        "id": 294,
        "name": "Codeforces Round 178 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1365348600,
        "relativeTimeSeconds": 324131169
    },
    {
        "id": 288,
        "name": "Codeforces Round 177 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1364916600,
        "relativeTimeSeconds": 324563169
    },
    {
        "id": 289,
        "name": "Codeforces Round 177 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1364916600,
        "relativeTimeSeconds": 324563169
    },
    {
        "id": 290,
        "name": "April Fools Day Contest 2013",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1364830200,
        "relativeTimeSeconds": 324649569
    },
    {
        "id": 286,
        "name": "Codeforces Round 176 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1364025600,
        "relativeTimeSeconds": 325454169
    },
    {
        "id": 287,
        "name": "Codeforces Round 176 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1364025600,
        "relativeTimeSeconds": 325454169
    },
    {
        "id": 285,
        "name": "Codeforces Round 175 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1363879800,
        "relativeTimeSeconds": 325599969
    },
    {
        "id": 283,
        "name": "Codeforces Round 174 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1363534200,
        "relativeTimeSeconds": 325945569
    },
    {
        "id": 284,
        "name": "Codeforces Round 174 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1363534200,
        "relativeTimeSeconds": 325945569
    },
    {
        "id": 282,
        "name": "Codeforces Round 173 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1363188600,
        "relativeTimeSeconds": 326291169
    },
    {
        "id": 280,
        "name": "Codeforces Round 172 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1362929400,
        "relativeTimeSeconds": 326550369
    },
    {
        "id": 281,
        "name": "Codeforces Round 172 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1362929400,
        "relativeTimeSeconds": 326550369
    },
    {
        "id": 279,
        "name": "Codeforces Round 171 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1362411000,
        "relativeTimeSeconds": 327068769
    },
    {
        "id": 277,
        "name": "Codeforces Round 170 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1362065400,
        "relativeTimeSeconds": 327414369
    },
    {
        "id": 278,
        "name": "Codeforces Round 170 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1362065400,
        "relativeTimeSeconds": 327414369
    },
    {
        "id": 276,
        "name": "Codeforces Round 169 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1361719800,
        "relativeTimeSeconds": 327759969
    },
    {
        "id": 274,
        "name": "Codeforces Round 168 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1361374200,
        "relativeTimeSeconds": 328105569
    },
    {
        "id": 275,
        "name": "Codeforces Round 168 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1361374200,
        "relativeTimeSeconds": 328105569
    },
    {
        "id": 272,
        "name": "Codeforces Round 167 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1360769400,
        "relativeTimeSeconds": 328710369
    },
    {
        "id": 273,
        "name": "Codeforces Round 167 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1360769400,
        "relativeTimeSeconds": 328710369
    },
    {
        "id": 271,
        "name": "Codeforces Round 166 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1360596600,
        "relativeTimeSeconds": 328883169
    },
    {
        "id": 269,
        "name": "Codeforces Round 165 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1359732600,
        "relativeTimeSeconds": 329747169
    },
    {
        "id": 270,
        "name": "Codeforces Round 165 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1359732600,
        "relativeTimeSeconds": 329747169
    },
    {
        "id": 268,
        "name": "Codeforces Round 164 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1359387000,
        "relativeTimeSeconds": 330092769
    },
    {
        "id": 266,
        "name": "Codeforces Round 163 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1358868600,
        "relativeTimeSeconds": 330611169
    },
    {
        "id": 264,
        "name": "Codeforces Round 162 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1358686800,
        "relativeTimeSeconds": 330792969
    },
    {
        "id": 265,
        "name": "Codeforces Round 162 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1358686800,
        "relativeTimeSeconds": 330792969
    },
    {
        "id": 263,
        "name": "Codeforces Round 161 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1358350200,
        "relativeTimeSeconds": 331129569
    },
    {
        "id": 261,
        "name": "Codeforces Round 160 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1358091000,
        "relativeTimeSeconds": 331388769
    },
    {
        "id": 262,
        "name": "Codeforces Round 160 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1358091000,
        "relativeTimeSeconds": 331388769
    },
    {
        "id": 267,
        "name": "Codeforces Testing Round 5",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 6300,
        "startTimeSeconds": 1358002800,
        "relativeTimeSeconds": 331476969
    },
    {
        "id": 257,
        "name": "Codeforces Round 159 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1357659000,
        "relativeTimeSeconds": 331820769
    },
    {
        "id": 260,
        "name": "Codeforces Round 158 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1356622500,
        "relativeTimeSeconds": 332857269
    },
    {
        "id": 258,
        "name": "Codeforces Round 157 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1356190200,
        "relativeTimeSeconds": 333289569
    },
    {
        "id": 259,
        "name": "Codeforces Round 157 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1356190200,
        "relativeTimeSeconds": 333289569
    },
    {
        "id": 256,
        "name": "Codeforces Round 156 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1355671800,
        "relativeTimeSeconds": 333807969
    },
    {
        "id": 255,
        "name": "Codeforces Round 156 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1355671800,
        "relativeTimeSeconds": 333807969
    },
    {
        "id": 254,
        "name": "Codeforces Round 155 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1355047200,
        "relativeTimeSeconds": 334432569
    },
    {
        "id": 253,
        "name": "Codeforces Round 154 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1354960800,
        "relativeTimeSeconds": 334518969
    },
    {
        "id": 251,
        "name": "Codeforces Round 153 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1354807800,
        "relativeTimeSeconds": 334671969
    },
    {
        "id": 252,
        "name": "Codeforces Round 153 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1354807800,
        "relativeTimeSeconds": 334671969
    },
    {
        "id": 250,
        "name": "CROC-MBTU 2012, Final Round (Online version, Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1353938400,
        "relativeTimeSeconds": 335541369
    },
    {
        "id": 247,
        "name": "CROC-MBTU 2012, Final Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1353927300,
        "relativeTimeSeconds": 335552469
    },
    {
        "id": 248,
        "name": "Codeforces Round 152 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1353857400,
        "relativeTimeSeconds": 335622369
    },
    {
        "id": 249,
        "name": "Codeforces Round 152 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1353857400,
        "relativeTimeSeconds": 335622369
    },
    {
        "id": 246,
        "name": "Codeforces Round 151 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1353511800,
        "relativeTimeSeconds": 335967969
    },
    {
        "id": 245,
        "name": "CROC-MBTU 2012, Elimination Round (ACM-ICPC)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1353339000,
        "relativeTimeSeconds": 336140769
    },
    {
        "id": 243,
        "name": "Codeforces Round 150 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1353079800,
        "relativeTimeSeconds": 336399969
    },
    {
        "id": 244,
        "name": "Codeforces Round 150 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1353079800,
        "relativeTimeSeconds": 336399969
    },
    {
        "id": 242,
        "name": "Codeforces Round 149 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1352647800,
        "relativeTimeSeconds": 336831969
    },
    {
        "id": 238,
        "name": "Codeforces Round 148 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1352044800,
        "relativeTimeSeconds": 337434969
    },
    {
        "id": 239,
        "name": "Codeforces Round 148 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1352044800,
        "relativeTimeSeconds": 337434969
    },
    {
        "id": 241,
        "name": "Bayan 2012-2013 Elimination Round (ACM ICPC Rules, English statements)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1351783800,
        "relativeTimeSeconds": 337695969
    },
    {
        "id": 237,
        "name": "Codeforces Round 147 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1351179000,
        "relativeTimeSeconds": 338300769
    },
    {
        "id": 235,
        "name": "Codeforces Round 146 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1350803400,
        "relativeTimeSeconds": 338676369
    },
    {
        "id": 236,
        "name": "Codeforces Round 146 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1350803400,
        "relativeTimeSeconds": 338676369
    },
    {
        "id": 234,
        "name": "Codeforces Round 145 (Div. 2, ACM-ICPC Rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 12600,
        "startTimeSeconds": 1350370800,
        "relativeTimeSeconds": 339108969
    },
    {
        "id": 240,
        "name": "Codeforces Round 145 (Div. 1, ACM-ICPC Rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1350370800,
        "relativeTimeSeconds": 339108969
    },
    {
        "id": 232,
        "name": "Codeforces Round 144 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1349969400,
        "relativeTimeSeconds": 339510369
    },
    {
        "id": 233,
        "name": "Codeforces Round 144 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1349969400,
        "relativeTimeSeconds": 339510369
    },
    {
        "id": 231,
        "name": "Codeforces Round 143 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1349623800,
        "relativeTimeSeconds": 339855969
    },
    {
        "id": 229,
        "name": "Codeforces Round 142 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1349105400,
        "relativeTimeSeconds": 340374369
    },
    {
        "id": 230,
        "name": "Codeforces Round 142 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7500,
        "startTimeSeconds": 1349105400,
        "relativeTimeSeconds": 340374369
    },
    {
        "id": 228,
        "name": "Codeforces Round 141 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1348759800,
        "relativeTimeSeconds": 340719969
    },
    {
        "id": 226,
        "name": "Codeforces Round 140 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1348500600,
        "relativeTimeSeconds": 340979169
    },
    {
        "id": 227,
        "name": "Codeforces Round 140 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1348500600,
        "relativeTimeSeconds": 340979169
    },
    {
        "id": 225,
        "name": "Codeforces Round 139 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1348069500,
        "relativeTimeSeconds": 341410269
    },
    {
        "id": 223,
        "name": "Codeforces Round 138 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1347809400,
        "relativeTimeSeconds": 341670369
    },
    {
        "id": 224,
        "name": "Codeforces Round 138 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1347809400,
        "relativeTimeSeconds": 341670369
    },
    {
        "id": 222,
        "name": "Codeforces Round 137 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1347291900,
        "relativeTimeSeconds": 342187869
    },
    {
        "id": 220,
        "name": "Codeforces Round 136 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1346427000,
        "relativeTimeSeconds": 343052769
    },
    {
        "id": 221,
        "name": "Codeforces Round 136 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1346427000,
        "relativeTimeSeconds": 343052769
    },
    {
        "id": 219,
        "name": "Codeforces Round 135 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1346081400,
        "relativeTimeSeconds": 343398369
    },
    {
        "id": 217,
        "name": "Codeforces Round 134 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1345273500,
        "relativeTimeSeconds": 344206269
    },
    {
        "id": 218,
        "name": "Codeforces Round 134 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1345273500,
        "relativeTimeSeconds": 344206269
    },
    {
        "id": 216,
        "name": "Codeforces Round 133 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1344958200,
        "relativeTimeSeconds": 344521569
    },
    {
        "id": 215,
        "name": "Codeforces Round 132 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1344267000,
        "relativeTimeSeconds": 345212769
    },
    {
        "id": 213,
        "name": "Codeforces Round 131 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1343662200,
        "relativeTimeSeconds": 345817569
    },
    {
        "id": 214,
        "name": "Codeforces Round 131 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1343662200,
        "relativeTimeSeconds": 345817569
    },
    {
        "id": 208,
        "name": "Codeforces Round 130 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7800,
        "startTimeSeconds": 1343057400,
        "relativeTimeSeconds": 346422369
    },
    {
        "id": 212,
        "name": "VK Cup 2012 Finals (unofficial online-version)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1342450800,
        "relativeTimeSeconds": 347028969
    },
    {
        "id": 211,
        "name": "VK Cup 2012 Finals",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1342335600,
        "relativeTimeSeconds": 347144169
    },
    {
        "id": 209,
        "name": "VK Cup 2012 Finals, Practice Session",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 5400,
        "startTimeSeconds": 1342252500,
        "relativeTimeSeconds": 347227269
    },
    {
        "id": 204,
        "name": "Codeforces Round 129 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1342020600,
        "relativeTimeSeconds": 347459169
    },
    {
        "id": 205,
        "name": "Codeforces Round 129 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1342020600,
        "relativeTimeSeconds": 347459169
    },
    {
        "id": 207,
        "name": "Abbyy Cup 2.0 - Final (unofficial)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1341730800,
        "relativeTimeSeconds": 347748969
    },
    {
        "id": 206,
        "name": "Abbyy Cup 2.0 - Final",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1341576900,
        "relativeTimeSeconds": 347902869
    },
    {
        "id": 203,
        "name": "Codeforces Round 128 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1341329400,
        "relativeTimeSeconds": 348150369
    },
    {
        "id": 201,
        "name": "Codeforces Round 127 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1340983800,
        "relativeTimeSeconds": 348495969
    },
    {
        "id": 202,
        "name": "Codeforces Round 127 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1340983800,
        "relativeTimeSeconds": 348495969
    },
    {
        "id": 200,
        "name": "Codeforces Round 126 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1340551800,
        "relativeTimeSeconds": 348927969
    },
    {
        "id": 198,
        "name": "Codeforces Round 125 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1340379000,
        "relativeTimeSeconds": 349100769
    },
    {
        "id": 199,
        "name": "Codeforces Round 125 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1340379000,
        "relativeTimeSeconds": 349100769
    },
    {
        "id": 196,
        "name": "Codeforces Round 124 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1339506000,
        "relativeTimeSeconds": 349973769
    },
    {
        "id": 197,
        "name": "Codeforces Round 124 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1339506000,
        "relativeTimeSeconds": 349973769
    },
    {
        "id": 195,
        "name": "Codeforces Round 123 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1339342200,
        "relativeTimeSeconds": 350137569
    },
    {
        "id": 193,
        "name": "Codeforces Round 122 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1338737400,
        "relativeTimeSeconds": 350742369
    },
    {
        "id": 194,
        "name": "Codeforces Round 122 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1338737400,
        "relativeTimeSeconds": 350742369
    },
    {
        "id": 191,
        "name": "Codeforces Round 121 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1338132600,
        "relativeTimeSeconds": 351347169
    },
    {
        "id": 192,
        "name": "Codeforces Round 121 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1338132600,
        "relativeTimeSeconds": 351347169
    },
    {
        "id": 188,
        "name": "Surprise Language Round 6",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1337959800,
        "relativeTimeSeconds": 351519969
    },
    {
        "id": 190,
        "name": "Codeforces Round 120 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1337182200,
        "relativeTimeSeconds": 352297569
    },
    {
        "id": 187,
        "name": "Codeforces Round 119 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1336663800,
        "relativeTimeSeconds": 352815969
    },
    {
        "id": 189,
        "name": "Codeforces Round 119 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1336663800,
        "relativeTimeSeconds": 352815969
    },
    {
        "id": 185,
        "name": "Codeforces Round 118 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1336145400,
        "relativeTimeSeconds": 353334369
    },
    {
        "id": 186,
        "name": "Codeforces Round 118 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1336145400,
        "relativeTimeSeconds": 353334369
    },
    {
        "id": 178,
        "name": "ABBYY Cup 2.0 - Hard",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1335614400,
        "relativeTimeSeconds": 353865369
    },
    {
        "id": 183,
        "name": "Croc Champ 2012 - Final",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1335532800,
        "relativeTimeSeconds": 353946969
    },
    {
        "id": 182,
        "name": "Codeforces Round 117 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1335280200,
        "relativeTimeSeconds": 354199569
    },
    {
        "id": 180,
        "name": "Codeforces Round 116 (Div. 2, ACM-ICPC Rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1335078000,
        "relativeTimeSeconds": 354401769
    },
    {
        "id": 177,
        "name": "ABBYY Cup 2.0 - Easy",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 14400,
        "startTimeSeconds": 1335016800,
        "relativeTimeSeconds": 354462969
    },
    {
        "id": 176,
        "name": "Croc Champ 2012 - Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1334934300,
        "relativeTimeSeconds": 354545469
    },
    {
        "id": 181,
        "name": "Croc Champ 2012 - Round 2 (Unofficial Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1334934300,
        "relativeTimeSeconds": 354545469
    },
    {
        "id": 175,
        "name": "Codeforces Round 115",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1334390400,
        "relativeTimeSeconds": 355089369
    },
    {
        "id": 164,
        "name": "VK Cup 2012 Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1333897500,
        "relativeTimeSeconds": 355582269
    },
    {
        "id": 174,
        "name": "VK Cup 2012 Round 3 (Unofficial Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1333897500,
        "relativeTimeSeconds": 355582269
    },
    {
        "id": 173,
        "name": "Croc Champ 2012 - Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1333724400,
        "relativeTimeSeconds": 355755369
    },
    {
        "id": 172,
        "name": "Croc Champ 2012 - Qualification Round",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1333440000,
        "relativeTimeSeconds": 356039769
    },
    {
        "id": 171,
        "name": "April Fools Day Contest",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1333292400,
        "relativeTimeSeconds": 356187369
    },
    {
        "id": 170,
        "name": "VK Cup 2012 Wild-card Round 2",
        "type": "IOI",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 604800,
        "startTimeSeconds": 1332954000,
        "relativeTimeSeconds": 356525769
    },
    {
        "id": 167,
        "name": "Codeforces Round 114 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1332860400,
        "relativeTimeSeconds": 356619369
    },
    {
        "id": 168,
        "name": "Codeforces Round 114 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1332860400,
        "relativeTimeSeconds": 356619369
    },
    {
        "id": 163,
        "name": "VK Cup 2012 Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1332687900,
        "relativeTimeSeconds": 356791869
    },
    {
        "id": 169,
        "name": "VK Cup 2012 Round 2 (Unofficial Div. 2 Edition)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1332687900,
        "relativeTimeSeconds": 356791869
    },
    {
        "id": 166,
        "name": "Codeforces Round 113 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1332516600,
        "relativeTimeSeconds": 356963169
    },
    {
        "id": 162,
        "name": "VK Cup 2012 Wild-card Round 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1332083400,
        "relativeTimeSeconds": 357396369
    },
    {
        "id": 165,
        "name": "Codeforces Round 112 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1331911800,
        "relativeTimeSeconds": 357567969
    },
    {
        "id": 161,
        "name": "VK Cup 2012 Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1331478300,
        "relativeTimeSeconds": 358001469
    },
    {
        "id": 159,
        "name": "VK Cup 2012 Qualification Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1331280000,
        "relativeTimeSeconds": 358199769
    },
    {
        "id": 160,
        "name": "Codeforces Round 111 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1331046000,
        "relativeTimeSeconds": 358433769
    },
    {
        "id": 158,
        "name": "VK Cup 2012 Qualification Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 86400,
        "startTimeSeconds": 1330804800,
        "relativeTimeSeconds": 358674969
    },
    {
        "id": 156,
        "name": "Codeforces Round 110 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1330536600,
        "relativeTimeSeconds": 358943169
    },
    {
        "id": 157,
        "name": "Codeforces Round 110 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1330536600,
        "relativeTimeSeconds": 358943169
    },
    {
        "id": 154,
        "name": "Codeforces Round 109 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1330095600,
        "relativeTimeSeconds": 359384169
    },
    {
        "id": 155,
        "name": "Codeforces Round 109 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1330095600,
        "relativeTimeSeconds": 359384169
    },
    {
        "id": 153,
        "name": "Surprise Language Round 5",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1329922800,
        "relativeTimeSeconds": 359556969
    },
    {
        "id": 152,
        "name": "Codeforces Round 108 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1329750000,
        "relativeTimeSeconds": 359729769
    },
    {
        "id": 150,
        "name": "Codeforces Round 107 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1329490800,
        "relativeTimeSeconds": 359988969
    },
    {
        "id": 151,
        "name": "Codeforces Round 107 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1329490800,
        "relativeTimeSeconds": 359988969
    },
    {
        "id": 149,
        "name": "Codeforces Round 106 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1328886000,
        "relativeTimeSeconds": 360593769
    },
    {
        "id": 148,
        "name": "Codeforces Round 105 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1328198400,
        "relativeTimeSeconds": 361281369
    },
    {
        "id": 145,
        "name": "Codeforces Round 104 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1327215600,
        "relativeTimeSeconds": 362264169
    },
    {
        "id": 146,
        "name": "Codeforces Round 104 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1327215600,
        "relativeTimeSeconds": 362264169
    },
    {
        "id": 144,
        "name": "Codeforces Round 103 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1326899100,
        "relativeTimeSeconds": 362580669
    },
    {
        "id": 142,
        "name": "Codeforces Round 102 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1326380700,
        "relativeTimeSeconds": 363099069
    },
    {
        "id": 143,
        "name": "Codeforces Round 102 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1326380700,
        "relativeTimeSeconds": 363099069
    },
    {
        "id": 141,
        "name": "Codeforces Round 101 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1326034800,
        "relativeTimeSeconds": 363444969
    },
    {
        "id": 140,
        "name": "Codeforces Round 100",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1325689200,
        "relativeTimeSeconds": 363790569
    },
    {
        "id": 147,
        "name": "Codeforces Testing Round 4",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 3600,
        "startTimeSeconds": 1325602800,
        "relativeTimeSeconds": 363876969
    },
    {
        "id": 138,
        "name": "Codeforces Beta Round 99 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1324728000,
        "relativeTimeSeconds": 364751769
    },
    {
        "id": 139,
        "name": "Codeforces Beta Round 99 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1324728000,
        "relativeTimeSeconds": 364751769
    },
    {
        "id": 137,
        "name": "Codeforces Beta Round 98 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1324015200,
        "relativeTimeSeconds": 365464569
    },
    {
        "id": 135,
        "name": "Codeforces Beta Round 97 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1323443100,
        "relativeTimeSeconds": 366036669
    },
    {
        "id": 136,
        "name": "Codeforces Beta Round 97 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1323443100,
        "relativeTimeSeconds": 366036669
    },
    {
        "id": 132,
        "name": "Codeforces Beta Round 96 (Div. 1)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1322924400,
        "relativeTimeSeconds": 366555369
    },
    {
        "id": 133,
        "name": "Codeforces Beta Round 96 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1322924400,
        "relativeTimeSeconds": 366555369
    },
    {
        "id": 134,
        "name": "Codeforces Testing Round 3",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 3600,
        "startTimeSeconds": 1322838000,
        "relativeTimeSeconds": 366641769
    },
    {
        "id": 131,
        "name": "Codeforces Beta Round 95 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1322233200,
        "relativeTimeSeconds": 367246569
    },
    {
        "id": 130,
        "name": "Unknown Language Round 4",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1321801200,
        "relativeTimeSeconds": 367678569
    },
    {
        "id": 128,
        "name": "Codeforces Beta Round 94 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1321337400,
        "relativeTimeSeconds": 368142369
    },
    {
        "id": 129,
        "name": "Codeforces Beta Round 94 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1321337400,
        "relativeTimeSeconds": 368142369
    },
    {
        "id": 126,
        "name": "Codeforces Beta Round 93 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1320858000,
        "relativeTimeSeconds": 368621769
    },
    {
        "id": 127,
        "name": "Codeforces Beta Round 93 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1320858000,
        "relativeTimeSeconds": 368621769
    },
    {
        "id": 123,
        "name": "Codeforces Beta Round 92 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1320333000,
        "relativeTimeSeconds": 369146769
    },
    {
        "id": 124,
        "name": "Codeforces Beta Round 92 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1320333000,
        "relativeTimeSeconds": 369146769
    },
    {
        "id": 125,
        "name": "Codeforces Testing Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1319893200,
        "relativeTimeSeconds": 369586569
    },
    {
        "id": 121,
        "name": "Codeforces Beta Round 91 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1319727600,
        "relativeTimeSeconds": 369752169
    },
    {
        "id": 122,
        "name": "Codeforces Beta Round 91 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1319727600,
        "relativeTimeSeconds": 369752169
    },
    {
        "id": 120,
        "name": "School Regional Team Contest, Saratov, 2011",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1318919400,
        "relativeTimeSeconds": 370560369
    },
    {
        "id": 119,
        "name": "Codeforces Beta Round 90",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1318604400,
        "relativeTimeSeconds": 370875369
    },
    {
        "id": 118,
        "name": "Codeforces Beta Round 89 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1317999600,
        "relativeTimeSeconds": 371480169
    },
    {
        "id": 117,
        "name": "Codeforces Beta Round 88",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1316790000,
        "relativeTimeSeconds": 372689769
    },
    {
        "id": 115,
        "name": "Codeforces Beta Round 87 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1316098800,
        "relativeTimeSeconds": 373380969
    },
    {
        "id": 116,
        "name": "Codeforces Beta Round 87 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1316098800,
        "relativeTimeSeconds": 373380969
    },
    {
        "id": 113,
        "name": "Codeforces Beta Round 86 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1315494000,
        "relativeTimeSeconds": 373985769
    },
    {
        "id": 114,
        "name": "Codeforces Beta Round 86 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1315494000,
        "relativeTimeSeconds": 373985769
    },
    {
        "id": 111,
        "name": "Codeforces Beta Round 85 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1315051200,
        "relativeTimeSeconds": 374428569
    },
    {
        "id": 112,
        "name": "Codeforces Beta Round 85 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1315051200,
        "relativeTimeSeconds": 374428569
    },
    {
        "id": 109,
        "name": "Codeforces Beta Round 84 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1314633600,
        "relativeTimeSeconds": 374846169
    },
    {
        "id": 110,
        "name": "Codeforces Beta Round 84 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1314633600,
        "relativeTimeSeconds": 374846169
    },
    {
        "id": 107,
        "name": "Codeforces Beta Round 83 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1314111600,
        "relativeTimeSeconds": 375368169
    },
    {
        "id": 108,
        "name": "Codeforces Beta Round 83 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1314111600,
        "relativeTimeSeconds": 375368169
    },
    {
        "id": 106,
        "name": "Codeforces Beta Round 82 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1313766000,
        "relativeTimeSeconds": 375713769
    },
    {
        "id": 105,
        "name": "Codeforces Beta Round 81",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1313247600,
        "relativeTimeSeconds": 376232169
    },
    {
        "id": 103,
        "name": "Codeforces Beta Round 80 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1312714800,
        "relativeTimeSeconds": 376764969
    },
    {
        "id": 104,
        "name": "Codeforces Beta Round 80 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1312714800,
        "relativeTimeSeconds": 376764969
    },
    {
        "id": 101,
        "name": "Codeforces Beta Round 79 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1312390800,
        "relativeTimeSeconds": 377088969
    },
    {
        "id": 102,
        "name": "Codeforces Beta Round 79 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1312390800,
        "relativeTimeSeconds": 377088969
    },
    {
        "id": 100,
        "name": "Unknown Language Round 3",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1312005600,
        "relativeTimeSeconds": 377474169
    },
    {
        "id": 98,
        "name": "Codeforces Beta Round 78 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1311346800,
        "relativeTimeSeconds": 378132969
    },
    {
        "id": 99,
        "name": "Codeforces Beta Round 78 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1311346800,
        "relativeTimeSeconds": 378132969
    },
    {
        "id": 97,
        "name": "Yandex.Algorithm 2011: Finals",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1310731200,
        "relativeTimeSeconds": 378748569
    },
    {
        "id": 95,
        "name": "Codeforces Beta Round 77 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1310137200,
        "relativeTimeSeconds": 379342569
    },
    {
        "id": 96,
        "name": "Codeforces Beta Round 77 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1310137200,
        "relativeTimeSeconds": 379342570
    },
    {
        "id": 93,
        "name": "Codeforces Beta Round 76 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1309446000,
        "relativeTimeSeconds": 380033769
    },
    {
        "id": 94,
        "name": "Codeforces Beta Round 76 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1309446000,
        "relativeTimeSeconds": 380033769
    },
    {
        "id": 91,
        "name": "Codeforces Beta Round 75 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1308582000,
        "relativeTimeSeconds": 380897769
    },
    {
        "id": 92,
        "name": "Codeforces Beta Round 75 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1308582000,
        "relativeTimeSeconds": 380897769
    },
    {
        "id": 89,
        "name": "Codeforces Beta Round 74 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1308236400,
        "relativeTimeSeconds": 381243369
    },
    {
        "id": 90,
        "name": "Codeforces Beta Round 74 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1308236400,
        "relativeTimeSeconds": 381243369
    },
    {
        "id": 87,
        "name": "Codeforces Beta Round 73 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1307458800,
        "relativeTimeSeconds": 382020969
    },
    {
        "id": 88,
        "name": "Codeforces Beta Round 73 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1307458800,
        "relativeTimeSeconds": 382020969
    },
    {
        "id": 86,
        "name": "Yandex.Algorithm 2011: Round 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1306077000,
        "relativeTimeSeconds": 383402769
    },
    {
        "id": 85,
        "name": "Yandex.Algorithm 2011: Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1305903600,
        "relativeTimeSeconds": 383576169
    },
    {
        "id": 83,
        "name": "Codeforces Beta Round 72 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1305299400,
        "relativeTimeSeconds": 384180369
    },
    {
        "id": 84,
        "name": "Codeforces Beta Round 72 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1305299400,
        "relativeTimeSeconds": 384180369
    },
    {
        "id": 82,
        "name": "Yandex.Algorithm 2011: Qualification 2",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1304694000,
        "relativeTimeSeconds": 384785769
    },
    {
        "id": 81,
        "name": "Yandex.Algorithm Open 2011: Qualification 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1304485200,
        "relativeTimeSeconds": 384994569
    },
    {
        "id": 79,
        "name": "Codeforces Beta Round 71",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1304175600,
        "relativeTimeSeconds": 385304169
    },
    {
        "id": 78,
        "name": "Codeforces Beta Round 70 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1303916400,
        "relativeTimeSeconds": 385563369
    },
    {
        "id": 77,
        "name": "Codeforces Beta Round 69 (Div. 1 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1303226100,
        "relativeTimeSeconds": 386253669
    },
    {
        "id": 80,
        "name": "Codeforces Beta Round 69 (Div. 2 Only)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1303226100,
        "relativeTimeSeconds": 386253669
    },
    {
        "id": 74,
        "name": "Codeforces Beta Round 68",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1302879600,
        "relativeTimeSeconds": 386600169
    },
    {
        "id": 75,
        "name": "Codeforces Beta Round 67 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1302706800,
        "relativeTimeSeconds": 386772970
    },
    {
        "id": 76,
        "name": "All-Ukrainian School Olympiad in Informatics",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1302609600,
        "relativeTimeSeconds": 386870169
    },
    {
        "id": 73,
        "name": "Codeforces Beta Round 66",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1302422400,
        "relativeTimeSeconds": 387057369
    },
    {
        "id": 71,
        "name": "Codeforces Beta Round 65 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1301410800,
        "relativeTimeSeconds": 388068969
    },
    {
        "id": 70,
        "name": "Codeforces Beta Round 64",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1301155200,
        "relativeTimeSeconds": 388324569
    },
    {
        "id": 69,
        "name": "Codeforces Beta Round 63 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1300809600,
        "relativeTimeSeconds": 388670169
    },
    {
        "id": 72,
        "name": "Unknown Language Round 2",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1300637400,
        "relativeTimeSeconds": 388842369
    },
    {
        "id": 68,
        "name": "Codeforces Beta Round 62",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1300464000,
        "relativeTimeSeconds": 389015769
    },
    {
        "id": 67,
        "name": "Manthan 2011",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1300033800,
        "relativeTimeSeconds": 389445969
    },
    {
        "id": 66,
        "name": "Codeforces Beta Round 61 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1299513600,
        "relativeTimeSeconds": 389966169
    },
    {
        "id": 65,
        "name": "Codeforces Beta Round 60",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1299340800,
        "relativeTimeSeconds": 390138969
    },
    {
        "id": 63,
        "name": "Codeforces Beta Round 59 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1298908800,
        "relativeTimeSeconds": 390570969
    },
    {
        "id": 62,
        "name": "Codeforces Beta Round 58",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1298649600,
        "relativeTimeSeconds": 390830169
    },
    {
        "id": 61,
        "name": "Codeforces Beta Round 57 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1298390400,
        "relativeTimeSeconds": 391089369
    },
    {
        "id": 64,
        "name": "Unknown Language Round 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1298304000,
        "relativeTimeSeconds": 391175769
    },
    {
        "id": 60,
        "name": "Codeforces Beta Round 56",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1298131200,
        "relativeTimeSeconds": 391348569
    },
    {
        "id": 59,
        "name": "Codeforces Beta Round 55 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1297440000,
        "relativeTimeSeconds": 392039769
    },
    {
        "id": 58,
        "name": "Codeforces Beta Round 54 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1296489600,
        "relativeTimeSeconds": 392990169
    },
    {
        "id": 57,
        "name": "Codeforces Beta Round 53",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1295971200,
        "relativeTimeSeconds": 393508569
    },
    {
        "id": 56,
        "name": "Codeforces Beta Round 52 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1295626200,
        "relativeTimeSeconds": 393853569
    },
    {
        "id": 55,
        "name": "Codeforces Beta Round 51",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1294992000,
        "relativeTimeSeconds": 394487769
    },
    {
        "id": 54,
        "name": "Codeforces Beta Round 50",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1294733700,
        "relativeTimeSeconds": 394746069
    },
    {
        "id": 53,
        "name": "Codeforces Beta Round 49 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1294329600,
        "relativeTimeSeconds": 395150169
    },
    {
        "id": 52,
        "name": "Codeforces Testing Round 1",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 3600,
        "startTimeSeconds": 1294160400,
        "relativeTimeSeconds": 395319369
    },
    {
        "id": 51,
        "name": "Codeforces Beta Round 48",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 9000,
        "startTimeSeconds": 1293552000,
        "relativeTimeSeconds": 395927769
    },
    {
        "id": 50,
        "name": "Codeforces Beta Round 47",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1292862000,
        "relativeTimeSeconds": 396617769
    },
    {
        "id": 49,
        "name": "Codeforces Beta Round 46 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1292601600,
        "relativeTimeSeconds": 396878169
    },
    {
        "id": 48,
        "name": "School Personal Contest #3 (Winter Computer School 2010/11) - Codeforces Beta Round 45 (ACM-ICPC Rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1292140800,
        "relativeTimeSeconds": 397338969
    },
    {
        "id": 47,
        "name": "Codeforces Beta Round 44 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1291737600,
        "relativeTimeSeconds": 397742169
    },
    {
        "id": 46,
        "name": "School Personal Contest #2 (Winter Computer School 2010/11) - Codeforces Beta Round 43 (ACM-ICPC Rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 10800,
        "startTimeSeconds": 1291536000,
        "relativeTimeSeconds": 397943769
    },
    {
        "id": 43,
        "name": "Codeforces Beta Round 42 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1291046400,
        "relativeTimeSeconds": 398433369
    },
    {
        "id": 42,
        "name": "Codeforces Beta Round 41",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1290096000,
        "relativeTimeSeconds": 399383769
    },
    {
        "id": 45,
        "name": "School Team Contest 3 (Winter Computer School 2010/11)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1289646000,
        "relativeTimeSeconds": 399833769
    },
    {
        "id": 41,
        "name": "Codeforces Beta Round 40 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1289232000,
        "relativeTimeSeconds": 400247769
    },
    {
        "id": 44,
        "name": "School Team Contest 2 (Winter Computer School 2010/11)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1289041200,
        "relativeTimeSeconds": 400438569
    },
    {
        "id": 40,
        "name": "Codeforces Beta Round 39",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1288972800,
        "relativeTimeSeconds": 400506969
    },
    {
        "id": 38,
        "name": "School Personal Contest #1 (Winter Computer School 2010/11) - Codeforces Beta Round 38 (ACM-ICPC Rules)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 14400,
        "startTimeSeconds": 1288440000,
        "relativeTimeSeconds": 401039769
    },
    {
        "id": 37,
        "name": "Codeforces Beta Round 37",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1288018800,
        "relativeTimeSeconds": 401460969
    },
    {
        "id": 39,
        "name": "School Team Contest 1 (Winter Computer School 2010/11)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 18000,
        "startTimeSeconds": 1287904200,
        "relativeTimeSeconds": 401575569
    },
    {
        "id": 36,
        "name": "Codeforces Beta Round 36",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1287482400,
        "relativeTimeSeconds": 401997369
    },
    {
        "id": 35,
        "name": "Codeforces Beta Round 35 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1287471600,
        "relativeTimeSeconds": 402008169
    },
    {
        "id": 34,
        "name": "Codeforces Beta Round 34 (Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1286802000,
        "relativeTimeSeconds": 402677769
    },
    {
        "id": 33,
        "name": "Codeforces Beta Round 33 (Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1286463600,
        "relativeTimeSeconds": 403016169
    },
    {
        "id": 32,
        "name": "Codeforces Beta Round 32 (Div. 2, Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1286002800,
        "relativeTimeSeconds": 403476969
    },
    {
        "id": 31,
        "name": "Codeforces Beta Round 31 (Div. 2, Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1285599600,
        "relativeTimeSeconds": 403880169
    },
    {
        "id": 30,
        "name": "Codeforces Beta Round 30 (Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1285340400,
        "relativeTimeSeconds": 404139369
    },
    {
        "id": 29,
        "name": "Codeforces Beta Round 29 (Div. 2, Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1284994800,
        "relativeTimeSeconds": 404484969
    },
    {
        "id": 28,
        "name": "Codeforces Beta Round 28 (Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1284735600,
        "relativeTimeSeconds": 404744169
    },
    {
        "id": 27,
        "name": "Codeforces Beta Round 27 (Codeforces format, Div. 2)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1284130800,
        "relativeTimeSeconds": 405348969
    },
    {
        "id": 26,
        "name": "Codeforces Beta Round 26 (Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1281970800,
        "relativeTimeSeconds": 407508969
    },
    {
        "id": 25,
        "name": "Codeforces Beta Round 25 (Div. 2 Only)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1280761200,
        "relativeTimeSeconds": 408718569
    },
    {
        "id": 24,
        "name": "Codeforces Beta Round 24",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1280149200,
        "relativeTimeSeconds": 409330569
    },
    {
        "id": 23,
        "name": "Codeforces Beta Round 23",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1278687600,
        "relativeTimeSeconds": 410792169
    },
    {
        "id": 22,
        "name": "Codeforces Beta Round 22 (Div. 2 Only)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1277823600,
        "relativeTimeSeconds": 411656169
    },
    {
        "id": 21,
        "name": "Codeforces Alpha Round 21 (Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1277730300,
        "relativeTimeSeconds": 411749469
    },
    {
        "id": 19,
        "name": "Codeforces Beta Round 19",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1277391600,
        "relativeTimeSeconds": 412088169
    },
    {
        "id": 20,
        "name": "Codeforces Alpha Round 20 (Codeforces format)",
        "type": "CF",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 5400,
        "startTimeSeconds": 1276875000,
        "relativeTimeSeconds": 412604769
    },
    {
        "id": 18,
        "name": "Codeforces Beta Round 18 (Div. 2 Only)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1276700400,
        "relativeTimeSeconds": 412779369
    },
    {
        "id": 17,
        "name": "Codeforces Beta Round 17",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1276182000,
        "relativeTimeSeconds": 413297769
    },
    {
        "id": 16,
        "name": "Codeforces Beta Round 16 (Div. 2 Only)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1275570000,
        "relativeTimeSeconds": 413909769
    },
    {
        "id": 15,
        "name": "Codeforces Beta Round 15",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 8100,
        "startTimeSeconds": 1275145200,
        "relativeTimeSeconds": 414334569
    },
    {
        "id": 14,
        "name": "Codeforces Beta Round 14 (Div. 2)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1274283000,
        "relativeTimeSeconds": 415196769
    },
    {
        "id": 13,
        "name": "Codeforces Beta Round 13",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1273154400,
        "relativeTimeSeconds": 416325369
    },
    {
        "id": 12,
        "name": "Codeforces Beta Round 12 (Div 2 Only)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1272538800,
        "relativeTimeSeconds": 416940969
    },
    {
        "id": 11,
        "name": "Codeforces Beta Round 11",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1272294000,
        "relativeTimeSeconds": 417185769
    },
    {
        "id": 10,
        "name": "Codeforces Beta Round 10",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1271346300,
        "relativeTimeSeconds": 418133469
    },
    {
        "id": 9,
        "name": "Codeforces Beta Round 9 (Div. 2 Only)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1270983600,
        "relativeTimeSeconds": 418496169
    },
    {
        "id": 8,
        "name": "Codeforces Beta Round 8",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1270741500,
        "relativeTimeSeconds": 418738269
    },
    {
        "id": 7,
        "name": "Codeforces Beta Round 7",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1270136700,
        "relativeTimeSeconds": 419343069
    },
    {
        "id": 6,
        "name": "Codeforces Beta Round 6 (Div. 2 Only)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1269673200,
        "relativeTimeSeconds": 419806569
    },
    {
        "id": 5,
        "name": "Codeforces Beta Round 5",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1269100800,
        "relativeTimeSeconds": 420378969
    },
    {
        "id": 4,
        "name": "Codeforces Beta Round 4 (Div. 2 Only)",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1268395200,
        "relativeTimeSeconds": 421084569
    },
    {
        "id": 3,
        "name": "Codeforces Beta Round 3",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1267963200,
        "relativeTimeSeconds": 421516569
    },
    {
        "id": 2,
        "name": "Codeforces Beta Round 2",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1267117200,
        "relativeTimeSeconds": 422362569
    },
    {
        "id": 1,
        "name": "Codeforces Beta Round 1",
        "type": "ICPC",
        "phase": "FINISHED",
        "frozen": false,
        "durationSeconds": 7200,
        "startTimeSeconds": 1266580800,
        "relativeTimeSeconds": 422898969
    }
];